// This file is auto-generated by @hey-api/openapi-ts

export type ObjectWithIntegerId = {
  id: number;
};

export type ObjectWithIntegerIdArray = Array<ObjectWithIntegerId>;

export type Bookmark = {
  bookmarkeeType?: string;
  bookmarkeeId?: number;
  createdAt?: string;
  id?: number;
  bookmarkee?: {
    abstract?: string;
    duration?: string;
    endScreenType?: string;
    number?: number;
    slug?: string;
    title?: string;
    isExampleLesson?: boolean;
    videoThumbUrlAltText?: string;
    updatedAt?: string;
    indexIdentifier?: string;
    videoThumbUrl?: string;
    durationSecs?: number;
    offlineEnabled?: boolean;
    brightcoveVideoId?: string;
    id?: number;
    course?: ObjectWithIntegerId;
    subchapters?: ObjectWithIntegerIdArray;
    season?: string;
    chaptersInstructors?: ObjectWithIntegerIdArray;
    instructors?: ObjectWithIntegerIdArray;
  };
};

export type Bookmarks = Array<Bookmark>;

export type CreateBookmarkAttributes = {
  bookmarkeeType: string;
  bookmarkeeId: string;
};

export type MediaItem = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId?: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid?: string;
};

export type CourseDeepInstructor = {
  bio?: string;
  courses: ObjectWithIntegerIdArray;
  headshotUrl?: string;
  headshotUrlAltText?: string | null;
  id: number;
  name: string;
};

export type CourseSubchapter = {
  chapterId: number;
  duration: number;
  endTime: number;
  id: number;
  imageUrl?: string;
  startTime: number;
  title: string;
};

export type ChapterType = "chapter" | "episode";

export const ChapterType = {
  CHAPTER: "chapter",
  EPISODE: "episode",
} as const;

export type CourseChapter = {
  abstract: string;
  availableAt?: string | null;
  brightcoveVideoId?: string;
  mediaUuid: string;
  chaptersInstructors?: ObjectWithIntegerIdArray;
  course: ObjectWithIntegerId;
  duration: string;
  durationSecs?: number;
  endScreenType?: string | null;
  id: number;
  indexIdentifier?: string;
  instructors: Array<CourseDeepInstructor>;
  isExampleLesson?: boolean;
  number: number;
  offlineEnabled?: boolean;
  season?: ObjectWithIntegerId | null;
  slug: string;
  subchapters: Array<CourseSubchapter>;
  title: string;
  type: ChapterType;
  updatedAt?: string;
  videoThumbUrl: string;
  videoThumbUrlAltText?: string | null;
  /**
   * This field is replaced by the teaser field. It will be deprecated in the near future.
   *
   */
  teaserBrightcoveVideoId?: string | null;
  teaser?: MediaItem | null;
};

export type Season = {
  id: number;
  title: string;
  teaser: string;
  isAvailable: boolean;
  chapters: ObjectWithIntegerIdArray;
};

export type Seasons = Array<Season>;

export type CourseType = "course" | "series";

export const CourseType = {
  COURSE: "course",
  SERIES: "series",
} as const;

export type CourseDeep = {
  id: number;
  uuid: string;
  aapExclusive: boolean;
  allPdfs?: Array<{
    id?: number;
    previewImage1?: string | null;
    previewImage1AltText?: string | null;
    title?: string;
    url?: string;
  }>;
  audioFriendly: string;
  availableAt: string | null;
  /**
   * This field is deprecated and will be removed in the future. Please use the `autoPlay` field instead.
   *
   * @deprecated
   */
  autoPlayBrightcoveVideoId?: number | null;
  autoPlay?: MediaItem | null;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  categories: Array<{
    camps?: ObjectWithIntegerIdArray;
    courses?: ObjectWithIntegerIdArray;
    coverImage?: string | null;
    coverImageAltText?: string | null;
    id: number;
    name: string;
    position: number;
    slug: string;
  }>;
  chapters: Array<CourseChapter>;
  chatEnabled?: boolean;
  cinematic12x5?: string;
  cinematic16x9?: string;
  cinematic12x5AltText?: string;
  cinematic16x9AltText?: string;
  classHeroIosAltText?: string;
  classSkillsAltText?: string;
  classTileImage?: string;
  classTileImageAltText?: string;
  coursesInstructors: Array<{
    course: ObjectWithIntegerId;
    courseId: number;
    id: number;
    instructor: ObjectWithIntegerId;
    instructorId: number;
    position: number;
  }>;
  engagementRank: number;
  hasRelatedInstructors?: boolean;
  headline?: string;
  headshotAltText?: string | null;
  hpFeaturedTileAltText?: string | null;
  hpTileAltText?: string | null;
  image16x9?: string;
  image16x9AltText?: string | null;
  image256x135?: string;
  image256x135AltText?: string | null;
  image2x3?: string;
  image2x3AltText?: string | null;
  image4x3?: string;
  image4x3AltText?: string | null;
  indexIdentifier?: string;
  instructorBio?: string;
  instructorName?: string;
  instructorTagline?: string | null;
  instructors: Array<CourseDeepInstructor>;
  isSingleCut?: boolean;
  isMultiInstructor: boolean;
  leftAlignedNameplate?: string;
  marketingCmColumn?: string;
  marketingOverview?: string;
  matureContent: boolean;
  merchandisingImages?: ObjectWithIntegerIdArray;
  multiInstructorName?: string | null;
  nameplate?: string;
  nameplateAltText?: string | null;
  nameplateSvgAltText?: string | null;
  numChapters: number;
  overview?: string;
  pdfs?: Array<{
    id: number;
    previewImage1?: string | null;
    previewImage1AltText?: string | null;
    title: string;
    url: string;
  }>;
  primary16x9?: string;
  primary16x9AltText?: string | null;
  primary1x1?: string;
  primary1x1AltText?: string | null;
  primary2x3?: string;
  primary2x3AltText?: string | null;
  primaryCategory?: ObjectWithIntegerId;
  productId?: number;
  releaseDescription?: string | null;
  /**
   * This field is deprecated and will be removed in the future. Please use the `sample` field instead.
   *
   * @deprecated
   */
  sampleVideoId?: string;
  sample?: MediaItem;
  seasonNote?: string | null;
  seasons: Seasons;
  secondary16x9AltText?: string | null;
  shortOverview?: string;
  skill?: string;
  slug: string;
  status: string;
  subchapters?: Array<CourseSubchapter>;
  tag: string | null;
  title: string;
  totalSeconds: number;
  type: CourseType;
  upcomingChapters?: Array<CourseChapter>;
  updatedAt?: string;
  vanityName?: string;
  welcomeStatement?: string;
  welcomeSurvey?: {
    course: ObjectWithIntegerId;
    id: number;
  };
  workbookCoverImages?: Array<string>;
  workbookCoverImagesAltTexts?: Array<string>;
  workbookDescription?: string;
};

export type Course = {
  id: number;
  uuid: string;
  aapExclusive: boolean;
  allPdfs?: ObjectWithIntegerIdArray;
  audioFriendly: string;
  availableAt: string;
  /**
   * This field is deprecated and will be removed in the future. Please use the `autoPlay` field instead.
   *
   * @deprecated
   */
  autoPlayBrightcoveVideoId?: string;
  autoPlay?: MediaItem;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  categories?: ObjectWithIntegerIdArray;
  categoryIds?: Array<string>;
  chapters?: ObjectWithIntegerIdArray;
  chatEnabled?: boolean;
  cinematic12x5?: string;
  cinematic16x9?: string;
  cinematic12x5AltText?: string;
  cinematic16x9AltText?: string;
  classHeroIosAltText?: string;
  classSkillsAltText?: string;
  classTileImage?: string;
  classTileImageAltText?: string;
  coursesInstructors?: ObjectWithIntegerIdArray;
  engagementRank?: number;
  hasRelatedInstructors?: boolean;
  headline?: string;
  headshotAltText?: string;
  hpFeaturedTileAltText?: string;
  hpTileAltText?: string;
  image16x9?: string;
  image16x9AltText?: string;
  image256x135?: string;
  image256x135AltText?: string;
  image2x3?: string;
  image2x3AltText?: string;
  image4x3?: string;
  image4x3AltText?: string;
  indexIdentifier?: string;
  instructorBio?: string;
  instructorName?: string;
  instructorTagline?: string;
  instructors?: ObjectWithIntegerIdArray;
  isSingleCut?: boolean;
  isMultiInstructor?: boolean;
  marketingCmColumn?: string;
  marketingOverview?: string;
  matureContent?: boolean;
  merchandisingImages?: ObjectWithIntegerIdArray;
  multiInstructorName?: string | null;
  nameplate?: string;
  nameplateAltText?: string;
  nameplateSvgAltText?: string;
  numChapters?: number;
  overview?: string;
  pdfs?: ObjectWithIntegerIdArray;
  primary16x9?: string;
  primary16x9AltText?: string;
  primary1x1?: string;
  primary1x1AltText?: string;
  primary2x3?: string;
  primary2x3AltText?: string;
  primaryCategory?: ObjectWithIntegerId;
  productId?: number;
  releaseDescription?: string | null;
  /**
   * This field is deprecated and will be removed in the future. Please use the `sample` field instead.
   *
   */
  sampleVideoId?: string;
  sample?: MediaItem;
  seasonNote?: string;
  seasons?: ObjectWithIntegerIdArray;
  secondary16x9AltText?: string;
  shortOverview?: string;
  showChapterNumbers?: boolean;
  skill?: string;
  slug: string;
  status: string;
  subchapters?: ObjectWithIntegerIdArray;
  tag: string | null;
  title: string;
  type: CourseType;
  totalSeconds?: number;
  updatedAt?: string;
  vanityName?: string;
  welcomeStatement?: string;
  welcomeSurvey?: ObjectWithIntegerId;
  workbookCoverImages?: Array<string>;
  workbookCoverImagesAltTexts?: Array<string>;
  workbookDescription?: string;
};

export type CoursesResult = Array<CourseDeep> | Array<Course>;

export type Instructor = {
  bio?: string;
  courses?: CoursesResult | ObjectWithIntegerIdArray;
  headshotUrl?: string;
  headshotUrlAltText?: string;
  id: number;
  name: string;
};

export type SessionFeaturedProjects = {
  id: number;
  description?: string;
  imageUrl?: string;
  imageUrlAltText?: string;
  position: number;
  mediaType?: string;
  video?: string;
};

export type Session = {
  id: number;
  fullDescription: string;
  isLive: boolean;
  isFixedEnrollment: boolean;
  launchDate: string;
  slug: string;
  title: string;
  primary2x3?: string;
  primary16x9?: string;
  secondary16x9?: string;
  outcomesTitle: string;
  color: string;
  nameplateImage: string;
  nameplateSvg: string;
  instructors: Array<Instructor>;
  campFeaturedProjects: Array<SessionFeaturedProjects>;
  trailer?: {
    brightcoveVideoId?: string;
    mediaUuid: string;
  };
};

export type SessionsResult = Array<Session>;

export type SingleSessionResult = {
  state: string;
  totalProjects: number;
  color?: string;
  equipmentDescription?: string;
  fullDescription: string;
  isLive: boolean;
  launchDate?: string;
  lastEnrollmentWindowClosedAt?: string;
  nameplateTitle: string;
  outcomesTitle?: string;
  projectsOutputDescription: string;
  slug: string;
  title: string;
  vanityName?: string;
  indexIdentifier?: string;
  headline?: string;
  supportingHeadline?: string;
  preLiveEnrollmentCount?: number;
  totalCohorts?: number;
  remainingCohortSpots?: number;
  cinematic12x5?: string;
  cinematic16x9?: string;
  nameplateImage?: string;
  nameplateSvg: string;
  primary1x1: string;
  primary2x3: string;
  primary16x9: string;
  secondary16x9?: string;
  totalDurationDays?: number;
  isFixedEnrollment: boolean;
  id: number;
  uuid: string;
  classOverviewTrailer?: {
    brightcoveVideoId?: string;
    mediaUuid: string;
    duration?: number;
    thumbUrl?: string;
    thumbUrlAltText?: string;
    id: number;
    videoSegments?: Array<string>;
  };
  trailer: {
    brightcoveVideoId?: string;
    mediaUuid: string;
    duration?: number;
    thumbUrl?: string;
    thumbUrlAltText?: string;
    id: number;
    videoSegments?: Array<string>;
  };
  primaryCategory?: {
    name: string;
    slug: string;
    id: number;
    camps?: Array<{
      id: number;
    }>;
    courses?: Array<{
      id: number;
    }>;
  };
  categories?: Array<{
    name: string;
    slug: string;
    id: number;
    camps?: Array<{
      id: number;
    }>;
    courses?: Array<{
      id: number;
    }>;
  }>;
  campModules?: Array<{
    campId: number;
    title: string;
    slug: string;
    description?: string;
    position: number;
    dueFromCampStartDays?: number;
    marketing3x2: string;
    totalVideos?: number;
    totalProjects?: number;
    id: number;
    campTasks?: Array<{
      campModuleId: number;
      taskType: string;
      title: string;
      description: string;
      dueFromCampStartDays?: number;
      position: number;
      slug: string;
      submissionMediaSupported?: Array<string>;
      durationSecs?: number;
      thumbUrl?: string;
      id: number;
    }>;
  }>;
  campProfileQuestions?: Array<{
    campId: number;
    question: string;
    questionType: string;
    position: number;
    id: number;
  }>;
  competencies?: Array<{
    campId: number;
    name: string;
    items: Array<string>;
    id: number;
  }>;
  instructors?: Array<{
    name: string;
    headshotUrl?: string;
    id: number;
  }>;
  campFeaturedProjects?: Array<SessionFeaturedProjects>;
  currentEnrollmentWindow?: {
    isOpen?: boolean;
    closesAt?: string;
  };
  instructorBio?: {
    description?: string;
    id: number;
    bio1x1?: string;
    bio16x9?: string;
    instructorPortfolioItems?: Array<{
      id: number;
      mediaType?: string;
      position: number;
      altText?: string;
      imageUrl?: string;
      instructorBio?: {
        id: number;
      };
      video?: string;
    }>;
  };
};

export type Category = {
  id: number;
  name: string;
  slug: string;
  camps: ObjectWithIntegerIdArray;
  courses: ObjectWithIntegerIdArray;
};

export type CategoriesResult = Array<Category>;

export type Chapter = {
  id: number;
  abstract: string;
  availableAt?: string;
  course: ObjectWithIntegerId | Course;
  duration: string;
  durationSecs: number;
  instructors: Array<ObjectWithIntegerId | Instructor>;
  number: number;
  slug: string;
  title: string;
  type: ChapterType;
  videoThumbUrl: string;
  videoThumbUrlAltText: string;
  /**
   * The unique identifier for the brightcove video content. In order to follow conventions,
   * this field will be deprecated in the future. Use the `teaser` nested object instead.
   *
   */
  teaserBrightcoveVideoId?: string | null;
  teaser?: {
    /**
     * The unique identifier for the brightcove video content.
     * Use this brightcove video ID to fetch metdata from Brightcove.
     * This will be deprecated in the future.
     *
     */
    brightcoveVideoId?: string;
    /**
     * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
     *
     */
    mediaUuid?: string;
  };
  /**
   * The title of the chapter, with the chapter number prepended if the course has chapter numbering enabled.
   *
   */
  displayTitle?: string;
};

export type ChapterResult = Array<Chapter>;

export type MobileContentGems = {
  courseId: number;
  id: number;
  position: number;
  imageUrl: string;
  imageUrlAltText: string;
  title: string;
};

export type ContentRowEntityType =
  | "course"
  | "course_progress"
  | "custom"
  | "lesson"
  | "playlist"
  | "session"
  | "session_progress";

export const ContentRowEntityType = {
  COURSE: "course",
  COURSE_PROGRESS: "course_progress",
  CUSTOM: "custom",
  LESSON: "lesson",
  PLAYLIST: "playlist",
  SESSION: "session",
  SESSION_PROGRESS: "session_progress",
} as const;

export type Pill = {
  text?: string;
  /**
   * See `PillKind` for a list of currently supported values.
   */
  kind?: string;
};

export type ContentRowEntityOverwrite = {
  tileImage?: {
    url?: string;
    altText?: string;
  };
  tileVideo?: {
    videoId: string;
  };
  title?: string;
  subtitle?: string;
  caption?: string;
  redirectUrl?: string;
  primaryPill?: Pill;
  secondaryPill?: Pill;
};

export type ContinueCourseEntity = {
  id: number;
  chapter: {
    id: number;
    duration: number;
    slug: string;
  };
  images: {
    cinematic12x5: string;
    cinematic12x5AltText: string;
    image16x9: string;
    image16x9AltText: string;
  };
  resumeProgress: {
    cursor: number;
    duration: number;
    progress: number;
  };
  slug: string;
  subtitle: string;
  title: string;
  type: CourseType;
  caption: string;
  /**
   * The unique identifier for the brightcove video content.
   * This field will be deprecated soon, as part of the CMS video migration project. Do not use this field. Use the `preview` field instead.
   *
   */
  videoPreview: string;
  preview?: {
    /**
     * The unique identifier for the brightcove video content.
     * Use this brightcove video ID to fetch metdata from Brightcove.
     * This will be deprecated in the future.
     *
     */
    brightcoveVideoId?: string;
    /**
     * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
     *
     */
    mediaUuid?: string;
  };
};

export type ContinueSessionEntity = {
  id: number;
  images: {
    image1x1?: string;
    image2x3?: string;
    image16x9?: string;
  };
  slug: string;
  subtitle: string;
  task: {
    id: number;
    duration?: number | null;
    slug: string;
    videoTask: boolean;
  };
  title: string;
};

export type ContentRowEntity =
  | (ContentRowEntityOverwrite & ContinueCourseEntity)
  | ContinueSessionEntity
  | ObjectWithIntegerId;

export type ContentRowItem = {
  analytics?: {
    [key: string]: string | null | number;
  };
  entityType: ContentRowEntityType;
  entity: ContentRowEntity;
};

export type ContentRowTileAttributes = {
  /**
   * See the `ContentRowUIConfigTileRatio` enum for list of values.
   */
  tileRatio?: string;
  /**
   * See the `ContentRowUIConfigTileImageMode` enum for list of values.
   */
  tileImageMode?: string;
  /**
   * See the `ContentRowUIConfigTileVideoMode` enum for list of values.
   */
  tileVideoMode?: string;
  showTileCaption?: boolean;
  showTileLogo?: boolean;
  /**
   * See the `ContentRowUIConfigShowTileVideoOn` enum for list of values.
   */
  showTileVideoOn?: string;
  showTileVideoCaptions?: boolean;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  tileBackgroundColor?: string;
  /**
   * See the `ContentRowUiConfigTileTextPlacement` enum for list of values.
   */
  tileTextPlacement?: string;
  /**
   * See the `ContentRowUiConfigTileClickTarget` enum for list of values.
   */
  tileClickTarget?: string;
};

export type ContentRowTitleAttributes = {
  htmlId?: string;
  cta?: Array<{
    label: string;
    url: string;
  }>;
  title?: string;
  description?: string;
  titleImage?: {
    url: string;
    altText?: string;
  };
};

export type ContentRowCarouselAttributes = {
  lazyLoad?: boolean;
  visibleTileCount?: number;
  visibleTileCountResponsive?: {
    [key: string]: number;
  };
  scrollTileCount?: number;
  autoScroll?: boolean;
  autoScrollPeriodInSec?: number;
  scrollLoop?: boolean;
  mutedTitle?: boolean;
};

export type ContentRowGridAttributes = {
  rowTileCount?: number;
  rowTileCountResponsive?: {
    [key: string]: number;
  };
};

export type ContentRowUiConfigAttributes = ContentRowTileAttributes &
  ContentRowTitleAttributes & {
    carousel?: ContentRowCarouselAttributes;
    grid?: ContentRowGridAttributes;
  };

export type ContentRowUiConfig = {
  /**
   * See the `ContentRowUIConfigType` enum for list of values.
   */
  type: string;
  attributes?: ContentRowUiConfigAttributes;
};

export type ContentRow = {
  id: number;
  apiType: string;
  slug: string;
  content?: Array<ContentRowItem>;
  analytics: {
    [key: string]: unknown;
  };
  refreshNeeded: boolean;
  uiConfig: ContentRowUiConfig;
  dynamicContent: boolean;
  conditions?: {
    experiments?: {
      [key: string]: unknown;
    };
  };
  items?: Array<ContentRowItem>;
};

export type ContentRows = Array<ContentRow>;

export type ConversationMessageKnowledge = {
  id: number;
  messageId: number;
  distance: number;
  ragJson?: {
    contentId?: number;
    classFormat?: string;
    classId?: number;
    distance?: number;
    startSecs?: number;
    endSecs?: number;
    category?: string;
    instructors?: string;
    courseTitle?: string;
    chapterTitle?: string;
    thumbUrl?: string;
    courseUrl?: string;
    chapterUrl?: string;
    text?: string;
  };
};

export type ConversationMessage = {
  id: number;
  conversationId: number;
  chapterId?: number;
  replyId?: number;
  source?: "user" | "assistant";
  content: string;
  rating?: "thumbsup" | "thumbsdown" | null;
  toxic?: boolean;
  createdAt?: string;
  knowledge?: Array<ConversationMessageKnowledge>;
};

export type Conversation = {
  id: number;
  courseId?: number;
  visitSessionId?: string;
  messages?: Array<ConversationMessage>;
  color?: string;
};

export type Conversations = Array<Conversation>;

export type ConversationMessageAttributes = {
  content: string;
  source?: "user" | "assistant";
  chapterId?: number;
  visitSessionId?: string;
};

export type ConversationAttributes = {
  courseId?: number;
  visitSessionId: string;
  messagesAttributes?: Array<ConversationMessageAttributes>;
  color?: string;
};

export type ConversationIntroduction = {
  introduction?: string;
  suggestions?: Array<string>;
};

export type ConversationMessages = Array<ConversationMessage>;

export type ConversationMessageUpdateAttributes = {
  rating?: string | null;
};

export type EmailConfirmationAction =
  | "cc_renew"
  | "delink"
  | "email_update"
  | "password_update"
  | "verify_email"
  | "email_correction";

export const EmailConfirmationAction = {
  CC_RENEW: "cc_renew",
  DELINK: "delink",
  EMAIL_UPDATE: "email_update",
  PASSWORD_UPDATE: "password_update",
  VERIFY_EMAIL: "verify_email",
  EMAIL_CORRECTION: "email_correction",
} as const;

export type EmailConfirmationAttributes = {
  type: EmailConfirmationAction;
};

export type EmailConfirmationStatus =
  | "confirmed"
  | "new_confirmation_required"
  | "pending_confirmation";

export const EmailConfirmationStatus = {
  CONFIRMED: "confirmed",
  NEW_CONFIRMATION_REQUIRED: "new_confirmation_required",
  PENDING_CONFIRMATION: "pending_confirmation",
} as const;

export type EmailConfirmation = {
  action: EmailConfirmationAction;
  status: EmailConfirmationStatus;
  /**
   * The email address to confirm.
   */
  unconfirmedEmail?: string;
};

export type EnterpriseSubscription = {
  id: number;
  organizationId: number;
  quantity: number;
  expiresAt: string;
  status: string;
  originatorType: string;
  originatorId: number;
  createdAt: string;
  updatedAt: string;
  requireConsent: boolean;
  terminatedAt?: string;
  cancellationScheduledAt?: string;
  canceledAt?: string;
  analyticsEnabled: boolean;
  enterpriseExperience: boolean;
  bulkSeatInviteSentAt?: string;
  marketingEmailsEnabled?: boolean;
  customInviteBody?: string;
  teamId: number;
  contractEffectiveDate?: string;
  teamName: string;
  infoSeats?: {
    total: number;
    available: number;
    active: number;
    pending: number;
  };
};

export type EnterpriseSubscriptions = Array<EnterpriseSubscription>;

export type EnterpriseNotification = {
  id: number;
  category: string;
  content: string;
  createdAt: string;
  licenseId: number;
  organizationId: number;
  status: string;
  teamId: number;
  title: string;
  userId: number;
};

export type EnterpriseNotifications = Array<EnterpriseNotification>;

export type TeamScheduledInvitation = {
  id: number;
  sendNow: boolean;
  sendInviteAt: string;
  status: string;
  membersInvited: number;
};

export type TeamCreateAttributes = {
  name: string;
  organizationId: number;
  parentTeamId: number;
};

export type TeamAdmin = {
  id: number;
  userId: number;
  teamId: number;
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  noEmailUser: boolean;
  username?: string;
};

export type TeamChild = {
  id: number;
  name: string;
  createdAt: string;
  depth: number;
  ownsLicense?: boolean;
  requireConsent?: boolean;
  parentTeamId: number;
  analyticsEnabled: boolean;
  lastUpdatedAt: string;
  licenseId?: number;
  membersCount: number;
  seatsCount?: number;
  seatsPending?: number;
  seatsRemaining?: number;
  children?: Array<TeamChild>;
  userRoles: Array<string>;
};

export type TeamMember = {
  id: number;
  userId: number;
  role: string;
  firstName: string;
  lastName: string;
  licenseTeam?: string;
  email: string;
  status: string;
  emailSentAt: string;
  createdAt: string;
  noEmailUser: boolean;
  username?: string;
};

export type TeamLicense = {
  id: number;
  organizationId: number;
  quantity: number;
  expiresAt: string;
  status: string;
  bulkSeatInviteSentAt: string;
  infoSeats: {
    total: number;
    available: number;
    active: number;
    pending: number;
  };
  selfServeEligible?: boolean;
  seatPrice?: number;
};

export type Team = {
  id: number;
  parentTeamId: number;
  organizationId: number;
  name: string;
  analyticsEnabled: boolean;
  lastUpdatedAt: string;
  membersCount: number;
  admins?: Array<TeamAdmin>;
  children?: Array<TeamChild>;
  members?: Array<TeamMember>;
  redeemed?: Array<TeamMember>;
  unassigned?: Array<TeamMember>;
  unredeemed?: Array<TeamMember>;
  licenses?: Array<TeamLicense>;
  teamHierarchy?: Array<TeamChild>;
  userRoles: Array<string>;
  pagination?: {
    /**
     * specify limit of how many items to return per request
     */
    limit?: number;
    /**
     * specify current pointer of how many items to return per request
     */
    offset?: number;
    /**
     * specify total count of items for the filter
     */
    count?: number;
  };
  pendingSeatsCount: number;
  redeemedSeatsCount: number;
};

export type TeamScheduledInvitations = Array<TeamScheduledInvitation>;

export type TeamNotification = {
  id?: number;
  title?: string | null;
  message: string;
  startsAt: string;
  endsAt: string;
  teamId: number;
};

export type Organization = {
  id: number;
  name: string;
  businessName: string;
  messaging?: TeamNotification | null;
  logoUrl: string | null;
  createdAt: string;
  primaryTeamId: number | null;
  primaryTeamName?: string;
  teamHierarchy?: Array<TeamChild>;
  requireConsent?: boolean;
  contentAssignments: boolean;
};

export type MemberNotification = {
  id: number;
  title?: string | null;
  message: string;
};

export type Video = {
  id: number;
  duration: number;
  brightcoveVideoId?: string;
  mediaUuid: string;
  thumbUrl?: string;
  thumbUrlAltText?: string;
};

export type Episode = {
  id: number;
  slug: string;
  title: string;
  description: string;
  number: number;
  duration?: string;
  video?: Video;
};

export type Episodes = Array<Episode>;

export type Experiment = {
  name?: string;
  value?: string;
  id?: string;
};

export type Experiments = Array<Experiment>;

export type FeatureInteraction = {
  id: number;
  interactionCount: number;
  name: string;
  user: ObjectWithIntegerId;
};

export type FeatureInteractionsResult = Array<FeatureInteraction>;

export type FeatureInteractionAttributes = {
  interactionCount: number;
  name: string;
};

export type FreeTrial = {
  eligible: boolean;
  advocate: {
    id: string;
    name?: string;
    email: string;
    profileImg?: string;
  } | null;
  durationDays?: number;
  termsLink: string;
  partnership?: string;
  isPartnershipTrial?: boolean;
  isGuestPass?: boolean;
  freeTrialType?: string;
  partnerInfo?: {
    displayName?: string;
  };
  source?: {
    name?: string;
    sharedContent?: {
      contentType?: string;
      contentId?: number;
    };
    promoCode?: string;
  };
  id: string;
};

export type GuestPassShareAttributes = {
  data: {
    attributes?: {
      emails?: Array<string>;
    };
  };
};

export type ImmersiveHero = {
  id: number;
  slug: string;
  courseId: number;
  chapterId?: number | null;
  course: {
    id: number;
    slug: string;
    type: "series" | "course";
    title: string;
    welcomeStatement: string;
    instructorName: string;
    cinematic12X5: string;
    marketingCmColumn?: string;
    nameplate: string;
    nameplateAltText?: string;
    headline: string;
    releaseDescription?: string;
    chapters: ObjectWithIntegerIdArray;
  };
  chapter: {
    id: number;
    slug: string;
    type: "chapter" | "episode";
    title: string;
    availableAt?: string;
    number: number;
  };
  resumeChapter?: {
    slug: string;
  };
  title: string;
  video: {
    id: number;
    brightcoveVideoId: number;
  };
  membersOnly: boolean;
};

export type ImmersiveHeros = Array<ImmersiveHero>;

export type Note = {
  chapter: ObjectWithIntegerId;
  course: ObjectWithIntegerId;
  content: string;
  id: number;
};

export type NoteDeep = {
  chapter: {
    id: number;
    slug: string;
    course: ObjectWithIntegerId;
    instructors: ObjectWithIntegerIdArray;
    subchapters: ObjectWithIntegerIdArray;
    type: ChapterType;
    title: string;
    number: number;
  };
  course: ObjectWithIntegerId;
  content: string;
  id: number;
};

export type Notes = Array<Note> | Array<NoteDeep>;

export type CreateNoteAttributes = {
  chapterId: number;
  content: string;
};

export type PlaylistTrack = {
  id: number;
  slug: string;
  name: string;
  uuid?: string;
  position?: number;
};

export type Playlist = {
  id: number;
  slug: string;
  uuid: string;
  name: string;
  description: string;
  status: string;
  duration: number;
  updatedAt: string;
  playlistTwoByThreeAltText?: string;
  playlistPosterImageAltText?: string;
  indexIdentifier?: string;
  playlistTwoByThree: string;
  playlistPosterImage?: string;
  themes: Array<ObjectWithIntegerId>;
  instructors: Array<ObjectWithIntegerId | Instructor>;
  tracks: Array<ObjectWithIntegerId | PlaylistTrack>;
};

export type Playlists = Array<Playlist>;

export type Category2 =
  | "coupon_code"
  | "gift_code"
  | "referral_code"
  | "value_coupon"
  | "promo_code"
  | "gifting_activation"
  | "corporate_discount_code"
  | "bulk_order_coupon"
  | "renewal_coupon"
  | "internal";

export const Category2 = {
  COUPON_CODE: "coupon_code",
  GIFT_CODE: "gift_code",
  REFERRAL_CODE: "referral_code",
  VALUE_COUPON: "value_coupon",
  PROMO_CODE: "promo_code",
  GIFTING_ACTIVATION: "gifting_activation",
  CORPORATE_DISCOUNT_CODE: "corporate_discount_code",
  BULK_ORDER_COUPON: "bulk_order_coupon",
  RENEWAL_COUPON: "renewal_coupon",
  INTERNAL: "internal",
} as const;

export type DiscountType = "amount_off" | "percentage_off";

export const DiscountType = {
  AMOUNT_OFF: "amount_off",
  PERCENTAGE_OFF: "percentage_off",
} as const;

export type Coupon = {
  id: number;
  code: string;
  category: Category2;
  currency?: string;
  discountType: DiscountType;
  maxRedemptions?: number;
  percentage?: number;
  redemptions?: number;
  requiredLogin?: boolean;
};

export type Product = {
  id: number;
  currency?: string;
  price?: string;
  assetSlug: string;
  pricing: {
    applyTax?: boolean;
    basePrice?: number;
    countryCode?: string;
    currency?: string;
    currencySymbol?: string;
    price?: number;
    taxAmount?: number;
    taxInclusive?: boolean;
  };
  basePrice?: number;
  taxAmount?: number;
  taxInclusive?: boolean;
  applyTax?: boolean;
  currencySymbol?: string;
  pricingMarketingText?: string;
  pricingMarketingText2?: string;
  vanityPrice?: number;
  productLtv?: {
    gift?: number;
    regular?: number;
  };
  productLtvInUsd?: number;
  monetizedFlatRate?: number;
  monetizedFlatRateTotal?: number;
  unmonetizedFlatRateTotal?: number;
  monetizedYearPricePerMonth: string;
  monetizedYearPricePerMonthDiscounted?: string | null;
  singleClassPaintedDifferenceWithStandard?: string | null;
  flatRate: number;
  coupon?: Coupon;
};

export type Products = Array<Product>;

export type Feature = {
  name: string;
  value: boolean | number | null;
  displayName?: string | null;
};

export type Entitlement = {
  id: number;
  name: string;
  benefits: Array<Feature>;
  mobileDisplayName?: string | null;
  appleProductId?: string | null;
  googleProductId?: string | null;
  hierarchy?: number | null;
  alternateGoogleProductIds?: Array<string>;
};

export type MemberOrganization = {
  id: number;
  name?: string;
  businessName?: string;
  primaryTeamId: number;
  logoUrl?: string;
};

export type User = {
  activeAnnualPass?: boolean;
  availableAuthTypes: Array<{
    lastLoginAt?: string;
    type?: string;
  }>;
  bogoEligible: boolean;
  bogoGiftExpiration?: string | null;
  bogoGiftExpirationRaw?: string | null;
  bogoGiftToken?: string | null;
  canUpgrade: boolean;
  currentAuthType?: string;
  email: string;
  emailToken: string;
  entitlement?: Entitlement | ObjectWithIntegerId;
  enrolledCourses: Array<string>;
  enterpriseSeatToken?: {
    id: number;
  };
  firstName?: string | null;
  gdprOptIn: boolean;
  id: number;
  lastName?: string | null;
  locale?: string | null;
  matureContentEnabled: boolean | null;
  profileId: number;
  profilePhotoUrl?: string | null;
  slug: string;
  subtitleEnabled: boolean;
  subtitleLocale?: string | null;
  organizationsAdministered?: Array<number>;
  organizationsMembered?: Array<MemberOrganization>;
  username?: string | null;
  noEmailUser: boolean;
  needsSetup?: boolean;
  hasHadSubscriptions?: boolean;
  hasCreditCard?: boolean;
  braintreePaypalEmailOfLatestSub?: string;
  hasBraintreeCcSub?: boolean;
  sponsoredSubscriptionInfo?: {
    [key: string]: unknown;
  };
  hasActiveAfterpaySubscription?: boolean;
  hasOnCallAccess?: boolean;
};

export type Profile = {
  city?: string;
  country?: string;
  displayName: string;
  id: number;
  location?: string;
  matureContentEnabled?: boolean;
  onboardedAt?: string;
  personalUrl?: string;
  personalUrlType?: string;
  profession?: string;
  profileImage?: string;
  skills: Array<ObjectWithIntegerId>;
  slug: string;
  tagline?: string;
  user: ObjectWithIntegerId | User;
  uuid: string;
  defaultProfile: boolean;
  careerGoal?: string;
};

export type Profiles = Array<Profile>;

export type ProfileCreateAttributes = {
  avatarColor: string;
  city?: string;
  country?: string;
  displayName: string;
  firstName?: string;
  lastName?: string;
  location?: string;
  matureContentEnabled?: boolean;
  personalUrl?: string;
  personalUrlType?: string;
  profession?: string;
  profileImage?: string;
  profilePhotoUrl?: string;
  skills?: Array<ObjectWithIntegerId>;
  tagline?: string;
};

export type ProfileUpdateAttributes = {
  avatarColor?: string;
  city?: string;
  country?: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  location?: string;
  matureContentEnabled?: boolean;
  onboarded?: string;
  personalUrl?: string;
  personalUrlType?: string;
  profession?: string;
  profileImage?: string;
  profilePhotoUrl?: string;
  skills?: Array<ObjectWithIntegerId>;
  tagline?: string;
};

export type OnboardingContentType = "Course" | "Camp";

export const OnboardingContentType = {
  COURSE: "Course",
  CAMP: "Camp",
} as const;

export type OnboardingCategory = {
  id?: number;
  name: string;
  isPrimary?: boolean;
};

export type OnboardingContent = {
  contentId: number;
  contentType: OnboardingContentType;
  contentSlug: string;
  headline: string;
  supportingHeadline: string;
  image: string;
  position: number;
  instructor: Instructor;
  categories: Array<OnboardingCategory>;
};

export type OnboardingContentRecommendation = Array<OnboardingContent>;

export type PurchasePlan = {
  id: number;
  billingCyclePeriod: number;
  slug: string;
  mobileDisplayName: string;
  isAnnualPass: boolean;
  isMonthlyPass: boolean;
  isInstallments: boolean;
  product?: ObjectWithIntegerId | Product;
};

export type ReferralAudioProgram = {
  id: number;
  name: string;
};

export type ReferralAudioProgramsResult = Array<ReferralAudioProgram>;

export type ReferralTokenAttributes = {
  courseId?: string;
  recipeId?: string;
  source:
    | "guest_pass_advocate"
    | "class"
    | "recipes"
    | "pre_onboarding"
    | "articles"
    | "catalog"
    | "class_guest"
    | "class_guest_next"
    | "class_locked"
    | "lesson"
    | "lesson_tile"
    | "lesson_video"
    | "lesson_page_logged_out"
    | "single_class_gift"
    | "homepage_class_samples"
    | "homepage_featured_instructor"
    | "homepage_featured_instructor_next"
    | "immersive_hero";
};

export type ShareLinks = {
  id: string;
  token?: string;
  invitationLinks: Array<{
    content:
      | "Facebook"
      | "Linkedin"
      | "Twitter"
      | "Copy"
      | "Messenger"
      | "Email"
      | "More"
      | "Message";
    url: string;
    id: number;
  }>;
};

export type Showcase = {
  id: number;
  backgroundImageUrl: string;
  caption?: string;
  course?: Course | ObjectWithIntegerId;
  session?: Session | ObjectWithIntegerId;
  ctaText?: string;
  gradient?: boolean;
  pillText?: string;
  pillType?: string;
  position: number;
  redirectUrl: string;
  subtitle?: string;
  tileType: number;
  title: string;
  updatedAt: string;
};

export type ShowcasesResult = Array<Showcase>;

export type Skill = {
  id: number;
  parentId: number | null;
  slug: string;
  name: string;
  uuid: string;
};

export type SkillsResult = Array<Skill>;

export type Subscription = {
  expiresAt?: string;
  cancelAtPeriodEnd?: boolean;
  id: number;
  providerType?: string;
  status?: string;
  startsAt?: string;
  renewalPurchasePlanId?: number;
  changeType?: string;
  "sponsored?": boolean;
  remainingDays: string;
  active: boolean;
  purchasePlan: PurchasePlan | ObjectWithIntegerId;
  renewalPurchasePlan?: PurchasePlan | ObjectWithIntegerId;
  entitlement?: Entitlement | ObjectWithIntegerId;
  sponsorName?: string;
};

export type ThemesResults = Array<{
  id: number;
  name: string;
  status: string;
  updatedAt: string;
  description?: string;
  playlists: Array<Playlist>;
}>;

export type TierHierarchy = 0 | 1 | 2 | 3;

export const TierHierarchy = {
  INDIVIDUAL: 0,
  DUO: 1,
  FAMILY: 2,
  FAMILY_PLUS: 3,
} as const;

export type PricingPlan = {
  id: number;
  name: string;
  paymentGatewayType: string;
  paymentGatewaySkuId: string;
};

export type TierBenefit = {
  name:
    | "concurrent_devices"
    | "offline_download"
    | "unlimit_mastercamp_access"
    | "multiple_profiles"
    | "optional_mature_content_exclusions"
    | "persona_in_tiers";
  value: string | number | boolean;
  displayName: string;
};

export type TierEntitlement = {
  id: number;
  name: string;
  benefits: Array<TierBenefit>;
};

export type Tier = {
  id: number;
  displayName: string;
  hierarchy: TierHierarchy;
  isUserCurrentTier: boolean;
  bestValue?: boolean;
  mostPopular?: boolean;
  internalName?: string;
  currencySymbol?: string;
  displayMonthlyPrice?: string;
  displayMonthlyPriceWithDiscount?: string;
  product: Product;
  pricingPlan?: PricingPlan;
  entitlement?: TierEntitlement;
  /**
   * prcng-4V1 experiment attribute
   */
  basicPlanIdentifier?: string;
  /**
   * prcng-52V1 experiment attribute
   */
  premiumPlusPlanIdentifier?: string;
  /**
   * prcng-52V1 experiment attribute
   */
  monetizedPremiumFamilyPriceDifference?: string;
};

export type TierCollection = {
  id: number;
  pricingTiers: Array<Tier>;
};

export type PartnershipData = {
  partnerName: string;
  partnerImage?: string;
  partnerUrl?: string;
  partnerDisplayName: string;
  partnerPaymentGateway: string;
  sku: string;
  resellerSkuDisplayName: string;
  skuSlug: string;
};

export type CartData = {
  email?: string;
  enterpriseAdmin?: boolean;
  enterpriseBusinessUser?: boolean;
  updatedFromSap?: boolean;
  userState?: string;
  connectedToFacebook?: boolean;
  needConfirmResidence?: boolean;
  projectPlusOneOfferEligible?: boolean;
  trialDay?: number | null;
  trialDaysLeft?: number | null;
  id?: number;
  subscription?: {
    status?: string;
    providerType?: string;
    canceledAt?: string | null;
    createdAt?: string;
    remainingSubscriptionDays?: number;
    cancelAtPeriodEnd?: boolean;
    paymentGatewayUserProduct?: {
      [key: string]: unknown;
    } | null;
    expirationDate?: string;
    originatorType?: string;
    canceledOnPaypalDashboard?: boolean | null;
    purchaseCountry?: string;
    accessType?: string;
    currentSubscriptionCycle?: number;
    canUpgradeToConsumer?: boolean;
    trialStartsAt?: string | null;
    trialEndsAt?: string | null;
    id?: number;
    isMonthlyPass?: boolean;
  };
  addOnSubscriptions?: Array<{
    id?: number;
    status?: string;
    productId?: number;
    pricingPlanId?: number;
    pricingPlanProductId?: number;
    subscriptionId?: number;
    canceledAt?: string | null;
    createdAt?: string;
    cancelAtPeriodEnd?: boolean;
    accessType?: string;
    currentSubscriptionCycle?: number;
  }>;
  partnershipsData?: PartnershipData;
};

export type GuestPass = {
  available?: boolean;
  remaining?: number;
  guestPassTotalDays?: number;
  expirationDate?: string;
  id?: string;
};

export type StreamAttributes = {
  uuid: string;
  assetType: string;
  videoId: string | number;
};

export type Stream = {
  uuid: string;
  timestamp: string;
  videoId: string;
};

export type StreamsResult = {
  active: number;
  authorized: boolean;
  interval: number;
  limit: number;
  streams?: Array<Stream>;
};

export type UserSession = {
  id: number;
  campId: number;
};

export type UserSessionsResult = Array<UserSession>;

export type UserCourse = {
  completedAt?: string;
  course?: ObjectWithIntegerId;
  courseId: number;
  courseImpactChapter?: number;
  hasNotes?: boolean;
  id: number;
  npsChapter?: number;
  npsDismissed?: string;
  originatorType: string;
  profile?: ObjectWithIntegerId;
  profileId?: number;
  profileUuid?: string;
  progressEntries?: ObjectWithIntegerId;
  resumeChapter?: ObjectWithIntegerId;
  resumeChapterId: number;
  resumeChapterProgress?: {
    chapterId?: number;
    createdAt?: string;
    cursor?: number;
    deletedAt?: string;
    duration?: number;
    id?: number;
    progress?: number;
    updatedAt?: string;
    userCourseId?: number;
  };
  updatedAt: string;
  user?: ObjectWithIntegerId;
  userId: number;
};

export type UserCourseDeep = {
  completedAt?: string;
  course?: {
    aapExclusive?: boolean;
    allPdfs?: ObjectWithIntegerIdArray;
    audioFriendly?: string;
    availableAt?: string;
    brightcoveVideoId?: string;
    categories?: ObjectWithIntegerIdArray;
    chapters?: ObjectWithIntegerIdArray;
    cinematic12x5?: string;
    cinematic12x5AltText?: string;
    cinematic16x9AltText?: string;
    classHeroIosAltText?: string;
    classSkillsAltText?: string;
    classTileImage?: string;
    classTileImageAltText?: string;
    coursesInstructors?: ObjectWithIntegerIdArray;
    engagementRank?: number;
    hasRelatedInstructors?: boolean;
    headline?: string;
    headshotAltText?: string;
    hpFeaturedTileAltText?: string;
    hpTileAltText?: string;
    id: number;
    image16x9?: string;
    image16x9AltText?: string;
    image256x135?: string;
    image256x135AltText?: string;
    image2x3?: string;
    image2x3AltText?: string;
    image4x3?: string;
    image4x3AltText?: string;
    indexIdentifier?: string;
    instructorBio?: string;
    instructorName?: string;
    instructors?: Array<{
      bio?: string;
      courses?: ObjectWithIntegerIdArray;
      headshotUrl?: string;
      headshotUrlAltText?: string;
      id?: number;
      name?: string;
    }>;
    isMultiInstructor?: boolean;
    marketingCmColumn?: string;
    marketingOverview?: string;
    matureContent?: boolean;
    merchandisingImages?: ObjectWithIntegerIdArray;
    multiInstructorName?: string | null;
    nameplate?: string;
    nameplateAltText?: string;
    nameplateSvgAltText?: string;
    numChapters?: number;
    overview?: string;
    pdfs?: ObjectWithIntegerIdArray;
    primary16x9?: string;
    primary16x9AltText?: string;
    primary1x1?: string;
    primary1x1AltText?: string;
    primary2x3?: string;
    primary2x3AltText?: string;
    primaryCategory?: ObjectWithIntegerId;
    productId?: number;
    /**
     * This field is deprecated and will be removed in the future. Please use the `sample` field instead.
     *
     */
    sampleVideoId?: string;
    sample?: MediaItem;
    seasonNote?: string;
    seasons?: ObjectWithIntegerIdArray;
    secondary16x9AltText?: string;
    shortOverview?: string;
    skill?: string;
    slug?: string;
    status?: string;
    title?: string;
    totalSeconds?: number;
    type: CourseType;
    updatedAt?: string;
    uuid: string;
    vanityName?: string;
    welcomeStatement?: string;
    welcomeSurvey?: ObjectWithIntegerId;
    workbookCoverImages?: Array<string>;
    workbookCoverImagesAltTexts?: Array<string>;
    workbookDescription?: string;
  };
  courseId: number;
  courseImpactChapter?: number;
  hasNotes?: boolean;
  id: number;
  npsChapter?: number;
  npsDismissed?: string;
  originatorType: string;
  profile?: ObjectWithIntegerId;
  profileId?: number;
  profileUuid?: string;
  progressEntries?: Array<{
    chapter?: ObjectWithIntegerId;
    chapterId?: number;
    completed?: boolean;
    cursor?: number;
    duration?: number;
    durationSecs?: number;
    id?: number;
    progress?: number;
    updatedAt?: string;
    userCourse?: ObjectWithIntegerId;
    userCourseId?: number;
  }>;
  resumeChapter?: {
    abstract?: string;
    brightcoveVideoId?: string;
    chaptersInstructors?: ObjectWithIntegerIdArray;
    course?: ObjectWithIntegerId;
    duration?: string;
    durationSecs?: number;
    endScreenType?: string;
    id: number;
    indexIdentifier?: string;
    instructors?: ObjectWithIntegerIdArray;
    isExampleLesson?: boolean;
    number: number;
    offlineEnabled?: boolean;
    season?: string;
    slug: string;
    subchapters?: ObjectWithIntegerIdArray;
    title: string;
    type: "episode" | "chapter";
    updatedAt?: string;
    uuid?: string;
    videoThumbUrl?: string;
    videoThumbUrlAltText?: string;
  };
  resumeChapterId: number;
  resumeChapterProgress?: {
    chapterId?: number;
    createdAt?: string;
    cursor?: number;
    deletedAt?: string;
    duration?: number;
    id?: number;
    progress?: number;
    updatedAt?: string;
    userCourseId?: number;
  };
  updatedAt: string;
  user?: ObjectWithIntegerId;
  userId: number;
};

export type UserCoursesResult = Array<UserCourse | UserCourseDeep>;

export type CreateUserCourseAttributes = {
  courseId: number;
};

export type UserProgress = {
  indexIdentifier: string;
  contentType: string;
  contentId: number;
  contentUuid: string;
  cursorPercentage: number;
  isRecentlyPlayed: boolean;
  isCompleted: boolean;
  redirectPath: string;
};

export type UserProgressResults = Array<UserProgress>;

export type UserPlaylistResults = Array<{
  percentCompleted: number;
  completed: boolean;
  updatedAt: string;
  playlist?: Playlist;
}>;

export type UserAttributesForUpdate = {
  email?: string;
  oldPassword?: string;
  password?: string;
  passwordConfirmation?: string;
  matureContentEnabled?: boolean;
  locale?: "en-US" | "en-GB";
  subtitleEnabled?: boolean;
  subtitleLocale?: "en-US" | "en-GB";
};

export type VideoProgressEntry = {
  id: number;
  completed: boolean;
  cursor: number;
  duration: number;
  progress: number;
  updatedAt: string;
  videoId: number;
  video: ObjectWithIntegerId;
};

export type VideoProgressEntriesResult = Array<VideoProgressEntry>;

export type VideoProgressEntryAttributesForCreate = {
  videoId: number;
  duration: number;
  cursor?: number;
  progress?: number;
};

export type VideoProgressEntryAttributesForUpdate = {
  videoId?: number;
  duration?: number;
  cursor?: number;
  progress?: number;
};

export type WatchListListableType = "Course" | "Camp";

export const WatchListListableType = {
  COURSE: "Course",
  CAMP: "Camp",
} as const;

export type WatchListItemCourse = {
  uuid: string;
  id: number;
  indexIdentifier?: string;
  title?: string;
  slug?: string;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  audioFriendly: string;
  headline?: string;
  classTileImage?: string;
  primary1x1?: string;
  primary2x3?: string;
  cinematic12x5?: string;
  nameplate?: string;
  instructorName?: string;
  welcomeStatement?: string;
  skill?: string;
  image2x3?: string;
  image16x9?: string;
  image256x135?: string;
  status: string;
  vanityName?: string;
  aapExclusive: boolean;
  availableAt?: string;
  instructorBio?: string;
  matureContent: boolean;
  engagementRank: number;
  overview?: string;
  shortOverview?: string;
  merchandisingImages?: Array<string>;
  workbookCoverImages?: unknown[];
  workbookDescription?: string;
};

export type WatchListItemChapter = {
  uuid: string;
  id: number;
  indexIdentifier?: string;
  abstract?: string;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  duration?: string;
  endScreenType?: string;
  number?: number;
  slug?: string;
  title?: string;
  isExampleLesson: boolean;
  videoThumbUrl?: string;
  durationSecs?: number;
  offlineEnabled: boolean;
};

export type WatchListItem = {
  id: number;
  listableType: WatchListListableType;
  listableId: number;
  user?: ObjectWithIntegerId;
  listable?: WatchListItemCourse | WatchListItemChapter;
};

export type WatchListResults = Array<WatchListItem>;

export type WatchListItemAttributes = {
  listableId: number;
  listableType: WatchListListableType;
};

export type LandingPrice = {
  id: string;
  billingCycle: string;
  monetizedPrice: string;
  currencySymbol: string;
  amount: number;
};

export type LandingPrices = {
  bestCo: LandingPrice;
};

export type PersonaBundle = Product & {
  discount?: number;
  personaMonthlyPrice?: string;
};

export type SearchConfigParams = {
  maxFacetHits: number;
  maxValuesPerFacet: number;
  facetingAfterDistinct: boolean;
};

export type SearchConfig = {
  index: string;
  baseFilters: string;
  params: SearchConfigParams;
  searchAppId: string;
  searchApiKey: string;
};

export type EmailAccount = {
  email: string;
  isFacebookLogin: boolean;
  needsSetup: boolean;
};

export type UserRegistration = {
  name: string;
  password: string;
  passwordConfirmation: string;
  gdprOptIn: boolean;
};

export type CreditCard = {
  id: number;
  userId: number;
  stripeCustomerId: string;
  stripeCardId: string;
  fingerprint: string;
  lastFourDigits: number;
  expMonth: number;
  expYear: number;
  brand: string;
  isDefault: boolean;
  postalCode: string | null;
  billingCountry: string | null;
  bankCountry: string;
  createdAt: string;
  updatedAt: string;
  setupIntentId?: string | null;
  setupIntentStatus?: string | null;
  requiresAction?: boolean | null;
  authenticationRedirectUrl?: string | null;
  error?: {
    message?: string;
  } | null;
};

export type CreditCards = Array<CreditCard>;

export type CreateCreditCardAttributes = {
  creditCard: {
    token?: string;
    paymentMethodId?: string;
    fromGift?: boolean;
  };
};

export type SetupIntentStatus = {
  status?: string | null;
  error?: string | null;
};

export type LocaleText = {
  [key: string]: string;
};

export type DiscountCoupon = {
  amountOff: number;
  description: string;
  discountHeadline: string;
  discountType: string;
  discountValue: string;
  percentageOff: number;
  promoStatus: string;
  slug: string;
  intro?: string;
  type: string;
  upsellText: string;
  termsLink: string;
  modalTitle?: LocaleText;
  modalText?: LocaleText;
  modalCtaText?: LocaleText;
  error?: string;
  showPromotionAppliedOnError?: boolean;
  gift?: boolean;
  requireLogin?: boolean;
};

export type ElectronicGiftOrder = {
  sendAtType: "delayed" | "immediately";
  sendDate?: string;
  delayedTimestamp?: string;
};

export type GiftCardOrder = {
  messageLine2?: string;
  careOf: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
};

export type GiftOrder =
  | ({
      giftType: "electronic_gift" | "gift_card";
      gifteeName: string;
      email: string;
      gifterName: string;
      gifterEmail: string;
      message?: string;
      sponsored?: boolean;
    } & ElectronicGiftOrder)
  | GiftCardOrder;

export type StripeOrderAttributes = {
  token?: string;
  saveCard?: boolean | null;
  creditCardId?: number | null;
  discountSlug?: string | null;
  paymentMethodId?: string | null;
  wallet?: boolean | null;
  gift?: GiftOrder;
};

export type BraintreeOrderAttributes = {
  paymentMethodNonce?: string;
  paypalBillingAddress?: {
    city?: string;
    countryCode?: string;
    line1?: string;
    postalCode?: string;
    state?: string;
  };
};

export type PaymentType = "stripe" | "braintree_credit_card" | "braintree";

export const PaymentType = {
  STRIPE: "stripe",
  BRAINTREE_CREDIT_CARD: "braintree_credit_card",
  BRAINTREE: "braintree",
} as const;

export type RegionInfo = {
  regionCode?: string;
  postalCode?: string;
};

export type CreateOrderAttributes = StripeOrderAttributes &
  BraintreeOrderAttributes & {
    email?: string;
    paymentType: PaymentType;
    products: Array<number>;
    regionInfo?: RegionInfo;
    gclid?: string | null;
    fbclid?: string | null;
    turnstileToken?: string;
  };

export type ProductType = "subscription" | "gift" | "course" | "voucher";

export const ProductType = {
  SUBSCRIPTION: "subscription",
  GIFT: "gift",
  COURSE: "course",
  VOUCHER: "voucher",
} as const;

export type GiftAddOn = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  discount?: number;
  discountId?: number;
  discountCode?: string;
  currency?: string;
  monetizedDiscount?: string;
  productId?: number;
};

export type MultiGiftsSummary = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  discount?: number;
  discountId?: number;
  discountCode?: string;
  currency?: string;
  monetizedDiscount?: string;
  productId?: number;
  flatRate?: number;
  unmonetizedFlatRateTotal?: number;
};

export type CartProduct = {
  annualPassGiftHeadline?: string;
  afterpayInstallmentMonetizedFlatRate?: string;
  cartExclusive?: boolean;
  chaptersCount?: number | null;
  courseId: number;
  courseSlug?: string;
  courseStatus?: string | null;
  courseTagline?: string;
  currency: string;
  currencySymbol: string;
  discountCode?: string | null;
  braintreeRedeemable?: boolean;
  flatRate: number;
  geoPrice: string;
  giftCardDisclaimer?: string;
  hasPromo: boolean;
  headline?: string;
  hierarchy?: TierHierarchy;
  id: number;
  imageUrl?: string | null;
  instructorName?: string;
  isAnnualPass?: boolean;
  isGeneric?: boolean | null;
  isMonthlyPass?: boolean;
  isSubscription: boolean;
  monetizedFlatRate: string;
  monetizedFlatRateTotal: string;
  monetizedYearPricePerMonth: string;
  monetizedYearPricePerMonthDiscounted: string | null;
  unmonetizedFlatRateTotal: number;
  multipleYearPass?: boolean;
  paypalSubAvailable?: boolean;
  price: number;
  pricingMarketingText?: string | null;
  pricingMarketingText2?: string | null;
  pricingPlanId?: number;
  productLtv: {
    gift?: number;
    regular?: number;
  };
  productTierName: string;
  receiptHeadline: string;
  stripePricingPlan?: string | null;
  type?: "PurchasePlan" | "Course";
  upsell?: boolean;
  vanityPrice?: number | null;
  displayPrice?: string;
  amountOff?: number;
  discountHeadline?: string;
  productType?: ProductType;
  giftAddOn?: GiftAddOn | null;
  monetizedDiscount?: string | null;
  quantity?: number;
  multiGiftsSummary?: MultiGiftsSummary | null;
  /**
   * The name of the product. It is only present for certificate programs.
   */
  displayName?: string | null;
};

export type SegmentEvent = {
  name?: string;
  properties?: {
    firstName?: string | null;
    lastName?: string | null;
    email?: string;
    contentIds?: Array<number>;
    postalCode?: string | null;
    contentType?: string;
    discount?: number;
    anonymousId?: string | null;
    freeTrialConversion?: boolean;
    isGift?: boolean;
    mcSlug?: string;
    orderId?: string;
    paymentId?: number;
    pricingPlanId?: number;
    productId?: number;
    productVanityName?: string | null;
    productSku?: string;
    revenue?: number;
    purchaseCurrency?: string;
    purchaseAmount?: number;
    total?: number;
    countryCode?: string;
    subscriptionWas?: string | null;
    firstTimeOrder?: boolean;
    currency?: string;
    cardLast4?: number;
    cardBrand?: string;
    fbp?: string | null;
    fbc?: string | null;
    freeTrialOrigin?: {
      name?: string;
      trialLength?: number;
      advocateId?: number;
      advocateEmail?: string;
      promoCode?: string;
      sharedContent?: string | null;
    } | null;
    ttclid?: string | null;
    trialLength?: number | null;
    trialExpiresAt?: string | null;
    isSponsored?: boolean;
    sponsorEmail?: string | null;
    sponsoreName?: string | null;
    sponsoreeEmail?: string;
    sponsoreeName?: string | null;
    paymentProvider?: string;
    sponsorCardLast4?: string | null;
    products?: ObjectWithIntegerIdArray;
  };
  integrations?: {
    integrations?: {
      [key: string]: unknown;
    };
  };
};

export type Order = {
  products: Array<CartProduct>;
  redirectPath: string;
  email?: string;
  needsSetup: boolean;
  newUserId?: number;
  orderId: number;
  subtotal: number;
  subtotalFormatted: number;
  promoResult: {
    error?: string;
  };
  isFreeTrial: boolean;
  freeTrialType?: "free_trial" | "guest_pass";
  segmentEvents: Array<SegmentEvent>;
  showReferralSurvey: boolean;
  referralSources: Array<string>;
  guestPass: {
    show?: boolean;
  };
  requiresAction?: boolean;
  afterpayRedirectUrl?: string;
  authenticationRedirectUrl?: string;
  orderSasNumber?: string;
  /**
   * specify user's BOGO gift token available to send
   */
  bogoGiftToken?: string;
  /**
   * specify when user's BOGO gift expires (iso 8601 format)
   */
  bogoGiftExpirationRaw?: string;
  /**
   * specify when the user's subscription expires (used for guest-pass iso 8601 format)
   */
  subscriptionEndsAt?: string;
  /**
   * prcng-4V1 experiment - specify if users purchased the new tier and it was auto upgraded
   */
  isExpanded?: boolean;
  /**
   * Link using PaymentElement
   */
  clientSecret?: string;
  /**
   * specifies if the payment method is stripe link
   */
  isStripeLink?: boolean;
};

export type OrderConfirmation = {
  id: number;
  status: string;
  products?: Array<CartProduct>;
  redirectPath?: string;
  needsSetup?: boolean;
  isFreeTrial?: boolean;
  segmentEvents?: Array<{
    name?: string;
    properties?: {
      firstName?: string | null;
      lastName?: string | null;
      email?: string;
      contentIds?: Array<number>;
      postalCode?: string | null;
      contentType?: string;
      discount?: number;
      anonymousId?: string | null;
      freeTrialConversion?: boolean;
      isGift?: boolean;
      mcSlug?: string;
      orderId?: string;
      paymentId?: number;
      pricingPlanId?: number;
      productId?: number;
      productVanityName?: string | null;
      productSku?: string;
      revenue?: number;
      purchaseCurrency?: string;
      purchaseAmount?: number;
      total?: number;
      countryCode?: string;
      subscriptionWas?: string | null;
      firstTimeOrder?: boolean;
      currency?: string;
      cardLast4?: number;
      cardBrand?: string;
      fbp?: string | null;
      fbc?: string | null;
      ttclid?: string | null;
      isSponsored?: boolean;
      sponsorEmail?: string | null;
      sponsoreName?: string | null;
      sponsoreeEmail?: string;
      sponsoreeName?: string | null;
      paymentProvider?: string;
      sponsorCardLast4?: string | null;
      products?: ObjectWithIntegerIdArray;
    };
    integrations?: {
      integrations?: {
        [key: string]: unknown;
      };
    };
  }>;
  showReferralSurvey?: boolean;
  referralSources?: Array<string>;
};

export type UpdateProductAttributes = {
  productId: number;
  discountSlug?: string;
};

export type AddProductAttributes = {
  productId: number;
  gift?: boolean;
  discountSlug?: string;
  productType?: string;
  quantity?: number;
};

export type RemoveProductAttributes = {
  productId: number;
  productType: string;
};

export type CartProducts = {
  products: Array<CartProduct>;
  orderSummary?: {
    total?: string;
    discountedTotal?: string;
    discountAmount?: string;
  };
};

export type RedeemBogoGift = {
  email: string;
  gifteeName: string;
  gifterEmail: string;
  gifterName: string;
  message: string;
  sendAtType: "delayed" | "immediately";
  sendDate?: string;
  sponsored?: boolean;
};

export type PersonaAddOn = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  billingCycle?: string;
  currency?: string;
  productId?: number;
  productType?: string;
};

export type LearningToolkitAddOn = {
  monetizedPrice?: string;
  billingCycle?: string;
  currency?: string;
  productId?: number;
  productType?: string;
};

export type CertificateProgramAddOnPricing = {
  /**
   * Raw price value in cents
   */
  price: number;
  /**
   * Formatted price with currency symbol
   */
  monetizedPrice: string;
  /**
   * Currency code
   */
  currency: string;
  /**
   * Discount percentage
   */
  discount: number;
  /**
   * ID of the coupon applied for the discount
   */
  discountId?: number | null;
  /**
   * Code of the coupon applied for the discount
   */
  discountCode?: string | null;
  /**
   * Price in cents after discount applied
   */
  discountedPrice: number;
  /**
   * Formatted discounted price
   */
  discountedMonetizedPrice: string;
};

export type Image = {
  altText?: string;
  url: string;
};

export type CertificateProgramAddOnImages = {
  /**
   * The main program thumbnail image (16x9 aspect ratio)
   */
  mainImage: Image;
  /**
   * The partner logo lockup condensed light image
   */
  logo: Image;
};

export type CertificateProgramAddOnPartner = {
  /**
   * The name of the partner organization (e.g., "NAVY SEAL FOUNDATION")
   */
  name: string;
};

export type CertificateProgramAddOn = {
  /**
   * The unique identifier of the certificate program
   */
  id: string;
  /**
   * The slug of the certificate program
   */
  slug: string;
  /**
   * The title of the certificate program
   */
  title: string;
  /**
   * ID of the associated product
   */
  productId: number;
  /**
   * Always "certificate_program"
   */
  productType: "certificate_program";
  /**
   * UUID of the media resource for video playback
   */
  mediaUuid: string;
  pricing: CertificateProgramAddOnPricing;
  images: CertificateProgramAddOnImages;
  partner: CertificateProgramAddOnPartner;
};

export type ProrationPreview = {
  /**
   * ID of the product
   */
  productId?: number;
  /**
   * Formatted current price with currency symbol
   */
  monetizedCurrentPrice?: string;
  /**
   * Formatted renewal price with currency symbol
   */
  monetizedRenewalPrice?: string;
  /**
   * Date when the subscription will renew (YYYY-MM-DD)
   */
  renewalDate?: string;
  /**
   * Formatted original price with currency symbol
   */
  monetizedOriginalPrice?: string;
  /**
   * Billing cycle of the product (e.g., monthly, yearly)
   */
  billingCycle?: string;
  /**
   * Currency code (e.g., USD, EUR)
   */
  currency?: string;
  /**
   * Type of the product (e.g., add-on, subscription)
   */
  productType?: string;
  discount?: number;
};

export type EmailConfirmationLegacyAttributes = {
  action: EmailConfirmationAction;
  /**
   * The email address to confirm.
   */
  email?: string;
};

export type AfterPayOrderAttributes = {
  zipCode?: string;
};

export type ContentRowUiConfigShowTileVideoOn =
  | "hover"
  | "first_visible"
  | "last_visible";

export const ContentRowUiConfigShowTileVideoOn = {
  HOVER: "hover",
  FIRST_VISIBLE: "first_visible",
  LAST_VISIBLE: "last_visible",
} as const;

export type ContentRowUiConfigTileImageMode =
  | "primary"
  | "cinematic"
  | "outcome"
  | "current_progress";

export const ContentRowUiConfigTileImageMode = {
  PRIMARY: "primary",
  CINEMATIC: "cinematic",
  OUTCOME: "outcome",
  CURRENT_PROGRESS: "current_progress",
} as const;

export type ContentRowUiConfigTileRatio = "16x9" | "2x3" | "1x1";

export const ContentRowUiConfigTileRatio = {
  _16X9: "16x9",
  _2X3: "2x3",
  _1X1: "1x1",
} as const;

export type ContentRowUiConfigTileVideoMode = "current_progress" | "trailer";

export const ContentRowUiConfigTileVideoMode = {
  CURRENT_PROGRESS: "current_progress",
  TRAILER: "trailer",
} as const;

export type ContentRowUiConfigType =
  | "carousel"
  | "hidden"
  | "grid"
  | "list"
  | "library_banner"
  | "enterprise_banner"
  | "assignment_carousel"
  | "looking_for_more_banner"
  | "daily_moments";

export const ContentRowUiConfigType = {
  CAROUSEL: "carousel",
  HIDDEN: "hidden",
  GRID: "grid",
  LIST: "list",
  LIBRARY_BANNER: "library_banner",
  ENTERPRISE_BANNER: "enterprise_banner",
  ASSIGNMENT_CAROUSEL: "assignment_carousel",
  LOOKING_FOR_MORE_BANNER: "looking_for_more_banner",
  DAILY_MOMENTS: "daily_moments",
} as const;

export type PartnershipEntitlement = {
  id: string;
  status: string;
  resellerName: string;
  resellerDisplayName: string;
  sku: string;
  partner: string;
  redirectAfterActivation: boolean;
  redemptionStatus: string;
  resellerSkuDisplayName: string;
  skuSlug: string;
  resellerAsset?: string | null;
  resellerUrl?: string | null;
  redirectUrl?: string | null;
  resellerAssetAltText?: string | null;
  faqUrl?: string | null;
};

export type PillKind =
  | "default"
  | "dim"
  | "transparent"
  | "primary"
  | "utility";

export const PillKind = {
  DEFAULT: "default",
  DIM: "dim",
  TRANSPARENT: "transparent",
  PRIMARY: "primary",
  UTILITY: "utility",
} as const;

export type ResumeChapter = {
  id: number;
  abstract: string;
  brightcoveVideoId?: string;
  mediaUuid: string;
  duration: string;
  endScreenType: string;
  number: number;
  slug: string;
  title: string;
  type: ChapterType;
  isExampleLesson: boolean;
  videoThumbUrl: string;
  uuid: string;
};

export type SessionsGalleryItem = {
  createdAt: string;
  id: number;
  moduleTitle: string;
  mediaSequence?: Array<{
    id: number;
    url: string;
    mediaType: string;
    status?: string;
    uuid?: string;
    position?: number;
  }>;
  postGroupId: number;
  postGroupType: string;
  text?: string;
};

export type SessionsGalleryFeed = {
  results: Array<SessionsGalleryItem>;
  cursor: number;
};

export type CouponCategories = Category2;

export type CouponDiscountType = DiscountType;

export type PurchasePlans = PurchasePlan;

export type V3Bookmark = {
  /**
   * The unique identifier of a resource to bookmark.
   */
  uuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type Playhead = {
  progress: number;
  cursor: number;
  /**
   * The percentage of the thumbnail bar to display.
   */
  barPercentage: number;
  isComplete: boolean;
  updatedAt: string;
};

export type EnterpriseAdminInteractions = {
  assignment?: {
    canAssign: boolean;
    cta?: EnterpriseAdminInteractionsCta;
  };
};

export type DisplayPagesType = "CWP" | "CDP" | "SDP" | "SAP";

export const DisplayPagesType = {
  CWP: "CWP",
  CDP: "CDP",
  SDP: "SDP",
  SAP: "SAP",
} as const;

export type EnterpriseAdminInteractionsCta = {
  title: string;
  content?: EnterpriseAdminInteractionsCtaContent;
  /**
   * Applicable pages for this cta, "CDP - Content Details Page", "CWP" - Content Watch Page", "SDP" - Session Details Page, "SAP" - Session Activity Page
   */
  displayPages?: Array<string>;
};

export type EnterpriseAdminInteractionsCtaContent = {
  title: string;
  subtitle?: string;
  image?: {
    "1x1"?: Image;
  };
};

export type Assignment = {
  /**
   * The message shared by the admin.
   */
  message?: string;
  /**
   * Name of the assigner (admin)
   */
  assignedBy?: string;
  /**
   * Name of the assignee or assignees (user)
   */
  assignedTo?: string;
  assignedAt?: string;
  /**
   * Applicable pages for this assignment, "CDP - Content Details Page", "CWP" - Content Watch Page", "SDP" - Session Details Page, "SAP" - Session Activity Page
   */
  displayPages?: Array<string>;
};

export type NpsSurveyType =
  | "FreeformTextNpsSurveyStep"
  | "ScoreNpsSurveyStep"
  | "MultiSelectNpsSurveyStep"
  | "NumericalRatingNpsSurveyStep"
  | "ImprovementNpsSurveyStep"
  | "PriorProficiencyNpsSurveyStep"
  | "FamiliarityNpsSurveyStep"
  | "InspirationNpsSurveyStep"
  | "HowItHelpsNpsSurveyStep"
  | "RatingReasonNpsSurveyStep"
  | "PromoterHighlightsStep"
  | "DetractorConcernsStep";

export const NpsSurveyType = {
  FREEFORM_TEXT_NPS_SURVEY_STEP: "FreeformTextNpsSurveyStep",
  SCORE_NPS_SURVEY_STEP: "ScoreNpsSurveyStep",
  MULTI_SELECT_NPS_SURVEY_STEP: "MultiSelectNpsSurveyStep",
  NUMERICAL_RATING_NPS_SURVEY_STEP: "NumericalRatingNpsSurveyStep",
  IMPROVEMENT_NPS_SURVEY_STEP: "ImprovementNpsSurveyStep",
  PRIOR_PROFICIENCY_NPS_SURVEY_STEP: "PriorProficiencyNpsSurveyStep",
  FAMILIARITY_NPS_SURVEY_STEP: "FamiliarityNpsSurveyStep",
  INSPIRATION_NPS_SURVEY_STEP: "InspirationNpsSurveyStep",
  HOW_IT_HELPS_NPS_SURVEY_STEP: "HowItHelpsNpsSurveyStep",
  RATING_REASON_NPS_SURVEY_STEP: "RatingReasonNpsSurveyStep",
  PROMOTER_HIGHLIGHTS_STEP: "PromoterHighlightsStep",
  DETRACTOR_CONCERNS_STEP: "DetractorConcernsStep",
} as const;

export type NpsSurvey = {
  /**
   * Indicates if the survey should be taken.
   */
  shouldTakeSurvey: boolean;
  /**
   * The unique identifier of the content to display the survey after.
   */
  contentUuid: string;
  /**
   * When specified, application triggers a survey when the user reaches the end of the moment.
   */
  momentUuid?: string;
  steps: Array<NpsSurveyStep>;
};

export type NpsSurveyStep = {
  /**
   * The type of survey step. Check `NpsSurveyType` for the list of enums
   */
  stepType: string;
  /**
   * The slug for the question, used to identify the question in the survey.
   */
  questionSlug?: string;
  /**
   * The question to be asked in the survey step.
   */
  question?: string;
  /**
   * Indicates if the step is optional.
   */
  optional?: boolean;
  freeformText?: {
    /**
     * Placeholder text for the freeform text input.
     */
    placeholder?: string;
  };
  score?: {
    /**
     * Indicates if the step is an NPS score step.
     */
    isNps?: boolean;
    /**
     * Minimum score value.
     */
    minimumScore: number;
    /**
     * Maximum score value.
     */
    maximumScore: number;
    /**
     * Label for the minimum score value.
     */
    minimumLabel: string;
    /**
     * Label for the maximum score value.
     */
    maximumLabel: string;
    freeformText?: {
      /**
       * Title for the freeform text input.
       */
      title?: string;
      /**
       * Indicates if the freeform text input is optional.
       */
      optional?: boolean;
      /**
       * Placeholder text for the freeform text input.
       */
      placeholder?: string;
    };
  };
  multiSelect?: {
    selectOptions: Array<{
      /**
       * Slug for the select option, used to identify the option in the survey.
       */
      slug?: string;
      /**
       * Text to display for the select option.
       */
      text?: string;
      freeformText?: {
        /**
         * Placeholder text for the freeform text input.
         */
        placeholder?: string;
      };
    }>;
  };
  numericalRating?: {
    title: string;
    question: string;
  };
  improvement?: {
    title: string;
    question: string;
  };
  priorProficiency?: {
    question: string;
  };
  familiarity?: {
    question: string;
  };
  inspiration?: {
    question: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
  howItHelps?: {
    question: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
  ratingReason?: {
    title?: string;
    question: string;
    subheading?: string;
  };
  promoterHighlights?: {
    title?: string;
    question: string;
    subheading?: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
  detractorConcerns?: {
    title?: string;
    question: string;
    subheading?: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
};

export type SurveyStepSelectOption = {
  /**
   * Enum key for the step.
   * For the list of enums check `HowItHelpsStepValue` for howItHelps,
   * `InspirationStepValue` for inspiration, and `FeedbackAspectStepValue` for `promoterHighlights` and `detractorConcerns`.
   *
   */
  name: string;
  /**
   * text presented for the step
   */
  text: string;
};

export type Communities = Array<CommunityItem>;

export type CommunityItem = {
  /**
   * The name of the community.
   */
  name: string;
  isSelected: boolean;
  isNew: boolean;
  id: string;
};

export type RecommendedSource = {
  /**
   * Text label for the recommendation source.
   */
  label?: string;
  /**
   * URL of the logo image.
   */
  logoUrl: string;
  /**
   * Text to display when logo image is unavailable.
   */
  fallbackText: string;
  /**
   * Alternative text for the logo image, used for accessibility.
   */
  logoAltText: string;
};

/**
 * This object provides the information that is necessary to display a landing page
 * for a bundle of video content, such as the CDP (Content Details Page).
 *
 */
export type WatchBundle = {
  /**
   * The unique identifier for the WatchBundle.
   */
  watchBundleUuid: string;
  /**
   * The total duration of released video content, in seconds.
   */
  totalRuntime: number;
  /**
   * The count of video content in the bundle once all content has been released.
   */
  finalContentCount: number;
  /**
   * Indicates if the bundle is suitable for consuming audio content without video.
   */
  isAudioFriendly: boolean;
  /**
   * Indicates if the bundle is mature subject matter.
   */
  isMature: boolean;
  /**
   * An ordered list of starring instructors.
   */
  highlightedStars?: Array<WatchBundleStar>;
  /**
   * Indicates to the client whether to display the contents in a list on the watch page
   * or hide the list of content. Typically used for single cut content.
   *
   */
  shouldShowWatchList?: boolean;
  /**
   * An ordered list of video content contained in the WatchBundle.
   */
  contents: Array<WatchBundleContent>;
  /**
   * An ordered list of seasons that can be used to group the video content. Not all watch bundles have seasons.
   *
   */
  seasons: Array<WatchBundleSeason>;
  terminology: WatchBundleTerminology;
  text: WatchBundleText;
  image: WatchBundleImage;
  video: WatchBundleVideo;
  links: WatchBundleLinks;
  tracking: WatchBundleTracking;
};

export type WatchBundleLinks = {
  /**
   * A path to the content details page.
   */
  detailsPage?: string;
};

export type WatchBundleVideo = {
  trailer?: unknown & PublicMedia;
  autoPlay?: AutoPlayVideo;
};

export type WatchBundleImage = {
  titleOverlay?: unknown & Image;
  /**
   * Images that can be set as dark backgrounds.
   */
  background?: {
    "16x9"?: Image;
    "12x5"?: Image;
  };
  /**
   * Images that represent thumbnails of the bundle.
   */
  thumbnail?: {
    "1x1"?: Image;
    "16x9"?: Image;
  };
};

export type WatchBundleText = {
  /**
   * The title of the bundle, typically displayed above the `subtitle` or `continuedTitle` text.
   */
  title: string;
  /**
   * A continuation of the title, typically preceded by the title. Often, this text resembles the subtitle
   * but with leading text that gramatically joins the title and subtitle.
   *
   */
  continuedTitle: string;
  /**
   * A brief line of text that provides context to the bundle.
   */
  subtitle: string;
  /**
   * A more detailed description of the bundle.
   */
  description: string;
  /**
   * Auxilliary watch information to display to the user, such as total runtime and/or content count.
   *
   */
  watchDetails?: string;
  /**
   * The text that should appear label for a tab that contains the list of content for the watch bundle.
   * This will be formatted in "Title Case". Clients should change the case as they see fit so the text appears in the UX appropriately.
   *
   */
  contentListTab?: string;
  /**
   * The text used on a button or link when starting the watch bundle.
   */
  startWatchingCta?: string;
  /**
   * Provides additional context about the seasons, such as when the next season is coming.
   */
  seasonNote?: string;
  /**
   * Indicates the release schedule of the content, such as when new episodes are released. Currently used for series only.
   */
  releaseNote?: string;
};

/**
 * Information that describes the format of the watch bundle.
 */
export type WatchBundleTerminology = {
  text: {
    watchBundle: string;
    season: string;
    content: string;
  };
  image: {
    /**
     * An image that represents the term for the watch bundle and can be overlayed over a dark background.
     */
    watchBundleOverlay?: Image;
  };
};

export type WatchBundleStar = {
  text: {
    name: string;
    /**
     * A paragraph describing noteworthy achievements by the instructor.
     */
    description: string;
  };
  image: {
    thumbnail: {
      "1x1": Image;
    };
  };
};

export type WatchBundleSeason = {
  /**
   * The unique identifier for the season.
   */
  seasonUuid: string;
  /**
   * A number indicating the relative order of the season within the bundle.
   * A season should chronologically precede other seasons with higher sequence numbers.
   *
   */
  sequenceNumber: number;
  text: {
    title: string;
    /**
     * A descriptive text with details about the season.
     */
    teaser?: string;
  };
};

export type WatchBundleContent = {
  /**
   * The unique identifier for the video content.
   */
  contentUuid: string;
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid: string;
  /**
   * Experimental. The position in the video to begin playback.
   */
  startPosition?: number;
  /**
   * Experimental. The position in the video to end playback.
   */
  endPosition?: number;
  /**
   * The duration of the video, in seconds.
   */
  runtime: number;
  downloadDetails: {
    /**
     * Indicates if the video is downloadable on mobile devices.
     */
    isDownloadable: boolean;
  };
  cta?: {
    /**
     * A path to an existing page.
     */
    path: string;
    /**
     * Text for the cta element
     */
    text: string;
  };
  sharingDetails: {
    /**
     * Indicates if the content can be shared
     */
    isShareable: boolean;
    image: {
      "12x5"?: Image;
    };
    /**
     * Text for the share button
     */
    ctaText?: string;
  };
  /**
   * The unique identifier for the season this content belongs to.
   */
  seasonUuid?: string;
  /**
   * A number indicating the relative order of the content within the bundle.
   * A piece of content should chronologically precede other contents with higher sequence numbers.
   *
   */
  sequenceNumber: number;
  releaseDetails: {
    /**
     * Indicates if the content has been released for consumption.
     */
    isReleased: boolean;
    /**
     * Formatted in date-only ISO8601, the date the content has been released. If the content is yet to be released,
     * expect the date to be in the future.
     *
     */
    releasedOn?: string;
  };
  text: {
    /**
     * The headline of the content.
     */
    title: string;
    /**
     * Additional title for the content.
     */
    continuedTitle?: string;
    /**
     * The supporting headline of the content.
     */
    subtitle?: string;
    /**
     * The paragraph that provides and introduction and context to the content.
     */
    description?: string;
    /**
     * A short label that indicates the position of the content within the bundle.
     */
    sequenceLabel?: string;
  };
  image: {
    thumbnail: {
      "16x9": Image;
    };
  };
  moments: Array<Moment>;
  links: WatchBundleContentLinks;
  tracking: WatchBundleContentTracking;
  conversation?: WatchBundleContentConversation;
  chatEnabled?: boolean;
};

export type WatchBundleContentLinks = {
  /**
   * A path to the content watch page.
   */
  watchPage: string;
  /**
   * A path to the content details page. This attribute is deprecated and will be removed in the future. It is superseded by the `cta` attribute.
   * @deprecated
   */
  detailsPage?: string;
};

export type PublicMedia = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid: string;
  text: {
    /**
     * The headline of the trailer.
     */
    title: string;
  };
  image: {
    thumbnail: {
      "16x9": Image;
    };
  };
};

/**
 * The video that should be played automatically when the watch bundle is opened.
 */
export type AutoPlayVideo = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid: string;
};

export type Moment = {
  /**
   * The unique identifier for the Moment.
   */
  momentUuid: string;
  /**
   * The point in video the moment takes place, in seconds.
   */
  position: number;
  text: {
    /**
     * The title of the moment.
     */
    title: string;
  };
  tracking: MomentTracking;
};

export type WatchBundleTrackingType =
  | "PlaylistTracking"
  | "CourseTracking"
  | "SearchPlaylistTracking";

export const WatchBundleTrackingType = {
  PLAYLIST_TRACKING: "PlaylistTracking",
  COURSE_TRACKING: "CourseTracking",
  SEARCH_PLAYLIST_TRACKING: "SearchPlaylistTracking",
} as const;

export type WatchBundleTracking = {
  /**
   * The type of tracking object.
   */
  trackingType: string;
  courseSlug?: string;
  courseId?: string;
  courseVanityName?: string;
  playlist?: string;
  playlistId?: string;
  search?: string;
  watchBundleUuid?: string;
};

export type WatchBundleContentTracking = {
  contentType: string;
  contentId: string;
  chapterSlug?: string;
  courseSlug?: string;
  courseId?: string;
  contentTitle: string;
  resourceType: string;
  resourceId: string;
  videoId?: string;
  contentUuid?: string;
};

export type WatchBundleContentConversation = {
  courseId: number;
  chapterId: number;
};

export type MomentTracking = {
  resourceType: string;
  resourceId: string;
};

export type WatchBundleExtras = {
  /**
   * The unique identifier for the WatchBundle.
   */
  watchBundleUuid: string;
  documents?: {
    guide?: Document;
    additionalMaterial?: Array<Document>;
  };
  externalResources?: Array<Document>;
  recipes?: Array<WatchBundleRecipe>;
  featuredRow?: {
    /**
     * Indicates that the client should show a featured row on the watch page.
     * This row typically takes the form of top rated lessons.
     *
     */
    shouldShowFeaturedRow?: boolean;
  };
  takeaways?: Array<Takeaway>;
};

export type Document = {
  url: string;
  /**
   * See `DocumentIntent` for a list of currently supported values.
   */
  intent?: string;
  text: {
    title: string;
    description?: string;
  };
  image?: {
    cover: Image;
  };
  tracking: DocumentTracking;
  cta?: {
    title: string;
  };
};

export type DocumentIntent = "download" | "redirect";

export const DocumentIntent = {
  DOWNLOAD: "download",
  REDIRECT: "redirect",
} as const;

export type WatchBundleRecipe = {
  recipeUuid: string;
  contentUuid: string;
  /**
   * Indicates if this recipe can be shared publicly
   */
  isShareable: boolean;
  text: {
    title: string;
    serves: string;
  };
  image?: {
    background?: {
      "4x3"?: Image;
    };
  };
  html: {
    ingredients: string;
    instructions: string;
  };
  document?: Document;
  tracking: RecipeTracking;
};

export type RecipeTracking = {
  resourceType: string;
  resourceId: string;
};

export type DocumentTracking = {
  resourceTitle: string;
  resourceType: string;
  resourceId: string;
};

export type Takeaway = {
  takeawayUuid: string;
  contentUuid: string;
  summary?: string;
  popup?: {
    showPosition: number;
    hidePosition: number;
  };
  list?: {
    startPosition: number;
    endPosition: number;
  };
};

export type WatchBundleInteractions = {
  continue?: WatchBundleContinueWatching;
  bookmarks?: WatchBundleBookmarks;
  notes?: WatchBundleNotes;
  surveys?: WatchBundleSurveys;
  assignment?: Assignment;
  enterpriseAdmin?: EnterpriseAdminInteractions;
  recommendedSource?: RecommendedSource;
};

export type WatchBundleSurveys = {
  netPromoterScore?: NpsSurvey;
  segment?: SegmentSurvey;
};

export type SegmentSurvey = {
  contentUuid: string;
  title: string;
  question: string;
  cta: SegmentSurveyCta;
};

export type SegmentSurveyCta = {
  /**
   * A path to an existing page.
   */
  path: string;
  /**
   * Text for the cta element
   */
  text: string;
};

export type WatchBundleContinueWatching = {
  resume?: ContentResume;
  contents?: Array<ContentPlayhead>;
};

export type ContentResume = {
  contentUuid: string;
  /**
   * The text to apply to a button or link when resuming the watch bundle content.
   */
  resumeText?: string;
};

export type ContentPlayhead = {
  contentUuid: string;
} & Playhead;

export type ContentBookmark = {
  contentUuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type MomentBookmark = {
  momentUuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type RecipeBookmark = {
  recipeUuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type WatchBundleBookmarks = {
  /**
   * Indicates if bookmarking is supported.
   */
  isSupported: boolean;
  bookmarks?: Array<V3Bookmark>;
  /**
   * @deprecated
   */
  contents?: Array<ContentBookmark>;
  /**
   * @deprecated
   */
  moments?: Array<MomentBookmark>;
  /**
   * @deprecated
   */
  recipes?: Array<RecipeBookmark>;
};

export type WatchBundleNotes = {
  /**
   * Indicates if notes are supported.
   */
  isSupported: boolean;
  contents?: Array<ContentNote>;
};

export type ContentNote = {
  contentUuid: string;
  entry: string;
  tracking?: NoteTracking;
};

export type NoteTracking = {
  resourceType: string;
  resourceId?: string;
};

export type WatchBundleContentInteractions = {
  netPromoterScore?: NpsSurvey;
};

export type PlaybackTokenResponse = {
  token: string;
};

export type V3Note = {
  entry: string;
};

export type UpdateSurvey = {
  /**
   * The slug of the question being answered. This is used to identify the specific survey step.
   * It should match the slug defined in the survey step.
   *
   */
  questionSlug?: string;
  /**
   * Freeform text for the survey step `FreeformTextNpsSurveyStep`
   */
  freeformText?: {
    /**
     * A text entry for the given survey step
     */
    text: string;
  };
  /**
   * Survey feedback for the survey step `ScoreNpsSurveyStep`
   */
  score?: {
    /**
     * A score for the given survey step
     */
    value: number;
    /**
     * A freeform text entry for the given survey step
     */
    freeformText?: string;
  };
  /**
   * Survey feedback for the survey step `MultiSelectNpsSurveyStep`
   */
  multiSelect?: {
    selections: Array<{
      /**
       * The slug of the select option
       */
      slug: string;
      /**
       * A freeform text entry for the given survey step
       */
      freeformText?: string;
    }>;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `NumericalRatingNpsSurveyStep``
   */
  numericalRating?: {
    score: number;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `ImprovementNpsSurveyStep``
   */
  improvement?: {
    /**
     * A text entry for the given survey step
     */
    feedback: string;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `PriorProficiencyNpsSurveyStep``
   */
  priorProficiency?: {
    /**
     * A text entry for the given survey step
     */
    feedback: string;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `FamiliarityNpsSurveyStep``
   */
  familiarity?: {
    /**
     * A text entry for the given survey step
     */
    feedback: string;
  };
  /**
   * Survey feedback for the survey step `InspirationNpsSurveyStep``
   */
  inspiration?: {
    /**
     * comma-separated list of options for this survey step. Check `InspirationStepValue` for the list of enums
     */
    feedback?: string;
    freeFormFeedback?: string;
  };
  /**
   * Survey feedback for the survey step `HowItHelpsNpsSurveyStep``
   */
  howItHelps?: {
    /**
     * comma-separated list of options for this survey step. Check `HowItHelpsStepValue` for the list of enums
     */
    feedback?: string;
    freeFormFeedback?: string;
  };
};

export type InspirationStepValue =
  | "Topic"
  | "Instructor"
  | "Recommendation"
  | "Asked"
  | "Other";

export const InspirationStepValue = {
  TOPIC: "Topic",
  INSTRUCTOR: "Instructor",
  RECOMMENDATION: "Recommendation",
  ASKED: "Asked",
  OTHER: "Other",
} as const;

export type HowItHelpsStepValue =
  | "Work"
  | "Personal"
  | "Motivation"
  | "NoImpact"
  | "Other";

export const HowItHelpsStepValue = {
  WORK: "Work",
  PERSONAL: "Personal",
  MOTIVATION: "Motivation",
  NO_IMPACT: "NoImpact",
  OTHER: "Other",
} as const;

/**
 * The enum values for the `PromoterHighlightsStep` and `DetractorConcernsStep` survey steps.
 *
 */
export type FeedbackAspectStepValue =
  | "InstructorAndTeachingStyle"
  | "Relevance"
  | "Structure"
  | "Activities"
  | "Pacing"
  | "UsabilityAndSupport"
  | "Other"
  | "None";

export const FeedbackAspectStepValue =
  /**
   * The enum values for the `PromoterHighlightsStep` and `DetractorConcernsStep` survey steps.
   *
   */
  {
    INSTRUCTOR_AND_TEACHING_STYLE: "InstructorAndTeachingStyle",
    RELEVANCE: "Relevance",
    STRUCTURE: "Structure",
    ACTIVITIES: "Activities",
    PACING: "Pacing",
    USABILITY_AND_SUPPORT: "UsabilityAndSupport",
    OTHER: "Other",
    NONE: "None",
  } as const;

export type Sharing = {
  links: {
    facebook: SharingLink;
    linkedin: SharingLink;
    twitter: SharingLink;
    copy: SharingLink;
    messenger: SharingLink;
    email: EmailSharingLink;
    more: SharingLink;
    message: SharingLink;
  };
  tracking: {
    /**
     * The identifier of the user requesting shareable links.
     */
    advocateId: string;
    /**
     * The email of the user requesting shareable links.
     */
    advocateEmail: string;
  };
};

export type SharingLink = {
  url: string;
  /**
   * Indicates if this link offers a redeemable guest pass.
   */
  includesGuestPass: boolean;
};

export type EmailSharingLink = SharingLink & {
  /**
   * The subject of the email to prepare.
   */
  subject: string;
  /**
   * The body of the email to prepare.
   */
  body: string;
};

export type SessionActivityInteractions = {
  communities?: Communities;
  community?: Community;
  surveys?: {
    netPromoterScore?: NpsSurvey;
  };
};

/**
 * This field is deprecated and will be replaced by `communities`.
 * @deprecated
 */
export type Community = {
  name: string;
};

export type SessionsInteractions = {
  assignment?: Assignment;
  enterpriseAdmin?: EnterpriseAdminInteractions;
  communities?: Communities;
};

export type CreateAssignments = {
  assignees: Array<AssigneeIdentifier>;
  message?: string;
  contentUuid: string;
};

export type Assignees = Array<Assignee>;

export type Assignee = {
  /**
   * Type of Assignee. Check `AssigneeTypeValue` for the list of enums
   */
  type: string;
  team?: V3Team;
  member?: Member;
};

export type AssigneeTypeValue = "Member" | "Team";

export const AssigneeTypeValue = {
  MEMBER: "Member",
  TEAM: "Team",
} as const;

export type Member = {
  id: string;
  name: string;
  email: string;
  noEmailUser: boolean;
  username?: string;
};

export type V3Team = {
  id: string;
  name: string;
};

export type AssigneeIdentifier = {
  id: string;
  /**
   * Assignee.  See 'AssigneeType' for the list of enums
   */
  type: string;
};

export type UserIdentifier = {
  userId: string;
};

export type ContentProgress = {
  /**
   * The unique identifier of an assignable resource
   */
  uuid: string;
  /**
   * A list of supported columns that should be shown in the Member Progress table (based on user's permissions)
   */
  detailedProgressFields: Array<string>;
  /**
   * The total number of members this class was shared with
   */
  totalMembersShared: number;
  /**
   * The total number of members this class was shared by the current user
   */
  totalMembersSharedByMe: number;
  /**
   * The total number of members with filters applied
   */
  totalMembers: number;
  /**
   * The total number of members that watched the course
   */
  totalMembersStarted: number;
  /**
   * Whether the data is incomplete
   */
  dataIncomplete: boolean;
  details: AssignedContentDetails;
  detailedProgress?: Array<DetailedProgress>;
  effectiveness?: {
    /**
     * The effectiveness rating given by viewers, on a scale of 0-10
     */
    rating: number;
    /**
     * The number of viewers who have rated the content
     */
    responseCount: number;
    /**
     * The list of individual users' NPS ratings (anonymized)
     */
    scores: Array<number>;
  };
  engagementMetrics?: {
    /**
     * The total number of members that started this class
     */
    started: number;
    /**
     * The total number of minutes watched
     */
    totalMinutesWatched: number;
    /**
     * The average of minutes watched
     */
    avgMinutesWatched: number;
    /**
     * The percentage of completion
     */
    pctCompletion: number;
    /**
     * The total number of members with filters applied
     */
    totalMembers: number;
    /**
     * The percentage of members that started this class
     */
    pctStarted: number;
    /**
     * The percentage of activities completed
     */
    pctActivitiesCompleted?: number;
  };
  impactSurvey?: {
    /**
     * The total number of viewers who responded to an impact survey for this content
     */
    totalResponseCount: number;
    prompts: Array<ImpactScorePrompt>;
  };
  programDetails?: {
    /**
     * The total number of sessions for this program
     */
    totalSessions: number;
    programSessions?: Array<ProgramSession>;
  };
};

export type ProgramSession = {
  /**
   * The unique identifier of the session
   */
  uuid: string;
  /**
   * The title of the session
   */
  title: string;
  image?: Image;
};

export type AssignedContents = Array<AssignedContent>;

export type AssignedContent = {
  /**
   * The unique identifier of a resource that has been assigned.
   */
  uuid: string;
  /**
   * The slug of the shared content.
   */
  slug: string;
  /**
   * Whether the current user can view progress for this assignment
   */
  canViewProgress: boolean;
  details: AssignedContentDetails;
  assignments: Array<Assignment>;
};

export type AssignedContentDetails = {
  /**
   * The title of the content
   */
  title: string;
  /**
   * The subtitle of the content, typically displayed below the main title
   */
  subtitle: string;
  image: Image;
};

export type AssignableContentResult = {
  contentItems: Array<AssignableContentListItem>;
};

export type AssignableContentListItem = {
  /**
   * The unique identifier of the content
   */
  uuid: string;
  /**
   * The title of the content
   */
  title: string;
};

export type DetailedProgress = {
  /**
   * User id
   */
  userId: number;
  /**
   * User Email Address
   */
  userEmail: string;
  /**
   * User Name
   */
  userName: string;
  /**
   * First share message from admin
   */
  firstShareMessage?: string;
  /**
   * Date and time when this content was first shared with the user
   */
  firstSharedOn?: string;
  /**
   * Name of the admin who shared this content first
   */
  firstSharedBy?: string;
  /**
   * Progress percentage of the user for the current content
   */
  contentProgress?: number;
  /**
   * Progress in minutes of the user for the current content
   */
  contentProgressMinutes?: number;
  /**
   * Date and time when the user started taking the content
   */
  contentStartedAt?: string;
  /**
   * Date and time when the user completed the content
   */
  contentCompletedAt?: string;
  /**
   * Date and time when the user last accessed this content
   */
  contentLastAccessedAt?: string;
  /**
   * The title of the content
   */
  contentTitle?: string;
  /**
   * Content duration in minutes
   */
  contentDurationMinutes?: number;
  /**
   * The content primary skill
   */
  contentSkill?: string;
  userNoEmailUser?: boolean;
  userUsername?: string;
  /**
   * Average completion percentage of the user for the current content
   */
  pctActivitiesCompleted?: number;
};

export type ImpactScorePrompt = {
  /**
   * The text of the prompt
   */
  promptText: string;
  /**
   * The number of respondents who agreed with the prompt
   */
  responseCount: number;
  /**
   * The percentage of respondents who agreed with the prompt
   */
  responsePct: number;
  textResponses: Array<TextResponse>;
};

export type TextResponse = {
  /**
   * A viewer's free-form text response to the prompt
   */
  text: string;
};

export type NavigationContents = Array<NavigationContent>;

export type NavigationContent = {
  /**
   * Path Action or TeamID.  See 'NavigationPathItems' for available paths
   */
  path: string;
  /**
   * Display text to show in sidebar
   */
  label: string;
  /**
   * (optional) Access to current option, unless set this value in 'false' only user for team hierarchy
   */
  enabled?: boolean;
  children?: Array<NavigationContent>;
};

export type V3Organization = {
  name: string;
  /**
   * A list of roles supported of current user
   */
  roles: Array<string>;
  /**
   * Whether current user has analytics access
   */
  analytics: boolean;
  /**
   * Whether current user has content assignments access
   */
  contentAssignments: boolean;
  teamsHierarchy: Array<TeamsHierarchy>;
};

export type TeamsHierarchy = {
  /**
   * The unique identifier of a team
   */
  id: string;
  /**
   * Display the team name
   */
  name: string;
  /**
   * A list of roles supported of current user for this team
   */
  roles: Array<string>;
  /**
   * License release date if the team is belongs to one.
   */
  launchDate: string;
  /**
   * Id of the parent team if exits
   */
  parentTeamId?: number;
  /**
   * Whether the team owns a license
   */
  ownsLicense?: boolean;
  /**
   * The team can serve as a data filter
   */
  filterable: boolean;
  /**
   * Whether the team supports filtering by revoked users
   */
  revokedUsersAvailable: boolean;
  tracking: {
    /**
     * Admin type for this team
     */
    adminType: string;
    /**
     * User permission for this team
     */
    adminPermission: string;
  };
  children: Array<TeamsHierarchy>;
};

export type EnterpriseLicenses = Array<EnterpriseLicense>;

export type EnterpriseLicense = {
  /**
   * Internal ID of the license
   */
  licenseId: number;
  /**
   * License Type.  See 'EnterpriseLicenseTypes' for available types
   */
  licenseType: string;
  /**
   * Number of seats available
   */
  quantity: number;
  /**
   * The date the license expires
   */
  expiresAt: string;
  /**
   * Cost per seat for the license, note that this is not available for all licenses
   */
  seatPrice?: number;
};

export type EnterpriseLicenseTypes = "trial" | "license" | "grant" | "demo";

export const EnterpriseLicenseTypes = {
  TRIAL: "trial",
  LICENSE: "license",
  GRANT: "grant",
  DEMO: "demo",
} as const;

export type V3Playlists = Array<V3Playlist>;

export type V3Playlist = {
  uuid: string;
  slug?: string;
  /**
   * The playlist title.
   */
  title: string;
  /**
   * Number of lessons included in the playlist.
   */
  totalLessons: number;
  creator?: {
    name?: string;
    email: string;
  };
  /**
   * The playlist description.
   */
  description?: string;
  /**
   * See 'PlaylistStatus' for available statuses
   */
  status: string;
  /**
   * The date the resource was created.
   */
  createdAt: string;
  /**
   * The date the resource was last updated.
   */
  updatedAt: string;
  primarySkill?: EnterprisePlaylistSkill;
  secondarySkill?: EnterprisePlaylistSkill;
  skills?: Array<EnterprisePlaylistSkill>;
  duration: number;
  assets?: {
    tall: PlaylistFile;
    wide: PlaylistFile;
    discussionGuide?: PlaylistFile;
  };
  visibleTo?: Array<{
    organization?: string;
    teams?: Array<string>;
  }>;
  isDeletionAllowed?: boolean;
};

export type EnterprisePlaylistSkill = {
  /**
   * uuid of the requested resource
   */
  uuid: string;
  /**
   * The name of the skill
   */
  name: string;
  slug?: string;
  /**
   * When skill has a parent, specified the uuid from it.
   */
  parentUuid?: string;
};

export type EnterprisePlaylistLesson = {
  /**
   * uuid of the requested resource
   */
  uuid: string;
  /**
   * The position in which the lesson is shown
   */
  position: number;
  image: Image;
  /**
   * The lesson name.
   */
  name: string;
  /**
   * The lesson description.
   */
  description?: string;
  /**
   * The instructor names involved in this lesson
   */
  instructors: string;
  /**
   * Lesson duration in seconds
   */
  duration: number;
  /**
   * See 'PlaylistStatus' for available statuses
   */
  status: string;
  isDeletionAllowed: boolean;
  /**
   * The date when the lesson was added to the playlist.
   */
  createdAt: string;
  /**
   * The content type of the lesson
   */
  contentType: string;
};

export type CreatePlaylist = {
  /**
   * The playlist title.
   */
  title: string;
  /**
   * The organization id to which the playlist belongs.
   */
  organizationId: string;
};

export type ReorderLessons = {
  lessons: Array<EnterprisePlaylistLessonOrder>;
};

export type CreatedPlaylist = {
  /**
   * The unique identifier of the playlist
   */
  uuid: string;
};

export type UpdatePlaylist = {
  /**
   * The playlist title.
   */
  title?: string;
  /**
   * The playlist description.
   */
  description?: string;
  playlistDiscussionGuide?: Blob | File;
  playlistTwoByThree?: Blob | File;
  playlistTwoByThreeAltText?: string;
  playlistPosterImage?: Blob | File;
  playlistPosterImageAltText?: string;
  /**
   * uuid of the primary skill
   */
  primarySkill?: string;
  /**
   * comma-separated list of skills uuids
   */
  secondarySkills?: string;
  removeDiscussionGuide?: boolean;
};

export type EnterprisePlaylistLessonOrder = {
  /**
   * The unique identifier of the lesson
   */
  uuid: string;
  /**
   * The position in which the lesson is shown
   */
  position: number;
};

export type PlaylistFile = {
  altText?: string;
  url: string;
  filename?: string;
};

export type EnterprisePlaylistAddLessons = {
  lessons: Array<EnterprisePlaylistNewLesson>;
};

export type EnterprisePlaylistNewLesson = {
  /**
   * The unique identifier of the lesson
   */
  uuid: string;
};

export type UpdateLesson = {
  /**
   * The lesson name.
   */
  name?: string;
  /**
   * The lesson description.
   */
  description?: string;
  /**
   * See 'PlaylistStatus' for available statuses
   */
  status?: string;
};

export type Program = {
  /**
   * The unique identifier of the program
   */
  uuid: string;
  /**
   * The program slug.
   */
  slug: string;
  details: {
    /**
     * The program title.
     */
    title: string;
    /**
     * The program subtitle.
     */
    subtitle: string;
    /**
     * The program about.
     */
    about: string;
    /**
     * The program duration.
     */
    duration: string;
    audience: string;
    bestFor: string;
  };
  userDetails: {
    /**
     * Determines whether the user has permission to share the program.
     */
    canAssign: boolean;
    /**
     * Indicates whether or not the user is enrolled in the program.
     */
    isEnrolled?: boolean;
    progress: ProgramUserDetailsProgress;
  };
  programBanner21x9?: Image;
  image1x1?: Image;
  programTile16x9?: Image;
  programBanner16x9?: Image;
  instructors?: Array<ProgramInstructor>;
  modules?: Array<ProgramModule>;
  adminResources?: Array<ProgramAdminResource>;
};

export type ProgramInstructor = {
  /**
   * The instructor name.
   */
  name: string;
  image: Image;
  /**
   * The instructor bio.
   */
  bio: string;
};

export type ProgramModule = {
  /**
   * The unique identifier of the session
   */
  uuid: string;
  /**
   * The position in which the module is shown
   */
  position?: number;
  /**
   * Number of activities included in the module.
   */
  totalActivities?: number;
  /**
   * The module duration.
   */
  duration?: string;
  /**
   * The module title.
   */
  title: string;
  /**
   * The module description.
   */
  description: string;
  competencies?: Array<{
    name: string;
    items: Array<string>;
  }>;
  /**
   * The slug of the session
   */
  slug: string;
  image?: Image;
  skills?: Array<string>;
  progress?: ProgramModuleProgress;
  resource?: ProgramModuleResource;
};

export type ProgramModuleProgress = {
  /**
   * See 'ProgramModuleStatus' for available statuses.
   */
  status: string;
  /**
   * The percentage in progress of the module
   */
  completedPercentage: number;
  buttonText?: string;
  /**
   * The task slug to resume or start the session.
   */
  moduleResumeTaskSlug?: string;
  /**
   * The task uuid to resume or start the session.
   */
  moduleResumeTaskUuid?: string;
};

export type ProgramUserDetailsProgress = {
  buttonText: string;
  /**
   * The session slug to resume or start the program.
   */
  programResumeCampSlug: string;
  /**
   * The task slug to resume or start the program.
   */
  programResumeTaskSlug: string;
};

export type ProgramAdminResource = {
  /**
   * The stage to which the resource belongs. See 'ProgramResourceStage' for possible values.
   */
  stage: string;
  /**
   * URL to download a zip file including all admin resources of the program stage.
   */
  url: string;
  buttonText: string;
  /**
   * A comma-separated string of document identifiers belonging to the resource.
   */
  documentIds?: string;
};

export type ProgramModuleResource = {
  /**
   * URL to download the resources of the module.
   */
  url: string;
  buttonText: string;
  /**
   * A comma-separated string of document identifiers belonging to the resource.
   */
  documentIds?: string;
};

/**
 * Describes the available navigation path items
 */
export type NavigationPathItems =
  | "overview"
  | "teams"
  | "shared-content"
  | "analytics"
  | "active-users"
  | "engagement"
  | "top-skills"
  | "top-courses"
  | "course-progress"
  | "member-leaderboard"
  | "playlists"
  | "customizations"
  | "logo"
  | "messaging";

export const NavigationPathItems =
  /**
   * Describes the available navigation path items
   */
  {
    OVERVIEW: "overview",
    TEAMS: "teams",
    SHARED_CONTENT: "shared-content",
    ANALYTICS: "analytics",
    ACTIVE_USERS: "active-users",
    ENGAGEMENT: "engagement",
    TOP_SKILLS: "top-skills",
    TOP_COURSES: "top-courses",
    COURSE_PROGRESS: "course-progress",
    MEMBER_LEADERBOARD: "member-leaderboard",
    PLAYLISTS: "playlists",
    CUSTOMIZATIONS: "customizations",
    LOGO: "logo",
    MESSAGING: "messaging",
  } as const;

/**
 * Describes the available assignee types
 */
export type AssigneeType = "Team" | "Member";

export const AssigneeType =
  /**
   * Describes the available assignee types
   */
  {
    TEAM: "Team",
    MEMBER: "Member",
  } as const;

/**
 * Describes the available detailed progress fields
 */
export type DetailedProgressFields =
  | "content_last_accessed_at"
  | "pct_completion"
  | "first_shared_by"
  | "first_shared_on"
  | "unshare"
  | "pct_activities_completed";

export const DetailedProgressFields =
  /**
   * Describes the available detailed progress fields
   */
  {
    CONTENT_LAST_ACCESSED_AT: "content_last_accessed_at",
    PCT_COMPLETION: "pct_completion",
    FIRST_SHARED_BY: "first_shared_by",
    FIRST_SHARED_ON: "first_shared_on",
    UNSHARE: "unshare",
    PCT_ACTIVITIES_COMPLETED: "pct_activities_completed",
  } as const;

/**
 * Describes the available admin roles
 */
export type AdminRoles = "management_admin" | "performance_admin";

export const AdminRoles =
  /**
   * Describes the available admin roles
   */
  {
    MANAGEMENT_ADMIN: "management_admin",
    PERFORMANCE_ADMIN: "performance_admin",
  } as const;

/**
 * Describes the available playlist statuses
 */
export type PlaylistStatus = "unavailable" | "available";

export const PlaylistStatus =
  /**
   * Describes the available playlist statuses
   */
  {
    UNAVAILABLE: "unavailable",
    AVAILABLE: "available",
  } as const;

/**
 * Describes the available program resource stages
 */
export type ProgramResourceStage = "before" | "along" | "after";

export const ProgramResourceStage =
  /**
   * Describes the available program resource stages
   */
  {
    BEFORE: "before",
    ALONG: "along",
    AFTER: "after",
  } as const;

/**
 * Describes the available program module statuses
 */
export type ProgramModuleStatus = "Not Started" | "In Progress" | "Done";

export const ProgramModuleStatus =
  /**
   * Describes the available program module statuses
   */
  {
    NOT_STARTED: "Not Started",
    IN_PROGRESS: "In Progress",
    DONE: "Done",
  } as const;

/**
 * Quote Request, requires either email and address OR discountCode
 */
export type EnterpriseQuoteRequest = {
  /**
   * First Name
   */
  firstName?: string;
  /**
   * Last Name
   */
  lastName?: string;
  /**
   * Email address of the prospective Customer
   */
  email?: string;
  address?: EnterpriseAddress;
  /**
   * Quanitity for the order
   */
  quantity: number;
  product: EnterpriseProduct;
  /**
   * Discount Code associated with the quote request
   */
  discountCode?: string;
};

/**
 * Addon Quote Request, requires licenseId and quantity
 */
export type EnterpriseAddonQuoteRequest = {
  /**
   * License ID of the license to be quoted
   */
  licenseId: number;
  /**
   * Quanitity for the order
   */
  quantity: number;
};

/**
 * Products available for purchase through self service
 */
export type EnterpriseProduct = "enterprise_license" | "bulk_code";

export const EnterpriseProduct =
  /**
   * Products available for purchase through self service
   */
  {
    ENTERPRISE_LICENSE: "enterprise_license",
    BULK_CODE: "bulk_code",
  } as const;

/**
 * Street Address
 */
export type EnterpriseAddress = {
  /**
   * first line of address
   */
  line1: string;
  /**
   * second line of address if required
   */
  line2?: string;
  /**
   * City
   */
  city: string;
  /**
   * State or Province
   */
  state: string;
  /**
   * Country
   */
  country: string;
  /**
   * Zip/Postal Code
   */
  postalCode: string;
};

/**
 * The quote generated for the customer
 */
export type EnterpriseQuote = {
  lineItems: Array<EnterpriseQuoteLineItem>;
  /**
   * Total cost before taxes
   */
  subtotal: number;
  discount?: EnterpriseQuoteComponent;
  tax: EnterpriseQuoteComponent;
  /**
   * Total cost
   */
  total: number;
};

/**
 * Line item for an enterprise quote
 */
export type EnterpriseQuoteLineItem = {
  /**
   * Item being purchased
   */
  product: string;
  /**
   * Number of items
   */
  quantity: number;
  /**
   * Cost of the item
   */
  unitPrice: number;
};

/**
 * Discount or Taxes associated with a quote
 */
export type EnterpriseQuoteComponent = {
  /**
   * Percentage of the discount or taxes
   */
  percent: number;
  /**
   * $ value of the discount or taxes
   */
  value: number;
};

/**
 * Addon Order Request, requires licenseId and quantity
 */
export type EnterpriseProcessAddonOrderRequest = {
  /**
   * License ID of the license to be quoted
   */
  licenseId: number;
  /**
   * Quanitity for the order
   */
  quantity: number;
  /**
   * Authentication token for the transaction
   */
  token: string;
  /**
   * country for payment processing
   */
  country: string;
  /**
   * postalCode for payment processing
   */
  postalCode: string;
};

/**
 * Order Request, requires email + address, or discountCode, along with payment tokens.
 */
export type EnterpriseProcessOrderRequest = {
  /**
   * First Name
   */
  firstName?: string;
  /**
   * Last Name
   */
  lastName?: string;
  /**
   * Email address of the prospective Customer
   */
  email?: string;
  address?: EnterpriseAddress;
  /**
   * Quantity for the order
   */
  quantity: number;
  product: EnterpriseProduct;
  /**
   * Discount Code associated with the order request
   */
  discountCode?: string;
  /**
   * Name of the organization
   */
  organizationName?: string;
  /**
   * payment type, credit card/wire
   */
  paymentType: "credit_card" | "wire";
  /**
   * Authentication token for the transaction
   */
  token?: string;
  /**
   * Card token for payment processing
   */
  cardToken?: string;
  /**
   * User agreed to consent to terms and conditions
   */
  userConsent: boolean;
  /**
   * Flag indicating this was an assisted order
   */
  assistedSelfServe?: boolean;
  /**
   * Payment method id for payment processing
   */
  paymentMethodId?: string;
  /**
   * Payment intent id for Stripe
   */
  paymentIntentId?: string;
  /**
   * Unique identifier for the zuora self order audit
   */
  selfServeOrderReferenceId?: string;
};

/**
 * The processed order details for the customer
 */
export type EnterpriseAddonOrder = {
  orderId: number;
  lineItems: Array<EnterpriseQuoteLineItem>;
  /**
   * Total cost before taxes
   */
  subtotal: number;
  discount?: EnterpriseQuoteComponent;
  tax: EnterpriseQuoteComponent;
  /**
   * Total cost
   */
  total: number;
};

/**
 * The processed order details for the customer
 */
export type EnterpriseOrder = {
  userId?: number;
  /**
   * Customer's email address
   */
  email?: string;
  lineItems?: Array<EnterpriseOrderLineItem>;
  /**
   * Total cost before taxes
   */
  orderSubtotal?: number;
  orderDiscount?: EnterpriseOrderComponent;
  orderTax?: EnterpriseOrderComponent;
  /**
   * Total cost
   */
  orderTotal?: number;
  /**
   * URL path for product activation
   */
  activationPath?: string;
  /**
   * Unique identifier for the order
   */
  orderId?: string;
  /**
   * Unique identifier for the zuora self order audit
   */
  selfServeOrderReferenceId?: string;
  /**
   * Flag indicating if the order requires action
   */
  requiresAction?: boolean;
  /**
   * URL for authentication redirect
   */
  authenticationRedirectUrl?: string;
  /**
   * Payment intent id for Stripe
   */
  paymentIntentId?: string;
  /**
   * Order status for 3Ds confimation
   */
  status3ds?: string;
};

export type EnterpriseOrderError = {
  errors?: Array<{
    status?: string;
    code?: string;
    title?: string;
  }>;
};

/**
 * Line item for an enterprise order
 */
export type EnterpriseOrderLineItem = {
  /**
   * Item being purchased
   */
  product: string;
  /**
   * Number of items
   */
  quantity: number;
  /**
   * Cost of the item
   */
  unitPrice: number;
};

/**
 * Discount or Taxes associated with an order
 */
export type EnterpriseOrderComponent = {
  /**
   * Percentage of the discount or taxes
   */
  percent: number;
  /**
   * $ value of the discount or taxes
   */
  value: number;
};

/**
 * The invoice details
 */
export type EnterpriseInvoice = {
  url: string;
};

/**
 * The current value of a filter; value type should match bounds type
 */
export type EnterpriseAnalyticsMetricFilterValue = {
  value: string;
  /**
   * (optional) The display value of the filter
   */
  label?: string;
};

/**
 * type of the EnterpriseAnalyticsMetricBounds
 */
export type EnterpriseAnalyticsMetricBoundsType =
  | "date_range"
  | "range"
  | "enum";

export const EnterpriseAnalyticsMetricBoundsType =
  /**
   * type of the EnterpriseAnalyticsMetricBounds
   */
  {
    DATE_RANGE: "date_range",
    RANGE: "range",
    ENUM: "enum",
  } as const;

/**
 * The maximum range of possible values for a filter
 */
export type EnterpriseAnalyticsMetricBounds = {
  /**
   * see EnterpriseAnalyticsMetricBoundsType for more information
   */
  type?: string;
  range?: EnterpriseAnalyticsMetricDateRangeBounds;
  enumBounds?: EnterpriseAnalyticsMetricEnumBounds;
};

/**
 * A bounds used to specify end points for a sortable range of data
 */
export type EnterpriseAnalyticsMetricDateRangeBounds = {
  options: [string, string];
};

/**
 * A bounds used to specify a list of discrete options
 */
export type EnterpriseAnalyticsMetricEnumBounds = {
  options: Array<{
    label: string;
    value: string;
  }>;
};

/**
 * the type of the EnterpriseAnalyticsRelationship
 */
export type EnterpriseAnalyticsRelationshipType = "content" | "skill" | "user";

export const EnterpriseAnalyticsRelationshipType =
  /**
   * the type of the EnterpriseAnalyticsRelationship
   */
  {
    CONTENT: "content",
    SKILL: "skill",
    USER: "user",
  } as const;

/**
 * additional data for enterprise analytics relationships
 */
export type EnterpriseAnalyticsRelationship = {
  /**
   * see EnterpriseAnalyticsRelationshipType
   */
  type?: string;
  content?: EnterpriseAnalyticsContent;
  skill?: EnterpriseAnalyticsSkill;
  user?: EnterpriseAnalyticsUser;
};

/**
 * additional data for content objects
 */
export type EnterpriseAnalyticsContent = {
  uuid: string;
  /**
   * type of content
   */
  contentType: string;
  title: string;
  subtitle: string;
  imageUrl?: string;
  primarySkill?: string;
};

/**
 * additional data for skill objects
 */
export type EnterpriseAnalyticsSkill = {
  uuid: string;
  slug: string;
  name: string;
};

/**
 * additional data for user objects
 */
export type EnterpriseAnalyticsUser = {
  uuid: string;
  email: string;
  displayName?: string;
  displayName1Line: string;
  username?: string;
  noEmailUser?: boolean;
};

export type EnterpriseAnalyticsFilterKey =
  | "from_date"
  | "to_date"
  | "interval"
  | "skill_uuid"
  | "include_revoked_members";

export const EnterpriseAnalyticsFilterKey = {
  FROM_DATE: "from_date",
  TO_DATE: "to_date",
  INTERVAL: "interval",
  SKILL_UUID: "skill_uuid",
  INCLUDE_REVOKED_MEMBERS: "include_revoked_members",
} as const;

export type EnterpriseAnalyticsFilterInterval =
  | "day"
  | "week"
  | "month"
  | "quarter";

export const EnterpriseAnalyticsFilterInterval = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  QUARTER: "quarter",
} as const;

export type EnterpriseAnalyticsCsvSlug =
  | "activity_overview_csv"
  | "user_activity_time_series_csv"
  | "course_progress_csv"
  | "top_courses_csv"
  | "top_skills_csv"
  | "user_course_progress_csv";

export const EnterpriseAnalyticsCsvSlug = {
  ACTIVITY_OVERVIEW_CSV: "activity_overview_csv",
  USER_ACTIVITY_TIME_SERIES_CSV: "user_activity_time_series_csv",
  COURSE_PROGRESS_CSV: "course_progress_csv",
  TOP_COURSES_CSV: "top_courses_csv",
  TOP_SKILLS_CSV: "top_skills_csv",
  USER_COURSE_PROGRESS_CSV: "user_course_progress_csv",
} as const;

export type EnterpriseAnalyticsMetricSlug =
  | "activity_overview"
  | "avg_num_minutes_watched_time_series"
  | "num_minutes_watched_time_series"
  | "num_unique_active_users_time_series"
  | "top_courses"
  | "top_skills"
  | "top_users";

export const EnterpriseAnalyticsMetricSlug = {
  ACTIVITY_OVERVIEW: "activity_overview",
  AVG_NUM_MINUTES_WATCHED_TIME_SERIES: "avg_num_minutes_watched_time_series",
  NUM_MINUTES_WATCHED_TIME_SERIES: "num_minutes_watched_time_series",
  NUM_UNIQUE_ACTIVE_USERS_TIME_SERIES: "num_unique_active_users_time_series",
  TOP_COURSES: "top_courses",
  TOP_SKILLS: "top_skills",
  TOP_USERS: "top_users",
} as const;

export type EnterpriseAnalyticsMetric = {
  errors?: EnterpriseAnalyticsMetricErrors;
  meta: EnterpriseAnalyticsMetricMeta;
  data?: {
    rows: Array<Array<string>>;
    columns: EnterpriseAnalyticsMetricColumns;
  };
  relationships?: EnterpriseAnalyticsMetricRelationships;
};

export type EnterpriseAnalyticsMetricColumns = Array<{
  name: string;
}>;

/**
 * Only returned if data is not returned
 */
export type EnterpriseAnalyticsMetricErrors = Array<{
  /**
   * Machine-readable key that indicates the type of error. May be used to conditionally show client-side error states.
   */
  name: string;
  /**
   * Human-readable error message
   */
  message: string;
}>;

export type EnterpriseAnalyticsMetricMeta = {
  slug: string;
  filters: Array<{
    name: string;
    value?: EnterpriseAnalyticsMetricFilterValue;
    bounds: EnterpriseAnalyticsMetricBounds;
  }>;
  /**
   * See EnterpriseAnalyticsMetricEmptyValueDescription
   */
  emptyValueDescription?: string;
};

/**
 * additional data for enterprise analytics metrics object identifiers
 */
export type EnterpriseAnalyticsMetricRelationships =
  Array<EnterpriseAnalyticsRelationship>;

/**
 * Explain the empty values in metrics data
 */
export type EnterpriseAnalyticsMetricEmptyValueDescription =
  | "no-data"
  | "no-data-in-range"
  | "privacy-protection";

export const EnterpriseAnalyticsMetricEmptyValueDescription =
  /**
   * Explain the empty values in metrics data
   */
  {
    NO_DATA: "no-data",
    NO_DATA_IN_RANGE: "no-data-in-range",
    PRIVACY_PROTECTION: "privacy-protection",
  } as const;

export type EnterpriseAnalyticsGenerateCsvReportJobMetric = {
  /**
   * See EnterpriseAnalyticsCsvSlug for values
   */
  slug: string;
  /**
   * key-value pairs of filters. See EnterpriseAnalyticsFilterKey for more information.
   */
  filters?: {
    [key: string]: unknown;
  };
};

export type EnterpriseAnalyticsGenerateCsvReportJobRequest = {
  /**
   * team id
   */
  teamId: string;
  metric: EnterpriseAnalyticsGenerateCsvReportJobMetric;
};

export type EnterpriseAnalyticsGenerateCsvReportJobResponse = {
  /**
   * Job identifier
   */
  uuid?: string;
  /**
   * see EnterpriseAnalyticsGenerateCsvReportJobStatus
   */
  status?: string;
  /**
   * pre-signed S3 link to the generated report
   */
  link?: string;
  /**
   * team id
   */
  teamId?: string;
  metric?: EnterpriseAnalyticsGenerateCsvReportJobMetric;
};

/**
 * EnterpriseAnalyticsGenerateCsvReportJob status
 */
export type EnterpriseAnalyticsGenerateCsvReportJobStatus =
  | "pending"
  | "successful"
  | "failed";

export const EnterpriseAnalyticsGenerateCsvReportJobStatus =
  /**
   * EnterpriseAnalyticsGenerateCsvReportJob status
   */
  {
    PENDING: "pending",
    SUCCESSFUL: "successful",
    FAILED: "failed",
  } as const;

export type V3ContentRow = {
  id: number;
  slug: string;
  uuid?: string;
  apiType: string;
  analytics: {
    [key: string]: string;
  };
  refreshNeeded: boolean;
  uiConfig: V3ContentRowUiConfig;
  experiments?: {
    [key: string]: string;
  };
  items: Array<V3ContentRowItem>;
};

export type V3ContentRows = Array<V3ContentRow>;

export type V3ContentRowItem = {
  itemUuid: string;
  /**
   * See `ContentRowTileType` for available types.
   */
  tileType: string;
  default?: ContentRowCarouselTile;
  assignment?: AssignmentCarouselTile;
  dailySkillTrack?: DailySkillTrackCarouselTile;
  continueWatching?: ContentRowCarouselTile;
  insight?: CollectionTile;
  quizCollection?: CollectionTile;
  takeawayCollection?: CollectionTile;
  audioCollection?: CollectionTile;
  shortVideoCollection?: CollectionTile;
  thumbnail?: ContentRowCarouselTile;
  imageBanner?: ImageBannerTile;
  interactiveHero?: InteractiveHeroTile;
  androidEngage?: AndroidEngageTile;
  info?: InfoTile;
};

export type ContentRowTileType =
  | "DefaultTile"
  | "DailySkillTrackTile"
  | "AssignmentTile"
  | "ContinueWatchingTile"
  | "CollectionTile"
  | "ThumbnailTile"
  | "TakeawayCollectionTile"
  | "QuizCollectionTile"
  | "AudioCollectionTile"
  | "ShortVideoCollectionTile"
  | "ImageBannerTile"
  | "InteractiveHeroTile"
  | "AndroidEngageTile"
  | "InfoTile";

export const ContentRowTileType = {
  DEFAULT_TILE: "DefaultTile",
  DAILY_SKILL_TRACK_TILE: "DailySkillTrackTile",
  ASSIGNMENT_TILE: "AssignmentTile",
  CONTINUE_WATCHING_TILE: "ContinueWatchingTile",
  COLLECTION_TILE: "CollectionTile",
  THUMBNAIL_TILE: "ThumbnailTile",
  TAKEAWAY_COLLECTION_TILE: "TakeawayCollectionTile",
  QUIZ_COLLECTION_TILE: "QuizCollectionTile",
  AUDIO_COLLECTION_TILE: "AudioCollectionTile",
  SHORT_VIDEO_COLLECTION_TILE: "ShortVideoCollectionTile",
  IMAGE_BANNER_TILE: "ImageBannerTile",
  INTERACTIVE_HERO_TILE: "InteractiveHeroTile",
  ANDROID_ENGAGE_TILE: "AndroidEngageTile",
  INFO_TILE: "InfoTile",
} as const;

export type ContentRowEntitySubtype = "episode" | "series";

export const ContentRowEntitySubtype = {
  EPISODE: "episode",
  SERIES: "series",
} as const;

export type V3ContentRowEntityType =
  | "camp"
  | "camp_task"
  | "chapter"
  | "course"
  | "custom"
  | "playlist"
  | "track"
  | "collection_part"
  | "audio_part"
  | "quiz_part"
  | "short_video_part"
  | "takeaway_part"
  | "program"
  | "certificate_program";

export const V3ContentRowEntityType = {
  CAMP: "camp",
  CAMP_TASK: "camp_task",
  CHAPTER: "chapter",
  COURSE: "course",
  CUSTOM: "custom",
  PLAYLIST: "playlist",
  TRACK: "track",
  COLLECTION_PART: "collection_part",
  AUDIO_PART: "audio_part",
  QUIZ_PART: "quiz_part",
  SHORT_VIDEO_PART: "short_video_part",
  TAKEAWAY_PART: "takeaway_part",
  PROGRAM: "program",
  CERTIFICATE_PROGRAM: "certificate_program",
} as const;

export type V3ContentRowUiConfig = {
  /**
   * See the `ContentRowUiConfigType` enum for list of values.
   */
  type: string;
  attributes?: V3ContentRowUiConfigAttributes;
};

export type V3ContentRowUiConfigAttributes = ContentRowTileAttributes &
  ContentRowTitleAttributes & {
    carousel?: ContentRowCarouselAttributes;
    grid?: ContentRowGridAttributes;
  };

export type ContentRowUiConfigTileTextPlacement =
  | "bottom"
  | "top"
  | "right"
  | "left";

export const ContentRowUiConfigTileTextPlacement = {
  BOTTOM: "bottom",
  TOP: "top",
  RIGHT: "right",
  LEFT: "left",
} as const;

export type ContentRowUiConfigTileClickTarget =
  | "same_tab"
  | "new_tab"
  | "new_window"
  | "modal";

export const ContentRowUiConfigTileClickTarget = {
  SAME_TAB: "same_tab",
  NEW_TAB: "new_tab",
  NEW_WINDOW: "new_window",
  MODAL: "modal",
} as const;

export type V3ContentRowUiConfigType =
  | "assignment_carousel"
  | "banner"
  | "carousel"
  | "enterprise_banner"
  | "grid"
  | "hidden"
  | "library_banner"
  | "list"
  | "looking_for_more_banner"
  | "daily_moments"
  | "collections";

export const V3ContentRowUiConfigType = {
  ASSIGNMENT_CAROUSEL: "assignment_carousel",
  BANNER: "banner",
  CAROUSEL: "carousel",
  ENTERPRISE_BANNER: "enterprise_banner",
  GRID: "grid",
  HIDDEN: "hidden",
  LIBRARY_BANNER: "library_banner",
  LIST: "list",
  LOOKING_FOR_MORE_BANNER: "looking_for_more_banner",
  DAILY_MOMENTS: "daily_moments",
  COLLECTIONS: "collections",
} as const;

export type ContentRowCarouselTile = {
  analytics?: {
    [key: string]: string;
  };
  title?: string;
  subtitle?: string;
  caption?: string;
  logo?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
  progress?: number;
  progressInSeconds?: number;
  topRightPill?: Pill;
  bottomRightPill?: Pill;
  topLeftPill?: Pill;
  bottomLeftPill?: Pill;
  tags?: Array<Tag>;
  images?: {
    primary16x9?: string;
    primary2x3?: string;
    primary1x1?: string;
    cinematic16x9?: string;
    outcome16x9?: string;
    currentProgress16x9?: string;
    nameplate?: string;
    manual?: string;
  };
  /**
   * This field is replaced by the `media` field.
   * This field will be deprecated soon, as part of the CMS video migration project.
   *
   */
  videos?: {
    trailer16x9?: string;
    currentProgress16x9?: string;
    manual?: string;
  };
  /**
   * This field is the new field to replace the `videos` field. The attribute names are the same as `videos`, but the
   * value is an object with `brightcoveVideoId` and `mediaUuid` attributes, to align with the conventional implementation.
   *
   */
  media?: {
    trailer16x9?: {
      /**
       * The unique identifier for the brightcove video content.
       * Use this brightcove video ID to fetch metdata from Brightcove.
       * This will be deprecated in the future.
       *
       */
      brightcoveVideoId?: string;
      /**
       * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
       *
       */
      mediaUuid?: string;
    };
    currentProgress16x9?: {
      /**
       * The unique identifier for the brightcove video content.
       * Use this brightcove video ID to fetch metdata from Brightcove.
       * This will be deprecated in the future.
       *
       */
      brightcoveVideoId?: string;
      /**
       * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
       *
       */
      mediaUuid?: string;
    };
    manual?: {
      /**
       * The unique identifier for the brightcove video content.
       * Use this brightcove video ID to fetch metdata from Brightcove.
       * This will be deprecated in the future.
       *
       */
      brightcoveVideoId?: string;
      /**
       * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
       *
       */
      mediaUuid?: string;
    };
  };
  tileClickRedirect?: string;
  watchNowRedirect?: string;
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
    entityChapterId?: number;
  };
  overlay?: {
    text?: string;
    setReminder?: boolean;
  };
  recommendedSource?: RecommendedSource;
  logoNonOverlay?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
};

export type AssignmentCarouselTile = {
  entityUuid?: string;
  title?: string;
  subtitle?: string;
  caption?: string;
  logo?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
  progressDetails?: {
    isComplete?: boolean;
    barPercentage?: number;
    progressText?: string;
    /**
     * The time the content was completed.
     */
    completedAt?: string;
  };
  images?: {
    primary1x1?: string;
    primary2x3?: string;
    primary16x9?: string;
  };
  tileClickRedirect?: string;
  assignerDisplayName?: string;
  /**
   * The time the content was assigned.
   */
  assignedAt?: string;
  assignedOn?: string;
  message?: string;
  resource?: {
    entityId?: number;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
  };
  analytics?: {
    [key: string]: string;
  };
};

export type DefaultTile = ContentRowCarouselTile;

export type DailySkillTrackCarouselTile = {
  tileType?: string;
  analytics?: {
    [key: string]: string;
  };
  title?: string;
  subtitle?: string;
  caption?: string;
  duration?: string;
  progress?: number;
  images?: {
    primary16x9?: string;
    primary2x3?: string;
    manual?: string;
  };
  tileClickRedirect?: string;
  resource?: {
    entityId?: number;
    entitySlug?: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
    playlistId?: string;
  };
};

export type V3PillKind =
  | "default"
  | "dim"
  | "transparent"
  | "primary"
  | "utility"
  | "announce";

export const V3PillKind = {
  DEFAULT: "default",
  DIM: "dim",
  TRANSPARENT: "transparent",
  PRIMARY: "primary",
  UTILITY: "utility",
  ANNOUNCE: "announce",
} as const;

export type TagSlugValue = "activities" | "community";

export const TagSlugValue = {
  ACTIVITIES: "activities",
  COMMUNITY: "community",
} as const;

export type Tag = {
  slug: string;
  /**
   * Name of the tag
   */
  name: string;
};

export type CollectionTile = {
  /**
   * The type of the tile.
   */
  type?: string;
  collectionUuid: string;
  collectionSlug?: string;
  partUuid?: string;
  partSlug?: string;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  loadingColor?: string;
  /**
   * For accessibility.
   */
  altText?: string;
  tileClickRedirect?: string;
  analytics?: {
    [key: string]: string;
  };
  /**
   * Freeform text representing status like New or Featured
   */
  pillText?: string;
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
  };
  /**
   * Object to show the data under the image
   */
  footer?: {
    image?: CollectionImage;
    /**
     * HTML representaton of the styled text.
     */
    text?: string;
    /**
     * Redirects to CDP.
     */
    clickRedirect?: string;
  };
  progress?: {
    resumePartUuid?: string;
    isComplete?: boolean;
    barPercentage?: number;
    resumeCardUuid?: string;
  };
  background?: CollectionImage;
  /**
   * See `FrontCoverTemplateTypes` for values
   */
  templateType?: string;
  collection?: CollectionTileContent;
  quiz?: QuizCollectionTileContent;
  takeaway?: TakeawayCollectionTileContent;
  audio?: AudioCollectionTileContent;
  short?: ShortVideoCollectionTileContent;
};

export type CollectionTileContent = {
  images?: {
    nameplate?: CollectionImage;
  };
};

export type QuizCollectionTileContent = {
  images?: {
    instructor?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    quizCta?: string;
  };
};

export type TakeawayCollectionTileContent = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    subtitle?: string;
  };
};

export type AudioCollectionTileContent = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    duration?: string;
  };
};

export type ShortVideoCollectionTileContent = {
  video?: MediaItem;
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    duration?: string;
  };
};

export type CollectionImage = {
  /**
   * URL of the image
   */
  url?: string;
  height?: number;
  width?: number;
};

export type FrontCoverTemplateTypes =
  | "CollectionTileContent"
  | "QuizCollectionTileContent"
  | "TakeawayCollectionTileContent"
  | "AudioCollectionTileContent"
  | "ShortVideoCollectionTileContent";

export const FrontCoverTemplateTypes = {
  COLLECTION_TILE_CONTENT: "CollectionTileContent",
  QUIZ_COLLECTION_TILE_CONTENT: "QuizCollectionTileContent",
  TAKEAWAY_COLLECTION_TILE_CONTENT: "TakeawayCollectionTileContent",
  AUDIO_COLLECTION_TILE_CONTENT: "AudioCollectionTileContent",
  SHORT_VIDEO_COLLECTION_TILE_CONTENT: "ShortVideoCollectionTileContent",
} as const;

export type ImageBannerTile = {
  tileType?: string;
  entityUuid?: string;
  images?: {
    primary16x9?: string;
  };
  description?: string;
  logo?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
  attributesMap?: Array<{
    key?: string;
    value?: string;
  }>;
  tagsContent?: {
    label?: string;
    tags?: Array<Tag>;
  };
  mainBadge?: string;
  tileClickRedirect?: string;
  ctaText?: string;
  ctaAltText?: string;
  analytics?: {
    [key: string]: string;
  };
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
  };
};

export type InteractiveHeroTile = {
  tileType?: string;
  analytics?: {
    [key: string]: string;
  };
  texts: {
    /**
     * Text that has to be displayed instead of a nameplate image.
     */
    title?: string;
    caption?: string;
    altText?: string;
  };
  images: {
    tile2x3?: string;
    tile16x9?: string;
    nameplate?: string;
  };
  ctas?: {
    tileCtaUrl?: string;
    playCta?: {
      text?: string;
      url?: string;
      analytics?: {
        [key: string]: string;
      };
    };
    updateInListCta?: {
      text?: string;
      isAdded?: boolean;
      analytics?: {
        [key: string]: string;
      };
    };
  };
  pills?: {
    topRightPill?: Pill;
  };
  resource?: {
    entityUuid: string;
    entityId: number;
    entitySlug: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
  };
};

export type AndroidEngageTile = {
  tileType?: string;
  title?: string;
  subtitle?: string;
  images?: {
    primary16x9?: string;
    primary2x3?: string;
    primary1x1?: string;
    currentProgress16x9?: string;
  };
  playbackRedirect?: string;
  detailsRedirect?: string;
  /**
   * Unix timestamp in milliseconds indicating when the content became available.
   */
  availableAt?: number;
  /**
   * Duration of the content in seconds.
   */
  duration?: number;
  genre?: string;
  /**
   * Progress of the content as a percentage.
   */
  progress?: number;
  /**
   * Progress of the content in seconds.
   */
  progressInSeconds?: number;
  /**
   * Unix timestamp in milliseconds indicating the last time the user engaged with the content.
   */
  lastEngagementTime?: number;
  analytics?: {
    [key: string]: string;
  };
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
  };
};

export type InfoTileCtaStyle = "primary" | "secondary" | "consent";

export const InfoTileCtaStyle = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  CONSENT: "consent",
} as const;

export type InfoTileCtaIntent = "redirect" | "share" | "track_event";

export const InfoTileCtaIntent = {
  REDIRECT: "redirect",
  SHARE: "share",
  TRACK_EVENT: "track_event",
} as const;

export type InfoTileStyle = "default" | "card";

export const InfoTileStyle = {
  DEFAULT: "default",
  CARD: "card",
} as const;

export type InfoTileImageAspectRatio = "16x9" | "1x1" | "2x3";

export const InfoTileImageAspectRatio = {
  _16X9: "16x9",
  _1X1: "1x1",
  _2X3: "2x3",
} as const;

export type InfoTileTitleSize = "header_l" | "header_m" | "header_s";

export const InfoTileTitleSize = {
  HEADER_L: "header_l",
  HEADER_M: "header_m",
  HEADER_S: "header_s",
} as const;

export type InfoTileBodySize = "body_l" | "body_m" | "body_s";

export const InfoTileBodySize = {
  BODY_L: "body_l",
  BODY_M: "body_m",
  BODY_S: "body_s",
} as const;

export type InfoTileCtaLayout = "vertical" | "horizontal";

export const InfoTileCtaLayout = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
} as const;

export type InfoTile = {
  tileType?: string;
  title?: string;
  body?: Array<string>;
  caption?: string;
  images?: {
    primary?: string;
  };
  ctas?: Array<{
    text: string;
    link?: string;
    /**
     * See `InfoTileCtaStyle` for a list of currently supported values.
     */
    style: string;
    /**
     * See `InfoTileCtaIntent` for a list of currently supported values.
     */
    intent: string;
    /**
     * Present only if style is consent
     */
    consent?: {
      /**
       * Whether consent is required to proceed with the action.
       */
      isRequired?: boolean;
      /**
       * Text to display for the consent checkbox.
       */
      text?: string;
    };
    analytics?: {
      [key: string]: string;
    };
  }>;
  uiConfig?: {
    /**
     * See `InfoTileStyle` for a list of currently supported values.
     */
    tileStyle?: string;
    /**
     * See `InfoTileImageAspectRatio` for a list of currently supported values.
     */
    primaryImageAspectRatio?: string;
    /**
     * See `InfoTileTitleSize` for a list of currently supported values.
     */
    titleSize?: string;
    /**
     * See `InfoTileBodySize` for a list of currently supported values.
     */
    bodySize?: string;
    /**
     * See `InfoTileCtaLayout` for a list of currently supported values.
     */
    ctaLayout?: string;
  };
  analytics?: {
    [key: string]: string;
  };
};

export type UniqueIdentifiersResponse = {
  /**
   * uuid of the requested resource.
   */
  uuid: string;
};

export type MyListItem = {
  uuid: string;
};

export type HomepageLayout = {
  navigation: Navigation;
};

export type Navigation = {
  items: Array<NavigationItem>;
};

export type NavigationItem = {
  position: number;
  /**
   * References to a content row bundle location
   */
  bundle: string;
  display: NavigationItemDisplay;
  analytics: {
    [key: string]: string;
  };
};

export type NavigationItemDisplay = {
  name: string;
};

export type SemanticSearchClassFormat = "Course" | "SeriesCourse" | "Camp";

export const SemanticSearchClassFormat = {
  COURSE: "Course",
  SERIES_COURSE: "SeriesCourse",
  CAMP: "Camp",
} as const;

export type SemanticSearchResponse = {
  search?: string;
  watchBundleUuid?: string;
  results?: Array<SemanticSearchResult>;
};

export type SemanticSearchResult = {
  chunkUuid?: string;
  /**
   * The semantic relevance of the answer. The lower the number, the more relevant the answer is likely to be.
   */
  distance?: number;
  /**
   * Refer to `SemanticSearchClassFormat` for the set of values.
   */
  classFormat?: string;
  /**
   * The id of the `Course` that the answer is found in.
   */
  classId?: number;
  courseTitle?: string;
  chapterTitle?: string;
  /**
   * The id of the `Chapter` that the answer is found in.
   */
  contentId?: number;
  courseUrl?: string;
  chapterUrl?: string;
  thumbUrl?: string;
  instructors?: string;
  /**
   * The point in the video the answer starts.
   */
  startSecs?: number;
  /**
   * The point in the video the answer ends.
   */
  endSecs?: number;
  /**
   * Description of the content
   */
  text?: string;
};

export type UpdateType = "Valid" | "Forced" | "Unsupported";

export const UpdateType = {
  VALID: "Valid",
  FORCED: "Forced",
  UNSUPPORTED: "Unsupported",
} as const;

export type AppData = {
  update: Update;
};

export type Update = {
  /**
   * Check "UpdateType" for enum values
   */
  status: string;
  message?: string;
};

export type CareerGoalValue =
  | "team_member"
  | "team_leader"
  | "senior_leadership"
  | "unsure";

export const CareerGoalValue = {
  TEAM_MEMBER: "team_member",
  TEAM_LEADER: "team_leader",
  SENIOR_LEADERSHIP: "senior_leadership",
  UNSURE: "unsure",
} as const;

export type LearningPreferences = {
  /**
   * enum key for the goal. For the list of enums, check CareerGoalValue
   */
  careerGoal?: string;
  skills?: Array<string>;
  subskills?: Array<string>;
};

export type CareerGoal = {
  slug: string;
  text?: string;
  description?: string;
  isSelected?: boolean;
};

export type CareerGoalPage = {
  title: string;
  subtitle: string;
  careerGoals: Array<CareerGoal>;
};

export type Subskill = {
  uuid: string;
  text: string;
  isSelected: boolean;
};

export type V3Skill = {
  uuid: string;
  iconSlug: string;
  text?: string;
  fadedText?: string;
  isSelected?: boolean;
  subskills?: Array<Subskill>;
};

export type SkillsPage = {
  title: string;
  subtitle: string;
  skills: Array<V3Skill>;
};

export type SubskillsPage = {
  title: string;
  subtitle: string;
  skills: Array<V3Skill>;
};

export type TabContent = {
  navigation?: TabContentNavigation;
  title?: Text;
  /**
   * Used to drive the career skill text
   */
  isCareerSkill?: boolean;
  goal?: Text;
  subNavigation?: SubNavigation;
  skillProgresses?: SkillProgresses;
  subSkillProgresses?: SubSkillProgresses;
  analytics?: {
    [key: string]: string;
  };
};

export type TabContentNavigation = {
  /**
   * default text to present if the navigation is a collapsable
   */
  defaultText?: string;
  items: Array<TabContentNavigationItem>;
};

export type SubNavigation = {
  items: Array<SubNavigationItem>;
};

export type SkillProgresses = {
  items: Array<SkillProgressesItem>;
};

/**
 * Sorted list of subskill progress
 */
export type SubSkillProgresses = {
  items: Array<SubSkillProgressesItem>;
};

export type Text = {
  text?: string;
};

/**
 * Parameters used to call content rows API
 */
export type ContentRowParams = {
  /**
   * References to a content row bundle location
   */
  bundle?: string;
  /**
   * Row reference id
   */
  referenceUuid?: string;
};

/**
 * Parameters used to call tab-content API
 */
export type TabContentParams = {
  /**
   * References to a navigation item
   */
  navigation?: string;
};

export type TabContentNavigationItem = {
  cta?: NavigationCta;
  display: Text;
  analytics: {
    [key: string]: string;
  };
};

export type SubNavigationItem = {
  cta?: ContentRowCta;
  display: Text;
  analytics: {
    [key: string]: string;
  };
};

export type SkillProgressesItem = {
  text: string;
  value: string;
  cta?: NavigationCta;
  analytics?: {
    [key: string]: string;
  };
};

export type SubSkillProgressesItem = {
  text: string;
  value: string;
  isSelected?: boolean;
};

export type NavigationCta = {
  contentRowParams?: ContentRowParams;
  tabContentParams?: TabContentParams;
};

export type ContentRowCta = {
  contentRowParams?: ContentRowParams;
};

export type Collection = {
  /**
   * The universally unique identifier.
   */
  uuid: string;
  /**
   * The slug used for friendly page links.
   */
  slug: string;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  loadingColor?: string;
  /**
   * This field is deprecated and replaced by the backgroundAudio MediaItem.
   *
   * @deprecated
   */
  backgroundMediaAudioUuid?: string;
  /**
   * This field is deprecated and replaced by the backgroundAudio MediaItem.
   *
   * @deprecated
   */
  backgroundBrightcoveAudioId?: string;
  backgroundAudio?: MediaItem;
  /**
   * Max volume for background audio.
   */
  maxVolume?: number;
  /**
   * Background audio volume on video cards.
   */
  ambientVolumeInVideoCard?: number;
  /**
   * See `CollectionTypes` enum for values.
   */
  collectionType?: string;
  parts: Array<CollectionPart>;
};

export type CollectionTypes =
  | "Collection"
  | "Collection::Takeaway"
  | "Collection::Audio"
  | "Collection::ShortVideo"
  | "Collection::Quiz"
  | "Collection::Onboarding";

export const CollectionTypes = {
  COLLECTION: "Collection",
  COLLECTION__TAKEAWAY: "Collection::Takeaway",
  COLLECTION__AUDIO: "Collection::Audio",
  COLLECTION__SHORT_VIDEO: "Collection::ShortVideo",
  COLLECTION__QUIZ: "Collection::Quiz",
  COLLECTION__ONBOARDING: "Collection::Onboarding",
} as const;

export type CollectionPart = {
  /**
   * The universally unique identifier.
   */
  uuid: string;
  /**
   * The slug used for friendly page links.
   */
  slug: string;
  /**
   * CollectionPart position within the Collection.
   */
  position?: number;
  analytics?: {
    [key: string]: string;
  };
  cards?: Array<
    CollectionPartCard & {
      partCover?: CollectionTemplatePartCover;
      textOnly?: CollectionTemplateTextOnly;
      imageTop?: CollectionTemplateImageTop;
      imageBottom?: CollectionTemplateImageBottom;
      fullScreenImage?: CollectionTemplateFullScreenImage;
      quote?: CollectionTemplateQuote;
      framing?: CollectionTemplateFraming;
      quiz?: CollectionTemplateQuiz;
      videoSetup?: CollectionTemplateVideoSetup;
      list?: CollectionTemplateList;
      partEnd?: CollectionTemplatePartEnd;
      shortVideo?: CollectionTemplateShortVideo;
      audio?: CollectionTemplateAudio;
      partendWithLinks?: CollectionTemplatePartEndWithLinks;
      takeaway?: CollectionTemplateTakeawayText;
      quizCoverCard?: CollectionTemplateQuizCover;
      onboardingSelection?: CollectionTemplateOnboardingSelection;
      quizArticle?: CollectionTemplateQuizArticle;
      compactPartCover?: CollectionTemplateCompactPartCover;
    }
  >;
};

export type CollectionPartCard = {
  /**
   * The universally unique identifier.
   */
  uuid: string;
  /**
   * The slug used for friendly page links.
   */
  slug: string;
  /**
   * For values see `CollectionPartCardType`.
   */
  type: string;
  /**
   * Hex value of the color
   */
  backgroundColor?: string;
  /**
   * CollectionPartCard position within the CollectionPart.
   */
  position?: number;
  backgroundImage?: CollectionImage;
  analytics?: {
    [key: string]: string;
  };
};

export type CollectionPartCardType =
  | "PartCover"
  | "TextOnly"
  | "ImageTop"
  | "ImageBottom"
  | "FullScreenImage"
  | "Quote"
  | "Framing"
  | "Quiz"
  | "VideoSetup"
  | "List"
  | "PartEnd"
  | "ShortVideo"
  | "Audio"
  | "PartEndWithLinks"
  | "Takeaway"
  | "QuizCover"
  | "OnboardingSelection"
  | "QuizArticle"
  | "CompactPartCover";

export const CollectionPartCardType = {
  PART_COVER: "PartCover",
  TEXT_ONLY: "TextOnly",
  IMAGE_TOP: "ImageTop",
  IMAGE_BOTTOM: "ImageBottom",
  FULL_SCREEN_IMAGE: "FullScreenImage",
  QUOTE: "Quote",
  FRAMING: "Framing",
  QUIZ: "Quiz",
  VIDEO_SETUP: "VideoSetup",
  LIST: "List",
  PART_END: "PartEnd",
  SHORT_VIDEO: "ShortVideo",
  AUDIO: "Audio",
  PART_END_WITH_LINKS: "PartEndWithLinks",
  TAKEAWAY: "Takeaway",
  QUIZ_COVER: "QuizCover",
  ONBOARDING_SELECTION: "OnboardingSelection",
  QUIZ_ARTICLE: "QuizArticle",
  COMPACT_PART_COVER: "CompactPartCover",
} as const;

export type CollectionQuizCardType =
  | "PartCover"
  | "TextOnly"
  | "ImageTop"
  | "ImageBottom"
  | "FullScreenImage"
  | "Quote"
  | "Framing"
  | "InlineAnswer"
  | "VideoSetup"
  | "List"
  | "PartEnd";

export const CollectionQuizCardType = {
  PART_COVER: "PartCover",
  TEXT_ONLY: "TextOnly",
  IMAGE_TOP: "ImageTop",
  IMAGE_BOTTOM: "ImageBottom",
  FULL_SCREEN_IMAGE: "FullScreenImage",
  QUOTE: "Quote",
  FRAMING: "Framing",
  INLINE_ANSWER: "InlineAnswer",
  VIDEO_SETUP: "VideoSetup",
  LIST: "List",
  PART_END: "PartEnd",
} as const;

export type CollectionTemplatePartCover = {
  images?: {
    separatorIcon?: CollectionImage;
    instructors?: CollectionImage;
    nameplate?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    instructorsLabel?: string;
    /**
     * HTML representaton of the styled text.
     */
    description?: string;
  };
};

export type CollectionTemplateCompactPartCover = {
  images?: {
    instructors?: CollectionImage;
    nameplate?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    instructorsLabel?: string;
  };
};

export type CollectionTemplateTextOnly = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    header1?: string;
    /**
     * HTML representaton of the styled text.
     */
    header2?: string;
  };
  images?: {
    separatorIcon?: CollectionImage;
  };
};

export type CollectionTemplateImageTop = {
  images?: {
    assetImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    header?: string;
    /**
     * HTML representaton of the styled text.
     */
    body?: string;
  };
};

export type CollectionTemplateImageBottom = {
  images?: {
    assetImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    header?: string;
    /**
     * HTML representaton of the styled text.
     */
    body?: string;
  };
};

export type CollectionTemplateFullScreenImage = {
  images?: {
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    captionText?: string;
  };
};

export type CollectionTemplateQuote = {
  images?: {
    quote?: CollectionImage;
    separatorIcon?: CollectionImage;
    instructorProfile?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorName?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorBio?: string;
  };
};

export type CollectionTemplateFraming = {
  images?: {
    assetImage?: CollectionImage;
    eyebrowBackgroundImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    description?: string;
  };
};

export type CollectionTemplateQuiz = {
  question?: CollectionTemplateQuizQuestion;
  results?: Array<CollectionQuizResult>;
};

export type CollectionTemplateQuizQuestion = {
  images?: {
    assetImage?: CollectionImage;
    eyebrowBackgroundImage?: CollectionImage;
    pillImage?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    pillText?: string;
  };
  options?: Array<CollectionTemplateQuizQuestionOption>;
};

export type CollectionTemplateQuizQuestionOption = {
  answerReference?: string;
  isCorrect?: boolean;
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    optionText?: string;
  };
};

export type CollectionQuizResult = {
  answerReference?: string;
  /**
   * For values see `CollectionQuizCardType`.
   */
  type?: string;
  backgroundImage?: CollectionImage;
  partCover?: CollectionTemplatePartCover;
  textOnly?: CollectionTemplateTextOnly;
  imageTop?: CollectionTemplateImageTop;
  imageBottom?: CollectionTemplateImageBottom;
  fullScreenImage?: CollectionTemplateFullScreenImage;
  quote?: CollectionTemplateQuote;
  framing?: CollectionTemplateFraming;
  videoSetup?: CollectionTemplateVideoSetup;
  list?: CollectionTemplateList;
  partEnd?: CollectionTemplatePartEnd;
  inlineAnswer?: CollectionTemplateInlineAnswer;
  shortVideo?: CollectionTemplateShortVideo;
  audio?: CollectionTemplateAudio;
  partendWithLinks?: CollectionTemplatePartEndWithLinks;
  takeaway?: CollectionTemplateTakeawayText;
  quizCoverCard?: CollectionTemplateQuizCover;
  onboardingSelection?: CollectionTemplateOnboardingSelection;
  quizArticle?: CollectionTemplateQuizArticle;
  compactPartCover?: CollectionTemplateCompactPartCover;
};

export type CollectionTemplateVideoSetup = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId?: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid?: string;
  images?: {
    quote?: CollectionImage;
    separatorIcon?: CollectionImage;
    instructorProfile?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    headerText2?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorName?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorBio?: string;
  };
};

export type CollectionTemplateList = {
  images?: {
    assetImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
  };
  bullets?: Array<{
    bulletImage?: CollectionImage;
    /**
     * HTML representaton of the styled text.
     */
    bulletTitleHtml?: string;
    /**
     * HTML representaton of the styled text.
     */
    bulletDescriptionHtml?: string;
  }>;
};

export type CollectionTemplatePartEnd = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
  };
  images?: {
    nameplate?: CollectionImage;
  };
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  circleGroupColor?: string;
};

export type CollectionTemplateInlineAnswer = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    headerText2?: string;
    /**
     * HTML representaton of the styled text.
     */
    description?: string;
  };
};

export type CollectionRows = {
  rows?: Array<CollectionRow>;
};

export type CollectionRow = {
  /**
   * A UUID that identifies the row.
   */
  rowUuid: string;
  /**
   * The title of the row in the UX
   */
  title?: string;
  tiles?: Array<CollectionRowTile>;
  analytics?: {
    [key: string]: string;
  };
};

export type CollectionRowTile = {
  /**
   * The unique identifier for the tile.
   */
  tileUuid: string;
  collectionUuid?: string;
  collectionSlug?: string;
  partUuid?: string;
  partSlug?: string;
  backgroundImageUrl?: string;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  loadingColor?: string;
  /**
   * For accessibility.
   */
  altText?: string;
  tileClickRedirect?: string;
  analytics?: {
    [key: string]: string;
  };
  releaseDetails?: {
    isReleased?: boolean;
  };
  progress?: {
    isComplete?: boolean;
    barPercentage?: number;
    resumeCardUuid?: string;
  };
};

export type CollectionTemplateShortVideo = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This field is deprecated and replaced by the video MediaItem.
   *
   * @deprecated
   */
  brightcoveVideoId?: string;
  /**
   * This field is deprecated and replaced by the video MediaItem.
   *
   * @deprecated
   */
  mediaUuid?: string;
  video?: MediaItem;
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionTemplateAudio = {
  audio?: MediaItem;
  /**
   * Time in seconds
   */
  startPosition?: number;
  /**
   * Time in seconds
   */
  endPosition?: number;
  /**
   * The url of the mp3 of the text that is uttered at the start of the content. mp3 is the output of the MC TTS Service.
   */
  audioNoteUrl?: string;
  images?: {
    asset?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionTemplatePartEndWithLinks = {
  images?: {
    finishedIcon?: CollectionImage;
    asset?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    subtitle?: string;
    /**
     * HTML representaton of the styled text.
     */
    relatedContentTitle?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorName?: string;
  };
  /**
   * URL similar to content row item tileClickRedirect
   */
  tileClickRedirect?: string;
};

export type CollectionTemplateTakeawayText = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    takeaway?: string;
    /**
     * HTML representaton of the styled text.
     */
    ctaTitle?: string;
    /**
     * HTML representaton of the styled text.
     */
    ctaSubtitle?: string;
  };
  images?: {
    ctaImage?: CollectionImage;
    pillImage?: CollectionImage;
  };
  /**
   * URL similar to content row item tileClickRedirect
   */
  tileClickRedirect?: string;
};

export type CollectionTemplateQuizCover = {
  images?: {
    instructorAsset?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionTemplateQuizArticle = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML string
     */
    subtitle?: string;
  };
};

export type CollectionTemplateOnboardingSelection = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionInteractions = {
  progress?: {
    resumePartUuid?: string;
    /**
     * The slug of the part that the user is resuming.
     */
    resumePartSlug?: string;
    resumeCardUuid?: string;
    /**
     * The slug of the card in the part that the user is resuming.
     */
    resumeCardSlug?: string;
    /**
     * Returns whether the user has completed the collection.
     */
    isComplete?: boolean;
    /**
     * The percentage of the progress that the user has made in the collection.
     */
    barPercentage?: number;
  };
  /**
   * Any additional analytics information that needs to be sent.
   */
  analytics?: {
    [key: string]: string;
  };
};

export type OnboardingAnalytics = {
  slug: string;
};

export type OnboardingStep = {
  slug: string;
};

export type Onboarding = {
  id: number;
  steps: Array<OnboardingStep>;
  analytics: OnboardingAnalytics;
};

export type UpdateSessionPreferences = {
  communityId: string;
};

export type IterableToken = {
  /**
   * The Json Web Token (JWT)
   */
  accessToken: string;
  expiresIn: number;
};

export type RevolutEligibleGift = {
  /**
   * The identifier is eligible to redeem a Revolut tier
   */
  eligible: boolean;
  /**
   * See `RevolutEligibleGiftStatuses` enum for values.
   */
  status: string;
  /**
   * See `RevolutEligibleGiftTiers` enum for values.
   */
  tier: string;
  /**
   * Defines whether the same type of tier is being activated.
   */
  isStack: boolean;
  /**
   * Returns the Revolut tier sku.
   */
  sku: string;
};

export type RevolutEligibleGiftStatuses =
  | "available"
  | "upgrade"
  | "downgrade"
  | "undefined"
  | "enterprise_user"
  | "expired_gift"
  | "redeemed_gift"
  | "active_subscription";

export const RevolutEligibleGiftStatuses = {
  AVAILABLE: "available",
  UPGRADE: "upgrade",
  DOWNGRADE: "downgrade",
  UNDEFINED: "undefined",
  ENTERPRISE_USER: "enterprise_user",
  EXPIRED_GIFT: "expired_gift",
  REDEEMED_GIFT: "redeemed_gift",
  ACTIVE_SUBSCRIPTION: "active_subscription",
} as const;

export type RevolutEligibleGiftTiers = "high" | "low";

export const RevolutEligibleGiftTiers = {
  HIGH: "high",
  LOW: "low",
} as const;

export type CertificateProgram = {
  /**
   * The unique identifier of the certificate program.
   */
  uuid: string;
  /**
   * The slug of the certificate program.
   */
  slug: string;
  /**
   * The title of the certificate program.
   */
  title: string;
  /**
   * The subtitle of the certificate program, displayed below the title on the marketing page hero.
   */
  subtitle?: string;
  /**
   * The images associated with the certificate program.
   */
  images?: {
    hero1x1?: Image;
    logoLockup?: Image;
  };
  /**
   * The videos associated with the certificate program.
   */
  videos?: {
    /**
     * Media UUID of course trailer.
     */
    trailerMediaUuid?: string;
  };
  defaultEngagement?: CertificateProgramEngagement;
  /**
   * The syllabus of the certificate program.
   */
  syllabus?: {
    /**
     * The URL to the syllabus PDF.
     */
    pdfUrl?: string;
    preview10x13?: Image;
  };
  /**
   * The key benefits of the certificate program.
   */
  keyBenefits?: Array<{
    /**
     * The title of the key benefit.
     */
    title?: string;
    /**
     * A short description of the key benefit.
     */
    description?: string;
  }>;
  /**
   * The outcome section of the certificate program.
   */
  outcomes?: {
    /**
     * The eyebrow text for the outcomes section.
     */
    eyebrow?: string;
    /**
     * The headline of the outcomes section.
     */
    headline?: string;
    /**
     * List of outcome statements for the certificate program.
     */
    outcomeStatements?: Array<CurriculumStatement>;
    /**
     * List of skills taught by this certificate program.
     */
    skills?: Array<CurriculumStatement>;
    images?: {
      outcomes9x16?: Image;
      outcomes1x1?: Image;
    };
  };
  /**
   * The partner information for the certificate program.
   */
  partner?: {
    /**
     * The eyebrow text for the partner.
     */
    eyebrow?: string;
    /**
     * The headline of the partner section.
     */
    headline?: string;
    /**
     * The name of the partner.
     */
    name?: string;
    /**
     * A brief bio of the partner.
     */
    bio?: string;
    images?: {
      logo?: Image;
      brand1x1?: Image;
    };
  };
  /**
   * List of instructors for the certificate program.
   */
  instructors?: Array<CurriculumInstructor>;
  curriculum?: Curriculum;
  /**
   * A descriptive label for when the certificate program will be available (e.g., "available Fall 2024").
   */
  releaseLabel?: string;
  /**
   * Whether signup for this certificate program is enabled.
   */
  signupEnabled?: boolean;
  /**
   * List of testimonials for the certificate program.
   */
  testimonials?: Array<{
    /**
     * The testimonial text.
     */
    text?: string;
    customer?: {
      /**
       * The name of the customer.
       */
      name?: string;
      /**
       * The title of the customer.
       */
      title?: string;
    };
  }>;
  /**
   * The certificate showcase section configuration and content.
   */
  certificateShowcase?: {
    /**
     * The images for the certificate showcase section.
     */
    images?: {
      showcase4x5?: Image;
    };
    /**
     * The subtext for the certificate showcase section.
     */
    subtext?: string;
  };
  /**
   * The pedagogy section of the certificate program.
   */
  pedagogy?: Array<{
    /**
     * The eyebrow text for the pedagogy section.
     */
    eyebrow?: string;
    /**
     * The title of the pedagogy section.
     */
    title?: string;
    /**
     * The description of the pedagogy section.
     */
    description?: string;
    image?: Image;
  }>;
};

/**
 * A general object containing a text property.
 */
export type CurriculumStatement = {
  text: string;
};

export type Curriculum = {
  /**
   * The details of the curriculum.
   */
  details: {
    /**
     * The title of the curriculum.
     */
    title?: string;
    /**
     * The description of the curriculum.
     */
    description?: string;
    images?: {
      hero1x1?: Image;
      rewardPreview?: Image;
      logoLockup?: Image;
      logoLockupCondensedDark?: Image;
    };
    videos?: {
      /**
       * Media UUID of course trailer.
       */
      trailerMediaUuid?: string;
    };
    /**
     * The total estimated time to complete the curriculum, in seconds.
     */
    estimatedDuration?: number;
    /**
     * The total number of lessons in the curriculum.
     */
    totalLessons?: number;
    /**
     * The difficulty of the curriculum.
     */
    difficulty?: string;
    /**
     * See `CurriculumStatus` for possible values.
     */
    status?: string;
    /**
     * The applied skills section of the curriculum.
     */
    appliedSkills?: {
      /**
       * The heading for the applied skills section.
       */
      heading?: string;
      /**
       * List of applied skills for the curriculum.
       */
      statements?: Array<CurriculumStatement>;
    };
    /**
     * The partner information for the certificate program.
     */
    partner?: {
      /**
       * The name of the partner.
       */
      name?: string;
      images?: {
        logo?: Image;
        logo1x1?: Image;
      };
    };
  };
  units: Array<CurriculumUnit>;
  analytics?: {
    [key: string]: string;
  };
};

export type CurriculumStatus = "available" | "coming_soon";

export const CurriculumStatus = {
  AVAILABLE: "available",
  COMING_SOON: "coming_soon",
} as const;

export type CurriculumUnit = {
  /**
   * The unique identifier of a unit.
   */
  uuid: string;
  /**
   * The title of the unit.
   */
  title: string;
  /**
   * The position of the unit.
   */
  position?: number;
  /**
   * The description of the unit.
   */
  description?: string;
  /**
   * The total estimated time to complete the unit, in seconds.
   */
  estimatedDuration?: number;
  /**
   * List of skills taught by this curriculum.
   */
  skills?: Array<CurriculumStatement>;
  /**
   * The total number of lessons in the unit.
   */
  totalLessons?: number;
  analytics?: {
    [key: string]: string;
  };
  lessons: Array<CurriculumLesson>;
};

export type CurriculumLesson = {
  /**
   * The unique identifier of a lesson.
   */
  uuid: string;
  /**
   * The slug of the lesson.
   */
  slug: string;
  /**
   * The title of the lesson.
   */
  title: string;
  /**
   * The title of the lesson.
   */
  subtitle?: string;
  /**
   * The description of the lesson.
   */
  description?: string;
  /**
   * The position of the lesson.
   */
  position: number;
  /**
   * The duration of the lesson, in seconds.
   */
  estimatedDuration?: number;
  /**
   * See `CurriculumLessonType` for possible values.
   */
  lessonType?: string;
  /**
   * Whether the lesson is required or not.
   */
  required?: boolean;
  analytics?: {
    [key: string]: string;
  };
  activities?: Array<CurriculumActivity>;
  navigation?: {
    /**
     * Slug of the next lesson
     */
    nextLessonSlug?: string;
    /**
     * Slug of the previous lesson
     */
    previousLessonSlug?: string;
  };
  download?: {
    /**
     * The header text of the download section.
     */
    headerText?: string;
    /**
     * The description of the download section.
     */
    description?: string;
    /**
     * The call to action text.
     */
    ctaText?: string;
    downloadImage?: Image;
    analytics?: {
      [key: string]: string;
    };
  };
};

export type CurriculumLessonType =
  | "video"
  | "quiz"
  | "reading"
  | "discussion"
  | "project";

export const CurriculumLessonType = {
  VIDEO: "video",
  QUIZ: "quiz",
  READING: "reading",
  DISCUSSION: "discussion",
  PROJECT: "project",
} as const;

export type CurriculumActivity = {
  /**
   * The unique identifier of an activity.
   */
  uuid: string;
  /**
   * The title of the activity.
   */
  title?: string;
  /**
   * The description of the activity.
   */
  description?: string;
  /**
   * The position of the activity.
   */
  position: number;
  /**
   * Whether the activity is required or not.
   */
  required?: boolean;
  analytics?: {
    [key: string]: string;
  };
  resource?: {
    /**
     * The call to action text.
     */
    ctaText?: string;
    /**
     * The URL to download the resource.
     */
    downloadUrl?: string;
  };
  /**
   * See `CurriculumActivityType` for possible values.
   */
  activityType?: string;
  video?: CurriculumVideoActivity;
  quiz?: CurriculumQuizActivity;
  article?: CurriculumArticleActivity;
  discussion?: CurriculumDiscussionActivity;
  instructors?: CurriculumInstructorsActivity;
  capstoneSummary?: CurriculumCapstoneSummaryActivity;
};

export type CurriculumActivityType =
  | "video"
  | "article"
  | "quiz"
  | "discussion"
  | "instructors"
  | "capstone_summary";

export const CurriculumActivityType = {
  VIDEO: "video",
  ARTICLE: "article",
  QUIZ: "quiz",
  DISCUSSION: "discussion",
  INSTRUCTORS: "instructors",
  CAPSTONE_SUMMARY: "capstone_summary",
} as const;

export type CurriculumVideoActivity = {
  /**
   * The unique identifier of the video.
   */
  mediaUuid: string;
  /**
   * The footer text of the video.
   */
  footerText?: string;
};

export type CurriculumArticleActivity = {
  /**
   * The text of the article.
   */
  text: string;
  glossary?: Array<CurriculumGlossaryTerm>;
};

export type CurriculumGlossaryTerm = {
  /**
   * Human-readable identifier for the glossary term
   */
  slug: string;
  /**
   * Display title for the glossary term
   */
  title: string;
  /**
   * The content of the glossary term.
   */
  content: string;
};

export type CurriculumQuizActivity = {
  questions: Array<CurriculumQuizQuestion>;
};

export type CurriculumQuizQuestion = {
  /**
   * The slug of the question.
   */
  slug: string;
  /**
   * The text of the question.
   */
  text: string;
  /**
   * The description of the question to provide more context.
   */
  description?: string;
  choices: Array<CurriculumQuizChoice>;
};

export type CurriculumQuizChoice = {
  /**
   * The slug of the option.
   */
  slug: string;
  /**
   * The text of the option.
   */
  text: string;
};

export type CurriculumDiscussionActivity = {
  discussionQuestions: Array<CurriculumDiscussionQuestion>;
  rubric?: CurriculumDiscussionRubric;
};

/**
 * If the discussion submission is to be evaluated, this object will be returned to provide the user with
 * the rubric for the discussion.
 *
 */
export type CurriculumDiscussionRubric = {
  /**
   * The unique identifier of the rubric.
   */
  rubricUuid?: string;
  /**
   * See `CurriculumDiscussionRubricEvaluationType` for possible values.
   */
  evaluationType?: string;
  /**
   * The maximum mark a user can achieve.
   */
  maxMark?: number;
  /**
   * The passing mark for the discussion.
   */
  passingMark?: number;
  /**
   * The questions in the rubric, where the key is the question slug.
   */
  questions?: {
    [key: string]: CurriculumDiscussionRubricQuestion;
  };
};

export type CurriculumDiscussionRubricEvaluationType =
  | "full_evaluation"
  | "only_feedback";

export const CurriculumDiscussionRubricEvaluationType = {
  FULL_EVALUATION: "full_evaluation",
  ONLY_FEEDBACK: "only_feedback",
} as const;

export type CurriculumDiscussionRubricQuestion = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The maximum mark a user can achieve for this question. This value is an aggregate of all the maximum criteria marks.
   */
  maxMark?: number;
  criteria?: Array<CurriculumDiscussionRubricQuestionCriterion>;
};

export type CurriculumDiscussionRubricQuestionCriterion = {
  /**
   * The slug of the criteria.
   */
  criterionSlug: string;
  /**
   * The position of the criteria.
   */
  position: number;
  /**
   * The maximum mark a user can achieve for this criterion.
   */
  maxMark?: number;
  /**
   * The text of the criteria.
   */
  text: string;
  /**
   * The description of the criteria to provide more context.
   */
  description?: string;
};

export type CurriculumDiscussionQuestion = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The primary text of the question.
   */
  text: string;
  /**
   * The description of the question to provide more context.
   */
  description?: string;
  /**
   * The minimum length of the answer.
   */
  minLength?: number;
  /**
   * The maximum length of the answer.
   */
  maxLength?: number;
};

export type CurriculumInstructorsActivity = Array<CurriculumInstructor>;

/**
 * The capstone summary activity for a lesson.
 */
export type CurriculumCapstoneSummaryActivity = {
  projectPreview4x3?: Image;
  /**
   * The maximum mark that can be achieved for the entire capstone project.
   */
  maxMark?: number;
  /**
   * The total number of discussion questions in the capstone project.
   */
  totalDiscussionQuestions?: number;
  /**
   * The capstone project deliverables.
   */
  deliverables?: Array<CapstoneProjectDeliverable>;
};

/**
 * A deliverable item for a capstone project.
 */
export type CapstoneProjectDeliverable = {
  discussion?: {
    /**
     * The unique identifier of the lesson associated with this deliverable.
     */
    lessonUuid: string;
    /**
     * The slug of the lesson associated with this deliverable.
     */
    lessonSlug: string;
    /**
     * The unique identifier of the activity associated with this deliverable.
     */
    activityUuid: string;
    /**
     * The title of the deliverable.
     */
    title: string;
    questions: Array<{
      /**
       * The question title.
       */
      title: string;
      /**
       * The maximum mark that can be achieved for this deliverable.
       */
      maxMark?: number;
      /**
       * The slug of the question.
       */
      questionSlug: string;
    }>;
  };
};

export type CurriculumInstructor = {
  /**
   * The name of the instructor.
   */
  name: string;
  /**
   * The role of the instructor.
   */
  role?: string;
  image?: Image;
};

export type CertificateProgramCatalog = {
  tiles?: Array<CertificateTile>;
};

export type CertificateHubTiles = {
  continueWatchingTiles?: Array<CertificateTile>;
  moreCertificatesTiles?: Array<CertificateTile>;
};

export type CertificateTile = {
  /**
   * The unique identifier of the certificate program.
   */
  uuid: string;
  /**
   * The slug of the certificate program.
   */
  slug?: string;
  /**
   * The title of the certificate program.
   */
  title: string;
  /**
   * A brief overview of the certificate program.
   */
  description: string;
  /**
   * The total estimated time to complete the curriculum, in seconds.
   */
  estimatedDuration?: number;
  thumbnail16x9: Image;
  logoLockup?: Image;
  badge?: {
    /**
     * Text to display on the badge.
     */
    text?: string;
    /**
     * See `CertificateTileBadgeStatus` for possible values.
     */
    status?: string;
  };
  /**
   * The subheading of the certificate program.
   */
  subheading?: string;
  partnerLogo?: Image;
  cta?: {
    /**
     * The text of the call to action.
     */
    text: string;
    /**
     * The slug of the last visited lesson.
     */
    lessonSlug?: string;
    /**
     * The unique identifier of the last visited lesson.
     */
    lessonUuid?: string;
  };
};

export type CertificateTileBadgeStatus = "coming_soon" | "completed";

export const CertificateTileBadgeStatus = {
  COMING_SOON: "coming_soon",
  COMPLETED: "completed",
} as const;

export type CertificateProgramInteractions = {
  enrollment?: CertificateProgramEnrollment;
  curriculumInteractions?: CurriculumInteractions;
  engagement?: CertificateProgramEngagement;
};

/**
 * The engagement section for certificate programs. This section is used to entice the user
 * to engage in the certificate program, and to provide the user with actions they can take related to the
 * certificate program.
 *
 */
export type CertificateProgramEngagement = {
  /**
   * The email capture section for engagement. This section is used to provide the user with
   * an email capture form to sign up for updates related to the certificate program.
   *
   */
  emailCapture?: {
    /**
     * The headline of the email capture section.
     */
    headline?: string;
  };
  /**
   * The notice section for engagement. This section is used to provide the user with a
   * notice for the engagement section. This is typically used to provide the user with a
   * call to action related to the certificate program.
   *
   */
  notice?: {
    /**
     * The headline of the notice section.
     */
    headline?: string;
    /**
     * The description of the notice section.
     */
    description?: string;
  };
  actionBlock?: CertificateProgramEngagementActionBlock;
  navigation?: CertificateProgramEngagementNavigation;
};

export type CertificateProgramEngagementNavigation = {
  /**
   * The actions available to the user in the navigation bar.
   *
   */
  actions?: Array<CertificateProgramEngagementCta>;
};

export type CertificateProgramEngagementActionBlock = {
  /**
   * The header section for engagement. This section is used to provide the user with
   * a header for the engagement section.
   *
   */
  header?: {
    /**
     * The eyebrow of the header section.
     */
    eyebrow?: string;
    /**
     * The headline of the header section.
     */
    headline?: string;
  };
  /**
   * The actions section for engagement. This section is used to provide the user with
   * actions they can take related to the certificate program.
   *
   */
  actions: Array<CertificateProgramEngagementCta>;
  /**
   * The details section for engagement. This section is used to provide information to the user
   * related to the certificate program, or to provide context to the user about the
   * engagement actions.
   *
   */
  details?: {
    /**
     * The text of the info section. This is used to provide information to the user
     * related to the certificate program, or to provide context to the user about the
     * engagement actions.
     *
     */
    text: string;
    /**
     * The link object is used to provide a link to the user. This can be used to
     * provide an alternative engagement action to the user, or to provide
     * additional information to the user.
     *
     */
    link?: {
      /**
       * The text of the link.
       */
      text: string;
      /**
       * The action to perform when the link is clicked.
       * See `CertificateProgramEngagementActionType` for a list of possible values.
       *
       */
      actionType: string;
    };
  };
};

/**
 * The actions available to the user related to the certificate program. This section is used to
 * provide the user with actions they can take related to the certificate program. For a user who is
 * not enrolled in the certificate program, this section could be used to provide the user with
 * actions they can take to enroll in the certificate program. For a user who is already enrolled in the
 * certificate program, this section could be used to direct the user to the curriculum.
 *
 */
export type CertificateProgramEngagementCta = {
  /**
   * The text of the action.
   */
  text: string;
  /**
   * The action to perform when the action is clicked.
   * See `CertificateProgramEngagementActionType` for a list of possible values.
   *
   */
  actionType: string;
  /**
   * The state of the action. This is used to indicate whether the action is enabled or disabled.
   * See `CertificateProgramCtaState` for a list of possible values.
   *
   */
  state?: string;
  /**
   * The style of the action. This is used to indicate the style of the action.
   * See `CertificateProgramCtaStyle` for a list of possible values.
   *
   */
  style?: string;
  /**
   * The context of the action. This is used to provide additional information to the user about the action.
   * The context is typically only provided if only a single action is available to the user.
   * For example, this could be used to provide the user with information about their current progress in
   * the certificate program.
   *
   */
  context?: {
    /**
     * The eyebrow of the context.
     */
    eyebrow?: string;
    /**
     * The headline of the context.
     */
    headline?: string;
  };
};

export type CertificateProgramCtaState = "enabled" | "disabled";

export const CertificateProgramCtaState = {
  ENABLED: "enabled",
  DISABLED: "disabled",
} as const;

export type CertificateProgramCtaStyle = "primary" | "secondary" | "tertiary";

export const CertificateProgramCtaStyle = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
} as const;

export type CertificateProgramEngagementActionType =
  | "start_trial"
  | "purchase_aap"
  | "purchase_certificate"
  | "download_syllabus"
  | "go_to_curriculum";

export const CertificateProgramEngagementActionType = {
  START_TRIAL: "start_trial",
  PURCHASE_AAP: "purchase_aap",
  PURCHASE_CERTIFICATE: "purchase_certificate",
  DOWNLOAD_SYLLABUS: "download_syllabus",
  GO_TO_CURRICULUM: "go_to_curriculum",
} as const;

export type CurriculumInteractions = {
  /**
   * The unique identifier of the certificate program.
   */
  certificateProgramUuid?: string;
  /**
   * The percentage of the CurriculumLesson completed.
   */
  completionPercentage?: number;
  /**
   * The estimated time remaining to complete the curriculum, in seconds.
   */
  estimatedTimeRemaining?: number;
  /**
   * Whether the curriculum is completed or not.
   */
  curriculumCompleted?: boolean;
  /**
   * The date and time when the unit was completed.
   */
  completedAt?: string;
  /**
   * Whether the reward is unlocked or not.
   */
  rewardUnlocked?: boolean;
  lastVisitedLesson?: {
    /**
     * The unique identifier of the last visited lesson.
     */
    uuid?: string;
    /**
     * The title of the last visited lesson.
     */
    lessonTitle?: string;
    /**
     * The slug of the last visited lesson.
     */
    lessonSlug?: string;
    ctaText?: string;
  };
  unitsInteractions: {
    [key: string]: CurriculumUnitInteractions;
  };
  /**
   * The survey for the curriculum. This survey should be presented to the user upon successful issuance of the certificate.
   *
   */
  survey?: {
    /**
     * Indicates if the survey should be taken by this user. `false` if the user has already been presented the survey.
     */
    shouldTakeSurvey?: boolean;
    /**
     * The unique identifier to use for the survey.
     */
    contentUuid?: string;
    steps?: Array<NpsSurveyStep>;
  };
};

export type CurriculumUnitInteractions = {
  /**
   * The unique identifier of a unit.
   */
  uuid: string;
  /**
   * The number of completed lessons in the unit.
   */
  completedLessons?: number;
  /**
   * The percentage of the unit completed.
   */
  completionPercentage?: number;
  /**
   * See `CurriculumProgressStatus` for possible values.
   */
  status?: string;
  /**
   * Whether the unit is locked or not.
   */
  locked?: boolean;
  lessonsInteractions: {
    [key: string]: CurriculumLessonInteractions;
  };
};

export type CurriculumProgressStatus =
  | "not_started"
  | "in_progress"
  | "completed";

export const CurriculumProgressStatus = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
} as const;

export type CurriculumLessonInteractions = {
  /**
   * The unique identifier of a lesson.
   */
  uuid: string;
  /**
   * See `CurriculumProgressStatus` for possible values.
   */
  status?: string;
  /**
   * The percentage of the lesson completed.
   */
  completionPercentage?: number;
  /**
   * Whether the lesson is locked or not.
   */
  locked?: boolean;
  todoList?: {
    /**
     * The title of the todo list.
     */
    title?: string;
    items?: Array<{
      /**
       * The text of the todo item.
       */
      text?: string;
      /**
       * Whether the todo item is completed or not.
       */
      completed?: boolean;
      /**
       * The unique identifier of the activity.
       */
      activityUuid?: string;
      /**
       * Whether the todo item is required or not.
       */
      required?: boolean;
      /**
       * The estimated time to complete the todo item, in seconds.
       */
      estimatedDuration?: number;
    }>;
  };
  activitiesInteractions?: {
    [key: string]: CurriculumActivityInteractions;
  };
  /**
   * The survey for the lesson. This survey should be presented to the user upon successful completion of the lesson.
   * If there is no survey for the lesson, this object will not be present.
   *
   */
  survey?: {
    /**
     * Indicates if the survey should be taken upon completion of the lesson. `false` if the user has already been presented the survey.
     */
    shouldTakeSurvey?: boolean;
    /**
     * The unique identifier to use for the survey.
     */
    contentUuid?: string;
    steps?: Array<NpsSurveyStep>;
  };
};

export type CurriculumActivityInteractions = {
  /**
   * The unique identifier of an activity.
   */
  uuid: string;
  /**
   * See `CurriculumActivityType` for possible values.
   */
  activityType?: string;
  video?: CurriculumVideoActivityInteractions;
  quiz?: CurriculumQuizActivityInteractions;
  discussion?: CurriculumDiscussionActivityInteractions;
  capstoneSummary?: CurriculumCapstoneSummaryActivityInteractions;
};

export type CurriculumVideoActivityInteractions = {
  /**
   * Whether the video activity is completed or not.
   */
  completed?: boolean;
  /**
   * The progress of the video activity in seconds
   */
  progress?: number;
};

export type CurriculumQuizActivityInteractions = {
  answers?: Array<CurriculumQuizAnswer>;
  /**
   * Whether the user can submit the quiz or not.
   */
  canSubmit?: boolean;
  /**
   * The number of correct answers to the questions on the quiz.
   */
  correctAnswers?: number;
  /**
   * The total number of questions on the quiz.
   */
  totalQuestions?: number;
};

export type CurriculumQuizAnswer = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The slug of the choice.
   */
  choiceSlug: string;
  /**
   * Whether the answer is correct or not.
   */
  isCorrect?: boolean;
  /**
   * The title of the feedback.
   */
  feedbackTitle?: string;
  answerMaterial?: {
    /**
     * The text of the answer.
     */
    text?: string;
    /**
     * The URL of the answer video.
     */
    videoUrl?: string;
  };
};

export type CurriculumDiscussionActivityInteractions = {
  answers?: Array<CurriculumDiscussionAnswer>;
  /**
   * The total number of questions on the discussion.
   */
  totalQuestions?: number;
  /**
   * Whether the discussion activity is completed or not.
   */
  completed?: boolean;
  evaluation?: CurriculumDiscussionEvaluation;
  analytics?: {
    [key: string]: string;
  };
};

/**
 * If the discussion submission is to be evaluated, this object will be returned to provide the user with the evaluation of the discussion. The rubric in the evaluation might be different from the rubric in the discussion activity, particularly if the rubric has been updated since the user submitted the discussion.
 */
export type CurriculumDiscussionEvaluation = {
  rubric?: CurriculumDiscussionRubric;
  /**
   * The outcome of the evaluation, once the evaluation is complete. If the outcome is `pass`, the user has passed the evaluation. If the outcome is `fail`, the user has failed the evaluation.
   * See `CurriculumDiscussionEvaluationOutcome` for possible values.
   *
   */
  outcome?: string;
  /**
   * The status of the evaluation. If the status is `pending`, the evaluation is still in progress. If the status is `complete`, the evaluation is complete. If the status is `error`, there was an error in the evaluation process.
   * See `CurriculumDiscussionEvaluationStatus` for possible values.
   *
   */
  status: string;
  /**
   * The mark of the discussion.
   */
  mark?: number;
  /**
   * Overall feedback on the submission.
   */
  feedback?: string;
  /**
   * The answers in the evaluation, where the key is the question slug.
   */
  assessments?: {
    [key: string]: CurriculumDiscussionEvaluationAssessment;
  };
};

export type CurriculumDiscussionEvaluationOutcome = "pass" | "fail";

export const CurriculumDiscussionEvaluationOutcome = {
  PASS: "pass",
  FAIL: "fail",
} as const;

export type CurriculumDiscussionEvaluationStatus =
  | "pending"
  | "complete"
  | "error"
  | "flagged";

export const CurriculumDiscussionEvaluationStatus = {
  PENDING: "pending",
  COMPLETE: "complete",
  ERROR: "error",
  FLAGGED: "flagged",
} as const;

export type CurriculumDiscussionEvaluationAssessment = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The mark of the question.
   */
  mark?: number;
  /**
   * Feedback on the submission for the question.
   */
  feedback?: string;
  /**
   * The criteria in the assessment, where the key is the criterion slug.
   */
  criteria: {
    [key: string]: CurriculumDiscussionEvaluationAssessmentCriterion;
  };
};

export type CurriculumDiscussionEvaluationAssessmentCriterion = {
  /**
   * The slug of the criterion.
   */
  criterionSlug: string;
  /**
   * The mark of the criterion.
   */
  mark?: number;
  /**
   * Feedback on the submission for the question, as it pertains to the criterion.
   */
  feedback?: string;
};

export type CurriculumDiscussionAnswer = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The answer of the user.
   */
  userAnswer: string;
  /**
   * see `CurriculumDiscussionAnswerStatus` for possible values.
   */
  status?: string;
};

export type CurriculumDiscussionAnswerStatus = "draft" | "submitted";

export const CurriculumDiscussionAnswerStatus = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
} as const;

export type CurriculumCapstoneSummaryActivityInteractions = {
  /**
   * The number of questions passed.
   */
  questionsPassed?: number;
  /**
   * The total mark.
   */
  totalMark?: number;
  deliverables?: {
    [key: string]: CapstoneProjectDeliverableInteractions;
  };
};

export type CapstoneProjectDeliverableInteractions = {
  discussion?: {
    /**
     * The mark of the deliverable.
     */
    mark?: number;
    /**
     * The date and time when the deliverable was submitted.
     */
    submittedAt?: string;
    /**
     * Whether the deliverable was passed or not.
     */
    passed?: boolean;
    /**
     * Key is the question slug, value is the user's answer to the question.
     */
    userAnswers?: {
      [key: string]: {
        /**
         * The slug of the question.
         */
        questionSlug?: string;
        /**
         * The user's answer to the question.
         */
        userAnswer?: string;
      };
    };
  };
};

export type CertificateProgramProduct = {
  /**
   * The id of the Certificate Program.
   */
  id: number;
  /**
   * The display name of the Certificate Program.
   */
  name: string;
  /**
   * The description of the Certificate Program.
   */
  description: string;
  /**
   * The unique identifier of the Certificate Program.
   */
  uuid?: string;
  /**
   * The slug of the Certificate Program.
   */
  slug: string;
  /**
   * The currency of the Certificate Program.
   */
  currency: string;
  /**
   * Price in minor currency units (cents / pence / etc.), before any discounts are applied.
   */
  price: number;
  /**
   * Total discount applied to the list price.
   */
  discountAmount?: number;
  /**
   * The price after rebates and discounts but before non-inclusive taxes.
   */
  netPrice?: number;
  /**
   * Text to display indicating the applied discount.
   */
  discountSubheading?: string;
  /**
   * If tax needs to be applied for the Certificate Program.
   */
  applyTax: boolean;
  /**
   * The display price of the Certificate Program.
   */
  displayPrice: string;
  /**
   * The display discounted amount of the Certificate Program
   */
  displayDiscountAmount?: string;
  /**
   * The display net price of the Certificate Program after discounts and rebates are applied.
   */
  displayNetPrice?: string;
  /**
   * See `ProductTier` for available types.
   */
  productTier?: string;
  /**
   * Tier hierarchy level (1 = lowest tier)
   */
  productTierLevel?: number;
  analytics?: {
    [key: string]: unknown;
  };
};

/**
 * The product tier identifier
 */
export type ProductTier = "tier1" | "tier2";

export const ProductTier =
  /**
   * The product tier identifier
   */
  {
    TIER1: "tier1",
    TIER2: "tier2",
  } as const;

/**
 * List of SKU products for the certificate program.
 */
export type CertificateProgramProducts = Array<CertificateProgramProduct>;

export type UserCertificateProgramReward = {
  /**
   * The unique identifier of a certificate program.
   */
  certificateProgramUuid: string;
  /**
   * The title of the certificate.
   */
  certificateTitle?: string;
  /**
   * The duration of the certificate.
   */
  certificateDuration?: number;
  curriculumImage?: Image;
  /**
   * The name of the user.
   */
  userName?: string;
  /**
   * The email of the user.
   */
  email?: string;
  /**
   * The date and time when the certificate was completed.
   */
  completedAt?: string;
  /**
   * The URL of the certificate.
   */
  certificateUrl?: string;
  /**
   * The URL to share the certificate on LinkedIn.
   */
  shareUrl?: string;
  /**
   * The URL to download the certificate.
   */
  downloadUrl?: string;
  /**
   * see `CertificateRewardIssueStatus` for possible values.
   */
  issueStatus?: string;
  rewardPreviewImage?: Image;
  rewardImage?: Image;
  /**
   * The media UUID of the completion video.
   */
  completionVideoMediaUuid?: string;
  analytics?: {
    [key: string]: string;
  };
};

export type CertificateRewardIssueStatus = "pending" | "issued";

export const CertificateRewardIssueStatus = {
  PENDING: "pending",
  ISSUED: "issued",
} as const;

/**
 * This object contains the enrollment data for the certificate program.
 *
 */
export type CertificateProgramEnrollment = {
  /**
   * Indicates whether the user is enrolled in the certificate program. This is true for both active and pending enrollments.
   */
  isEnrolled?: boolean;
  /**
   * The type of the originator of the enrollment. See `CertificateProgramEnrollmentSource` for possible values.
   */
  source?: string;
  /**
   * The current status of the enrollment. See `CertificateProgramEnrollmentStatus` for possible values.
   */
  status?: string;
  /**
   * The certificate program information.
   */
  certificateProgram?: {
    /**
     * The unique identifier of the certificate program.
     */
    uuid?: string;
    /**
     * The slug of the certificate program.
     */
    slug?: string;
    /**
     * The title of the certificate program.
     */
    title?: string;
  };
  /**
   * The date and time when the user was enrolled in the certificate program. If the user pre-enrolled, this will be the date and time when the user was pre-enrolled in the certificate program. See the activatedAt field for the date and time the enrollment was activated.
   */
  enrolledAt?: string;
  /**
   * The date and time when the user activated the certificate program.
   */
  activatedAt?: string;
  /**
   * The date and time when access to the certificate program expires.
   */
  expiresAt?: string;
  /**
   * The tier level of the certificate program enrollment. See `ProductTier` for possible values.
   */
  productTier?: string;
};

export type CertificateProgramCoupon = {
  code: string;
  /**
   * see `CertificateProgramCouponEligibility` for possible values.
   */
  couponEligibility: string;
  /**
   * see `CertificateProgramCouponDiscountType` for possible values.
   */
  discountType?: string;
  /**
   * The discount value of the coupon.
   */
  discountValue?: number;
  /**
   * The unique identifier of the product.
   */
  productUuid?: string;
  modal?: {
    title?: string;
    text?: string;
    cta?: string;
  };
};

export type CertificateProgramCouponDiscountType =
  | "amount_off"
  | "percentage_off";

export const CertificateProgramCouponDiscountType = {
  AMOUNT_OFF: "amount_off",
  PERCENTAGE_OFF: "percentage_off",
} as const;

export type CertificateProgramCouponEligibility = "eligible" | "ineligible";

export const CertificateProgramCouponEligibility = {
  ELIGIBLE: "eligible",
  INELIGIBLE: "ineligible",
} as const;

export type CertificateProgramEnrollments = {
  enrollments?: Array<CertificateProgramEnrollment>;
};

export type CertificateProgramEnrollmentSource =
  | "purchase"
  | "credit"
  | "trial"
  | "gift";

export const CertificateProgramEnrollmentSource = {
  PURCHASE: "purchase",
  CREDIT: "credit",
  TRIAL: "trial",
  GIFT: "gift",
} as const;

/**
 * The current status of the enrollment.
 */
export type CertificateProgramEnrollmentStatus =
  | "active"
  | "pending"
  | "inactive";

export const CertificateProgramEnrollmentStatus =
  /**
   * The current status of the enrollment.
   */
  {
    ACTIVE: "active",
    PENDING: "pending",
    INACTIVE: "inactive",
  } as const;

export type AcceleratorUser = {
  /**
   * The UUID of the user
   */
  uuid?: string;
  /**
   * The employee ID of the user
   */
  employeeId?: string;
  /**
   * The location, this might be a store number or a geo
   */
  location?: string;
  /**
   * Slug to identify the organization that this user belongs to
   */
  orgSlug?: string;
  /**
   * Whether the user has consented to sharing their data with their organization
   */
  dataConsentGiven?: boolean;
};

export type GrowthCategory = {
  id: number;
  name: string;
  slug: string;
  /**
   * The parentId is the Category that a Subcategory belongs to. Categories don't have a parent_id
   */
  parentId?: number;
  uuid: string;
  rankings?: Array<{
    rankValue: number;
    rankType: string;
  }>;
  videos?: Array<{
    mediaUuid?: string;
    videoType?: string;
  }>;
};

export type GrowthContent = {
  uuid: string;
  /**
   * the id for the Course / Camp
   */
  contentId: number;
  /**
   * Unique slug for the content
   */
  slug: string;
  /**
   * See `GrowthContentType` for available types.
   */
  type: string;
  title: string;
  headline?: string;
  skill?: string;
  instructors?: Array<{
    name: string;
  }>;
  instructorName?: string;
  leftAlignedNameplate?: string;
  nameplate?: string;
  marketingCmColumn?: string;
  /**
   * Media UUID for the course trailer
   */
  mediaUuid?: string;
  /**
   * Media video thumbnail URL for the course trailer
   */
  mediaVideoThumbUrl?: string;
  /**
   * Media UUID for the course sample (AKA "mobile_web_gem")
   */
  sampleMediaUuid?: string;
  /**
   * Media video thumbnail URL for the course sample
   */
  sampleMediaVideoThumbUrl?: string;
  primary16x9?: string;
  primary2x3?: string;
  primary1x1?: string;
  cinematic12x5?: string;
  tag?: string;
  releaseDescription?: string;
  durationInSeconds?: number;
  /**
   * Number of camp modules or number of series episodes or number of course chapters
   */
  durationAsCount?: number;
  vanityName?: string;
  primaryCategory: {
    id?: number;
  };
  /**
   * List of categories associated with the content
   */
  categories: Array<{
    id: number;
  }>;
  primarySubcategory: {
    id?: number;
  };
  /**
   * List of subcategories associated with the content
   */
  subcategories: Array<{
    id: number;
  }>;
  rankings?: Array<{
    rankValue: number;
    rankType: string;
  }>;
};

export type GrowthContentType = "course" | "camp" | "series";

export const GrowthContentType = {
  COURSE: "course",
  CAMP: "camp",
  SERIES: "series",
} as const;

export type GrowthSubcategoryWithLessons = {
  id: number;
  /**
   * The parentId is the Category that a Subcategory belongs to. Categories don't have a parent_id
   */
  parentId?: number;
  uuid: string;
  name: string;
  slug: string;
  /**
   * List of ranked lessons within the subcategory
   */
  lessons: Array<GrowthLesson>;
};

export type GrowthLesson = {
  uuid: string;
  /**
   * id for the lesson
   */
  contentId: number;
  /**
   * See `GrowthLessonType` for available types.
   */
  type: string;
  /**
   * Unique slug for the lesson
   */
  slug: string;
  /**
   * Title of the lesson
   */
  title: string;
  /**
   * Lesson abstract
   */
  abstract?: string;
  /**
   * Ranking of the lesson within the subcategory
   */
  rank: number;
  /**
   * The parent class for the lesson
   */
  class: {
    uuid?: string;
    /**
     * The total number of lessons (chapters or camp modules) in the class
     */
    lessonCount?: number;
  };
};

export type GrowthLessonType = "chapter" | "camptask" | "serieschapter";

export const GrowthLessonType = {
  CHAPTER: "chapter",
  CAMPTASK: "camptask",
  SERIESCHAPTER: "serieschapter",
} as const;

export type GrowthCategoryWithMedia = {
  id: number;
  /**
   * The parentId is the Category that a Subcategory belongs to. Categories don't have a parent_id
   */
  parentId?: number;
  uuid: string;
  name: string;
  slug: string;
  /**
   * List of media for the category / subcategory
   */
  media?: Array<GrowthCategoryMedia>;
};

export type GrowthCategoryMedia = {
  mediaType?: string;
  mediaUuid?: string;
  thumbnail16x9?: string;
  /**
   * The instructors in the media item
   */
  instructors?: Array<GrowthCategoryMediaInstructor>;
};

export type GrowthCategoryMediaInstructor = {
  id?: number;
  uuid?: string;
  /**
   * The instructor's position in the ordered list (0-based index)
   */
  order?: number;
  name?: string;
  /**
   * The instructor's primary 2x3 image
   */
  primary2x3?: string;
};

export type Outcome = {
  id: number;
  name: string;
  slug: string;
  uuid: string;
  /**
   * A one-liner describing the outcome
   */
  description?: string;
  /**
   * A short, action-oriented name phrased with an -ing verb form
   */
  gerund?: string;
};

export type ContentOutcome = {
  uuid: string;
  /**
   * the id for the Course / Camp
   */
  contentId: number;
  /**
   * Unique slug for the content
   */
  slug?: string;
  /**
   * See `GrowthContentType` for available types.
   */
  type: string;
  title?: string;
  /**
   * List of outcomes associated with the content ordered by relevance rank
   */
  outcomes?: Array<{
    id: number;
  }>;
};

export type EmailCaptureRequest = {
  /**
   * The email address to capture
   */
  email: string;
  /**
   * Custom event name for tracking
   */
  eventName?: string;
  /**
   * Whether user has consented to marketing emails
   */
  marketingConsent?: boolean;
  /**
   * Campaign identifier (e.g., cart, marketingEmails, accountCreation)
   */
  campaign?: string;
  /**
   * Product identifier (e.g., masterclass, certificates)
   */
  product?: string;
  /**
   * Unique event ID for deduplication across Iterable and Segment
   */
  eventId?: string;
};

export type EmailCaptureResponse = {
  /**
   * Whether the email capture was successful
   */
  success: boolean;
};

export type ErrorResponse = {
  /**
   * Error message
   */
  error: string;
};

export type DecagonUserToken = {
  /**
   * The Json Web Token (JWT)
   */
  userToken: string;
  expiresIn: number;
};

export type CommerceProduct = {
  id: number;
  name: string;
  status: string;
  /**
   * The description of the product
   */
  description?: string;
  /**
   * List of purchase plans for the product
   */
  purchasePlans?: Array<CommercePurchasePlan>;
};

export type CommercePurchasePlan = {
  /**
   * the id for the Purchase Plan
   */
  id: number;
  /**
   * Unique slug for the purchase plan
   */
  slug: string;
  /**
   * Duration for the purchase plan
   */
  duration: number;
  durationUnits: string;
  /**
   * friendly name for the purchase plan
   */
  displayName: string;
  /**
   * List of pricing plans for the purchase plan
   */
  pricingPlans?: Array<CommercePricingPlan>;
};

export type CommercePricingPlan = {
  /**
   * the id for the Pricing Plan
   */
  id: number;
  /**
   * Unique name for the pricing plan
   */
  name: string;
  /**
   * Stripe price id for this pricing plan
   */
  paymentGatewaySkuId: string;
  currency: string;
  price: number;
  usdPrice?: number;
  active: boolean;
};

export type SubscriptionDetails = {
  /**
   * Days the subscription lasts
   */
  billingLengthDays: number;
  currency: string;
  price: number;
  /**
   * Name of pricing tier
   */
  displayName: string;
  /**
   * SKU of purchase plan
   */
  planSku: string;
};

export type SupportedCapabilities =
  | "media_download"
  | "concurrent_devices"
  | "multiple_profiles"
  | "notes"
  | "bookmarks"
  | "recipes"
  | "class_resources"
  | "class_ta";

export const SupportedCapabilities = {
  MEDIA_DOWNLOAD: "media_download",
  CONCURRENT_DEVICES: "concurrent_devices",
  MULTIPLE_PROFILES: "multiple_profiles",
  NOTES: "notes",
  BOOKMARKS: "bookmarks",
  RECIPES: "recipes",
  CLASS_RESOURCES: "class_resources",
  CLASS_TA: "class_ta",
} as const;

export type Capabilities = {
  /**
   * List of capabilities available to the user. Each capability key appears at most once.
   */
  userCapabilities?: Array<Capability>;
};

export type Capability = {
  /**
   * See `SupportedCapabilities` for a list of currently supported keys.
   */
  key: string;
  /**
   * The value associated with the capability (e.g., "true", "false", or other capability-specific values)
   */
  value: string;
};

/**
 * include dependencies
 */
export type Parameterdeep = boolean;

export type Parameterplatform = "web";

export const Parameterplatform = {
  WEB: "web",
} as const;

/**
 * include additional dependencies
 */
export type Parameterfilter = string;

/**
 * gift query param, determines whether we are sending a gift or not
 */
export type Parametergift = boolean;

/**
 * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
 */
export type ParameterdiscountSlug = string;

/**
 * include additional dependencies
 */
export type Parameterinclude = string;

/**
 * UUID of the current Profile, used to filter response data to that Profile
 */
export type ParameterMCProfileId = string;

/**
 * Short lived token used for the playback urls by chromecast
 */
export type ParameterXPLAYBACKTOKEN = string;

export type GetBookmarksData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filter by given bookmarked entity id
   */
  filterBookmarkeeIds?: number;
  /**
   * Filter by given bookmarked entity type
   */
  filterBookmarkeeType?: string;
};

export type GetBookmarksResponse = Bookmarks;

export type CreateBookmarkData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Bookmark attributes
   */
  requestBody: CreateBookmarkAttributes;
};

export type CreateBookmarkResponse = Bookmark;

export type DeleteBookmarkData = {
  id: number;
};

export type DeleteBookmarkResponse = void;

export type GetSessionsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * slug to be remove from response
   */
  excludedSlug?: string;
  /**
   * include hub dependencies
   */
  hub?: string;
};

export type GetSessionsResponse = SessionsResult;

export type GetSessionBySlugData = {
  /**
   * include dependencies
   */
  deep: boolean;
  /**
   * slug id
   */
  slug: string;
};

export type GetSessionBySlugResponse = SingleSessionResult;

export type GetSessionInteractionsData = {
  sessionUuid: string;
};

export type GetSessionInteractionsResponse = SessionsInteractions;

export type GetCategoriesResponse = CategoriesResult;

export type GetChaptersData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetChaptersResponse = ChapterResult;

export type GetCoursesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    tag?: string;
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetCoursesResponse = CoursesResult;

export type GetCourseBySlugData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters courses by tag
   */
  filter?: {
    tag?: string;
  };
  /**
   * Course slug
   */
  slug: string;
};

export type GetCourseBySlugResponse = Course | CourseDeep;

export type GetCoursesContentGemsData = {
  /**
   * Course id
   */
  id: number;
};

export type GetCoursesContentGemsResponse = MobileContentGems;

export type GetContentRowsData = {
  pageSlug?: string;
  platform?: "web";
};

export type GetContentRowsResponse = ContentRows;

export type GetContentRowByIdData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Content row ID
   */
  id: number;
};

export type GetContentRowByIdResponse = ContentRow;

export type GetConversationsData = {
  /**
   * filters by course
   */
  filterCourseId?: number;
  /**
   * filters by client session
   */
  filterVisitSessionId?: string;
  /**
   * Sort by attribute
   */
  sort?: string;
};

export type GetConversationsResponse = Conversations;

export type CreateConversationData = {
  /**
   * Conversation attributes
   */
  requestBody: ConversationAttributes;
};

export type CreateConversationResponse = Conversation;

export type GetConversationIntroductionData = {
  /**
   * Current chapter
   */
  chapterId?: number;
  /**
   * Current course
   */
  courseId?: number;
};

export type GetConversationIntroductionResponse = ConversationIntroduction;

export type GetConversationData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
};

export type GetConversationResponse = Conversation;

export type GetConversationMessagesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
  /**
   * Page size
   */
  pageLimit?: number;
  /**
   * Page offset (multiple of page[limit])
   */
  pageOffset?: number;
  /**
   * Sort by id or -id
   */
  sort?: string;
};

export type GetConversationMessagesResponse = ConversationMessages;

export type CreateConversationMessageData = {
  id: number;
  /**
   * Message attributes
   */
  requestBody: ConversationMessageAttributes;
};

export type CreateConversationMessageResponse = ConversationMessage;

export type UpsertConversationMessageData = {
  id: number;
  /**
   * Message attributes
   */
  requestBody: ConversationMessageAttributes;
};

export type UpsertConversationMessageResponse = ConversationMessage;

export type GetConversationMessageData = {
  conversationId: number;
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
};

export type GetConversationMessageResponse = ConversationMessage;

export type UpdateConversationMessageData = {
  conversationId: number;
  id: number;
  /**
   * Message update attributes
   */
  requestBody: ConversationMessageUpdateAttributes;
};

export type UpdateConversationMessageResponse = ConversationMessage;

export type CreateEmailConfirmationData = {
  /**
   * Context for the Email Confirmation
   */
  requestBody: EmailConfirmationAttributes;
};

export type CreateEmailConfirmationResponse = EmailConfirmation;

export type GetEmailConfirmationData = {
  /**
   * Token that references a specific Email Confirmation
   */
  token: string;
};

export type GetEmailConfirmationResponse = EmailConfirmation;

export type GetLegacyEmailConfirmationResponse = {
  confirmationStatus?: EmailConfirmationStatus;
  email?: string;
};

export type CreateLegacyEmailConfirmationData = {
  /**
   * Email confirmation attributes
   */
  requestBody: {
    emailConfirmation: EmailConfirmationLegacyAttributes;
  };
};

export type CreateLegacyEmailConfirmationResponse = {
  confirmationStatus?: string;
};

export type DownloadExampleCsvResponse = unknown;

export type GetEnterpriseSubscriptionsResponse = EnterpriseSubscriptions;

export type GetNotificationsResponse = EnterpriseNotifications;

export type ClearNotificationsData = {
  /**
   * Ids to clear
   */
  requestBody: {
    ids: Array<string>;
  };
};

export type ClearNotificationsResponse = void;

export type GetScheduledInvitationData = {
  /**
   * Bulk import id
   */
  id: number;
};

export type GetScheduledInvitationResponse = TeamScheduledInvitation;

export type UpdateScheduledInviteData = {
  id: number;
  /**
   * Scheduled invite attributes
   */
  requestBody: {
    sendInviteAt: string;
  };
};

export type UpdateScheduledInviteResponse = unknown;

export type CancelScheduledInviteData = {
  id: number;
};

export type CancelScheduledInviteResponse = void;

export type GetScheduledInvitationCsvData = {
  /**
   * Bulk invite ID
   */
  id: number;
  /**
   * team ID
   */
  teamId?: number;
};

export type GetScheduledInvitationCsvResponse = string;

export type CreateTeamData = {
  /**
   * Attributes for the new Profile
   */
  requestBody: TeamCreateAttributes;
};

export type CreateTeamResponse = Team;

export type GetTeamData = {
  filter?: string;
  /**
   * Team ID
   */
  id: number;
  include?: string;
  pageOffset?: number;
};

export type GetTeamResponse = Team;

export type DeleteTeamData = {
  /**
   * Team ID
   */
  id: number;
};

export type DeleteTeamResponse = unknown;

export type UpdateTeamData = {
  /**
   * Team ID
   */
  id: number;
  /**
   * Team's new name
   */
  requestBody: {
    name?: string;
  };
};

export type UpdateTeamResponse = unknown;

export type AddAdminByEmailData = {
  /**
   * Email and role
   */
  requestBody: {
    /**
     * New admin's email
     */
    email?: string;
    /**
     * New admin's role
     */
    role?: string;
  };
  /**
   * Team ID
   */
  teamId: number;
};

export type AddAdminByEmailResponse = unknown;

export type RemindUserData = {
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type RemindUserResponse = unknown;

export type UpdateTeamUserData = {
  /**
   * User's new name
   */
  requestBody: {
    user?: {
      firstName?: string;
      lastName?: string;
    };
  };
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type UpdateTeamUserResponse = unknown;

export type AddUserData = {
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type AddUserResponse = unknown;

export type DeleteUserData = {
  /**
   * Admin Role
   */
  role?: string;
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type DeleteUserResponse = unknown;

export type AddAdminData = {
  /**
   * admin role
   */
  role: string;
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type AddAdminResponse = unknown;

export type SetAdminRoleData = {
  /**
   * admin role
   */
  adminRole: string;
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type SetAdminRoleResponse = unknown;

export type GetScheduledInvitationsData = {
  /**
   * Team ID
   */
  teamId: number;
};

export type GetScheduledInvitationsResponse = TeamScheduledInvitations;

export type GetOrganizationData = {
  deep?: boolean;
  /**
   * Organization ID
   */
  id: number;
};

export type GetOrganizationResponse = Organization;

export type RemoveLogoData = {
  /**
   * Organization ID
   */
  id: number;
};

export type RemoveLogoResponse = void;

export type SaveOrganizationMessageData = {
  /**
   * Attributes for the custom message
   */
  requestBody: TeamNotification;
};

export type SaveOrganizationMessageResponse = TeamNotification;

export type GetOrganizationMessageData = {
  /**
   * Team notification ID
   */
  id: number;
};

export type GetOrganizationMessageResponse = TeamNotification;

export type DeleteOrganizationMessageData = {
  /**
   * Team notification ID
   */
  id: number;
};

export type DeleteOrganizationMessageResponse = void;

export type DismissOrganizationMessageData = {
  /**
   * Team notification ID
   */
  id: number;
};

export type DismissOrganizationMessageResponse = unknown;

export type GetUnreadOrganizationMessageResponse = Array<MemberNotification>;

export type GetEpisodesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for Episodes
   */
  filter?: {
    pilot?: boolean;
  };
};

export type GetEpisodesResponse = Episodes;

export type GetEpisodeBySlugData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Episode slug
   */
  slug: string;
};

export type GetEpisodeBySlugResponse = Episode;

export type GetExperimentsResponse = Experiments;

export type GetFeatureInteractionsData = {
  /**
   * Filters for current user's Feature Interactions
   */
  filter?: {
    id?: number;
  };
};

export type GetFeatureInteractionsResponse = FeatureInteractionsResult;

export type UpdateFeatureInteractionData = {
  /**
   * Updated feature interaction info
   */
  requestBody: FeatureInteractionAttributes;
};

export type UpdateFeatureInteractionResponse = FeatureInteraction;

export type GetGuestPassesData = {
  /**
   * Referral token
   */
  referralToken: string;
};

export type GetGuestPassesResponse = FreeTrial;

export type SendGuestPassViaEmailData = {
  /**
   * Emails where the guest pass will be shared
   */
  requestBody: GuestPassShareAttributes;
};

export type SendGuestPassViaEmailResponse = unknown;

export type GetImmersiveHerosData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * specify a one of slug, courseSlug, or chapterSlug to filter
   */
  filter?: {
    /**
     * specify a gem slug to filter
     */
    slug?: string;
    /**
     * specify a course slug to filter
     */
    courseSlug?: string;
    /**
     * specify a chapter slug to filter
     */
    chapterSlug?: string;
  };
};

export type GetImmersiveHerosResponse = ImmersiveHeros;

export type GetInstructorsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    /**
     * specify a playlist
     */
    playlist?: string;
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetInstructorsResponse = Array<Instructor>;

export type GetNotesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for Notes
   */
  filter?: {
    courseSlug?: string;
  };
};

export type GetNotesResponse = Notes;

export type CreateNoteData = {
  /**
   * Note attributes
   */
  requestBody: CreateNoteAttributes;
};

export type CreateNoteResponse = Note;

export type DeleteNoteData = {
  id: number;
};

export type DeleteNoteResponse = void;

export type UpdateNoteData = {
  id: number;
  /**
   * Note attributes
   */
  requestBody: {
    content: string;
  };
};

export type UpdateNoteResponse = Note;

export type GetPlaylistData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  slug: string;
  track?: string;
};

export type GetPlaylistResponse = Playlist;

export type GetPlaylistsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetPlaylistsResponse = Playlists;

export type GetProductsData = {
  /**
   * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   */
  discountSlug?: string;
  /**
   * include additional dependencies
   */
  filterPurchasePlanSlugs?: string;
  /**
   * gift query param, determines whether we are sending a gift or not
   */
  gift?: boolean;
};

export type GetProductsResponse = Products;

export type GetProfilesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetProfilesResponse = Profiles;

export type CreateProfileData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Attributes for the new Profile
   */
  requestBody: ProfileCreateAttributes;
};

export type CreateProfileResponse = Profile;

export type GetProfileData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Profile ID
   */
  id: number;
};

export type GetProfileResponse = Profile;

export type UpdateProfileData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
  /**
   * Profile attributes to be changed
   */
  requestBody: ProfileUpdateAttributes;
};

export type UpdateProfileResponse = Profile;

export type DeleteProfileData = {
  id: number;
};

export type DeleteProfileResponse = void;

export type GetOnboardingContentRecommendationResponse =
  OnboardingContentRecommendation;

export type GetPurchasePlanData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Either id number or specific plan slug
   */
  id: string | number;
};

export type GetPurchasePlanResponse = PurchasePlan;

export type GetReferralAudioProgramsResponse = ReferralAudioProgramsResult;

export type CreateShareableGuestPassLinksData = {
  /**
   * Attributes to create an invitation link. These attributes will be used to create utm params and handle link redirection
   */
  requestBody: ReferralTokenAttributes;
};

export type CreateShareableGuestPassLinksResponse = ShareLinks;

export type GetShowcasesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetShowcasesResponse = ShowcasesResult;

export type GetSkillsResponse = SkillsResult;

export type GetLastUserSubscriptionData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetLastUserSubscriptionResponse = Subscription;

export type GetThemesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for ids
   */
  filter?: {
    /**
     * CSV of ids to filter
     */
    id?: string;
  };
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetThemesResponse = ThemesResults;

export type GetCurrentTierCollectionData = {
  /**
   * temporal param to support the prcng-107V1 experiment and return the correct tier collection
   */
  collapsedBucket?: string;
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   */
  discountSlug?: string;
  /**
   * gift query param, determines whether we are sending a gift or not
   */
  gift?: boolean;
};

export type GetCurrentTierCollectionResponse = TierCollection;

export type GetPersonaBundleTierCollectionData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   */
  discountSlug?: string;
  /**
   * gift query param, determines whether we are sending a gift or not
   */
  gift?: boolean;
};

export type GetPersonaBundleTierCollectionResponse = TierCollection;

export type GetUserCartDataData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetUserCartDataResponse = CartData;

export type GetUserGuestPassesResponse = GuestPass;

export type GetLastUserProductResponse = Product;

export type ValidateStreamConcurrencyData = {
  /**
   * Information about a new streaming session
   */
  requestBody: StreamAttributes;
};

export type ValidateStreamConcurrencyResponse = StreamsResult;

export type ReleaseConcurrentSeatData = {
  /**
   * Streaming session id
   */
  requestBody: StreamAttributes;
};

export type ReleaseConcurrentSeatResponse = StreamsResult;

export type GetUserSessionsResponse = UserSessionsResult;

export type GetUserCoursesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetUserCoursesResponse = UserCoursesResult;

export type CreateUserCourseData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Course to associate to User
   */
  requestBody: CreateUserCourseAttributes;
};

export type CreateUserCourseResponse = UserCourse;

export type GetUserCourseBySlugData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters courses by tag
   */
  filter?: {
    tag?: string;
  };
  /**
   * Course slug
   */
  slug: string;
};

export type GetUserCourseBySlugResponse = UserCourse;

export type GetUserProgressData = {
  /**
   * Filters for current user's watch list items
   */
  filter?: {
    contentType?: string;
  };
};

export type GetUserProgressResponse = UserProgressResults;

export type GetUserPlaylistsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for completed playlists
   */
  filter?: {
    completed?: boolean;
  };
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetUserPlaylistsResponse = UserPlaylistResults;

export type GetUserData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * User id
   */
  id: string | number;
};

export type GetUserResponse = User;

export type UpdateUserData = {
  /**
   * User id
   */
  id: string | number;
  /**
   * Updated user info
   */
  requestBody: UserAttributesForUpdate;
};

export type UpdateUserResponse = User;

export type GetVideoProgressEntriesData = {
  /**
   * Filters for current user's Video Progress Entries
   */
  filter?: {
    byVideoType?: string;
  };
};

export type GetVideoProgressEntriesResponse = VideoProgressEntriesResult;

export type CreateVideoProgressEntryData = {
  /**
   * New video progress entry info
   */
  requestBody: VideoProgressEntryAttributesForCreate;
};

export type CreateVideoProgressEntryResponse = VideoProgressEntry;

export type UpdateVideoProgressEntryData = {
  /**
   * Video Progress Entry id
   */
  id: number;
  /**
   * Updated video progress entry info
   */
  requestBody: VideoProgressEntryAttributesForUpdate;
};

export type UpdateVideoProgressEntryResponse = VideoProgressEntry;

export type GetWatchListItemsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetWatchListItemsResponse = WatchListResults;

export type CreateWatchListItemData = {
  /**
   * Information about the watch list item
   */
  requestBody: WatchListItemAttributes;
};

export type CreateWatchListItemResponse = WatchListItem;

export type DeleteWatchListItemData = {
  /**
   * Id of the current item
   */
  id: number;
};

export type DeleteWatchListItemResponse = unknown;

export type GetLandingPricesData = {
  /**
   * user geo to calculate price
   */
  mcGeo: string;
};

export type GetLandingPricesResponse = LandingPrices;

export type GetPersonaBundleResponse = PersonaBundle;

export type GetSearchConfigData = {
  mode?: "library" | "search" | "customplaylists";
  platform?: "web";
  userExperience?: "consumer" | "enterprise";
};

export type GetSearchConfigResponse = SearchConfig;

export type GetRegisteredEmailData = {
  /**
   * email to verify
   */
  email: string;
};

export type GetRegisteredEmailResponse = EmailAccount;

export type CompleteUserRegistrationData = {
  /**
   * User attributes
   */
  requestBody: UserRegistration;
};

export type CompleteUserRegistrationResponse = unknown;

export type AddCreditCardData = {
  /**
   * Credit card params
   */
  requestBody: CreateCreditCardAttributes;
};

export type AddCreditCardResponse = CreditCard;

export type GetCreditCardsResponse = CreditCards;

export type RemoveCreditCardData = {
  id: number;
};

export type RemoveCreditCardResponse = void;

export type GetCreditCardsWithCurrencyData = {
  /**
   * Filter credit card by payment method cards or token cards
   */
  tokenOnly?: boolean;
};

export type GetCreditCardsWithCurrencyResponse = CreditCards;

export type GetDefaultCreditCardResponse = CreditCard;

export type CheckSetupIntentStatusData = {
  setupIntentId: string;
};

export type CheckSetupIntentStatusResponse = SetupIntentStatus | CreditCard;

export type VerifyCouponData = {
  /**
   * Slug of the coupon to be verified
   */
  code: string;
  /**
   * ID of the product the coupon is being applied to
   */
  productId: number;
};

export type VerifyCouponResponse = DiscountCoupon;

export type CreateOrderData = {
  /**
   * Order params
   */
  requestBody: CreateOrderAttributes;
  /**
   * COM-839
   */
  xTsBucket: string;
};

export type CreateOrderResponse = Order;

export type ConfirmData = {
  id: number;
};

export type ConfirmResponse = OrderConfirmation;

export type AddDiscountToCartProductsData = {
  /**
   * Send the productId and discount we would like to add
   */
  requestBody: UpdateProductAttributes;
};

export type AddDiscountToCartProductsResponse = unknown;

export type AddProductToCartData = {
  /**
   * Cart attributes
   */
  requestBody: AddProductAttributes;
};

export type AddProductToCartResponse = {
  product: CartProduct;
};

export type ClearCartResponse = {
  /**
   * Status of the cart clear operation
   */
  status: boolean;
  /**
   * Message indicating the success of the operation
   */
  message: string;
};

export type RemoveProductFromCartData = {
  /**
   * Product attributes
   */
  requestBody: RemoveProductAttributes;
};

export type RemoveProductFromCartResponse = {
  product: CartProduct;
};

export type GetCartProductsData = {
  /**
   * if user is gifting, we send gift = true
   */
  gift?: boolean;
};

export type GetCartProductsResponse = CartProducts;

export type RedeemData = {
  /**
   * gift token
   */
  bogoGiftToken: string;
  /**
   * Gift attributes
   */
  requestBody: {
    gift: RedeemBogoGift;
  };
};

export type RedeemResponse = {
  gifteeName?: string;
};

export type GetGiftAddOnResponse = GiftAddOn;

export type GetAddOnsResponse = {
  persona?: PersonaAddOn;
  learningToolkit?: LearningToolkitAddOn;
  gift?: GiftAddOn;
  certificatePrograms?: Array<CertificateProgramAddOn>;
};

export type GetLearningToolkitAddOnResponse = LearningToolkitAddOn;

export type GetPersonaAddOnResponse = PersonaAddOn;

export type PreviewProrationData = {
  /**
   * ID of the product to preview proration for
   */
  id: number;
};

export type PreviewProrationResponse = ProrationPreview;

export type CancelData = {
  id: number;
};

export type CancelResponse = unknown;

export type ReactivateData = {
  id: number;
};

export type ReactivateResponse = unknown;

export type PreviewData = {
  /**
   * The product id of the plan to preview
   */
  changeProductId: number;
  id: number;
};

export type PreviewResponse = {
  /**
   * The prorated amount for the plan change
   */
  proratedAmount?: string;
  /**
   * The currency code
   */
  currency?: string;
  /**
   * The type of change (upgrade or downgrade)
   */
  changeType?: "upgrade" | "downgrade";
};

export type UpdateData = {
  /**
   * Subscription ID
   */
  id: number;
  /**
   * Subscription attributes
   */
  requestBody: {
    /**
     * The type of change
     */
    changeType: string;
    /**
     * The product id of the plan to update
     */
    changeProductId: number;
  };
};

export type UpdateResponse = {
  /**
   * A message indicating the subscription was updated
   */
  message?: string;
};

export type PricingUpgradeResponse = unknown;

export type GetWatchBundleData = {
  watchBundleUuid: string;
};

export type GetWatchBundleResponse = WatchBundle;

export type GetWatchBundleExtrasData = {
  watchBundleUuid: string;
};

export type GetWatchBundleExtrasResponse = WatchBundleExtras;

export type GetWatchBundleInteractionsData = {
  watchBundleUuid: string;
};

export type GetWatchBundleInteractionsResponse = WatchBundleInteractions;

export type AddBookmarkData = {
  /**
   * The unique identifier of a resource to bookmark.
   */
  uuid: string;
};

export type AddBookmarkResponse = V3Bookmark;

export type RemoveBookmarkData = {
  /**
   * The unique identifier of a resource to bookmark.
   */
  uuid: string;
};

export type RemoveBookmarkResponse = void;

export type PatchNoteData = {
  contentUuid: string;
  requestBody: {
    entry: string;
  };
};

export type PatchNoteResponse = V3Note;

export type DestroyNoteData = {
  contentUuid: string;
};

export type DestroyNoteResponse = void;

export type GetWatchBundleContentInteractionsData = {
  /**
   * Content uuid
   */
  contentUuid: string;
};

export type GetWatchBundleContentInteractionsResponse =
  WatchBundleContentInteractions;

export type PatchPlaybackData = {
  contentUuid: string;
  requestBody: {
    cursor: number;
  };
};

export type PatchPlaybackResponse = Playhead;

export type GetPlaybackTokenResponse = PlaybackTokenResponse;

export type UpdateSurveyResponseData = {
  contentUuid: string;
  requestBody: UpdateSurvey;
};

export type UpdateSurveyResponseResponse = void;

export type ShowSharingData = {
  uuid: string;
};

export type ShowSharingResponse = Sharing;

export type GetSessionActivityInteractionsData = {
  /**
   * Activity uuid
   */
  uuid: string;
};

export type GetSessionActivityInteractionsResponse =
  SessionActivityInteractions;

export type GetAssigneesResponse = Assignees;

export type GetContentProgressData = {
  filters?: {
    [key: string]: unknown;
  };
  /**
   * Filters progress based on who shared
   */
  sharedBy?: "all" | "me";
  /**
   * The team identifier in which the progress content was assigned.
   */
  teamId: string;
  /**
   * The unique identifier of an assignable content.
   */
  uuid: string;
};

export type GetContentProgressResponse = ContentProgress;

export type GetAssignmentsResponse = AssignedContents;

export type CreateAssignmentsData = {
  requestBody: CreateAssignments;
  xRequestId?: string;
};

export type CreateAssignmentsResponse = unknown;

export type DestroyAssignmentData = {
  contentUuid: string;
  requestBody: UserIdentifier;
};

export type DestroyAssignmentResponse = void;

export type GetAssignableContentResponse = AssignableContentResult;

export type GetNavigationResponse = NavigationContents;

export type GetOrganizationInfoData = {
  id: string;
};

export type GetOrganizationInfoResponse = V3Organization;

export type GetTemplateBulkImportResponse = string;

export type GetEnterpriseSkillsResponse = Array<EnterprisePlaylistSkill>;

export type V3GetPlaylistsData = {
  /**
   * The unique identifier of an organization.
   */
  organizationId: number;
};

export type V3GetPlaylistsResponse = V3Playlists;

export type CreatePlaylistData = {
  requestBody: CreatePlaylist;
};

export type CreatePlaylistResponse = CreatedPlaylist;

export type V3GetPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type V3GetPlaylistResponse = V3Playlist;

export type UpdatePlaylistData = {
  formData: UpdatePlaylist;
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type UpdatePlaylistResponse = void;

export type DeletePlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type DeletePlaylistResponse = void;

export type PublishPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type PublishPlaylistResponse = void;

export type UnpublishPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type UnpublishPlaylistResponse = void;

export type DuplicatePlaylistData = {
  requestBody: CreatePlaylist;
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type DuplicatePlaylistResponse = CreatedPlaylist;

export type GetLessonsFromPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
};

export type GetLessonsFromPlaylistResponse = Array<EnterprisePlaylistLesson>;

export type AddLessonsToPlaylistData = {
  playlistUuid: string;
  requestBody: EnterprisePlaylistAddLessons;
};

export type AddLessonsToPlaylistResponse = unknown;

export type ReorderLessonsInPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
  requestBody: ReorderLessons;
};

export type ReorderLessonsInPlaylistResponse = void;

export type UpdateLessonInPlaylistData = {
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
  requestBody: UpdateLesson;
};

export type UpdateLessonInPlaylistResponse = void;

export type RemoveLessonFromPlaylistData = {
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
};

export type RemoveLessonFromPlaylistResponse = void;

export type GetProgramData = {
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
};

export type GetProgramResponse = Program;

export type EnrollProgramsData = {
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
};

export type EnrollProgramsResponse = unknown;

export type GetProgramDownloadResourcesData = {
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
  /**
   * Files to be compressed that belong to the same section.
   */
  stage?: "before" | "along" | "after";
};

export type GetProgramDownloadResourcesResponse = Blob | File;

export type GetModuleDownloadResourcesData = {
  /**
   * The unique identifier of a module.
   */
  moduleSlug: string;
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
};

export type GetModuleDownloadResourcesResponse = Blob | File;

export type GetQuoteData = {
  requestBody: EnterpriseQuoteRequest;
};

export type GetQuoteResponse = EnterpriseQuote;

export type GetAddonQuoteData = {
  requestBody: EnterpriseAddonQuoteRequest;
};

export type GetAddonQuoteResponse = EnterpriseQuote;

export type ProcessAddonOrderData = {
  requestBody: EnterpriseProcessAddonOrderRequest;
};

export type ProcessAddonOrderResponse = EnterpriseAddonOrder;

export type ProcessOrderData = {
  requestBody: EnterpriseProcessOrderRequest;
};

export type ProcessOrderResponse = EnterpriseOrder;

export type GetInvoiceData = {
  /**
   * The unique identifier of the invoice.
   */
  invoiceId: string;
};

export type GetInvoiceResponse = EnterpriseInvoice;

export type GetLicensesResponse = EnterpriseLicenses;

export type RevokeConsentResponse = void;

export type GetMetricData = {
  filters?: {
    [key: string]: unknown;
  };
  slug: string;
  teamId: string;
};

export type GetMetricResponse = EnterpriseAnalyticsMetric;

export type CreateGenerateCsvReportJobData = {
  /**
   * generate-csv-report-job request body
   */
  requestBody: EnterpriseAnalyticsGenerateCsvReportJobRequest;
};

export type CreateGenerateCsvReportJobResponse =
  EnterpriseAnalyticsGenerateCsvReportJobResponse;

export type GetGenerateCsvReportJobData = {
  uuid: string;
};

export type GetGenerateCsvReportJobResponse =
  EnterpriseAnalyticsGenerateCsvReportJobResponse;

export type GetContentRowsV3Data = {
  /**
   * Used to filter out tiles with a different entityType
   */
  entityType?: Array<V3ContentRowEntityType>;
  filter: {
    bundle: string;
    /**
     * comma-separated list of ids to filter
     */
    id?: string;
    platform:
      | "iphone"
      | "ipad"
      | "android_phone"
      | "android_tv"
      | "fire_tv"
      | "apple tv"
      | "roku"
      | "web";
    /**
     * Used to override row reference
     */
    referenceUuid?: string;
  };
  includeItems?: boolean;
  resourceUuid?: string;
};

export type GetContentRowsV3Response = V3ContentRows;

export type GetResourceUniqueIdentifierData = {
  /**
   * Type of the resource in plural.
   */
  resourceTypePlural:
    | "stories"
    | "collections"
    | "collection-parts"
    | "collection-part-cards"
    | "courses"
    | "chapters"
    | "certificate_programs"
    | "curriculum_lessons";
  /**
   * Slug of the resource.
   */
  slug: string;
};

export type GetResourceUniqueIdentifierResponse = UniqueIdentifiersResponse;

export type GetMyListResponse = Array<MyListItem>;

export type AddToMyListData = {
  contentUuid: string;
};

export type AddToMyListResponse = unknown;

export type RemoveFromMyListData = {
  contentUuid: string;
};

export type RemoveFromMyListResponse = void;

export type GetHomepageLayoutResponse = HomepageLayout;

export type GetSemanticSearchData = {
  /**
   * The question asked by the user
   */
  q: string;
};

export type GetSemanticSearchResponse = SemanticSearchResponse;

export type GetAppDataResponse = AppData;

export type UpdateLearningPreferencesData = {
  requestBody: LearningPreferences;
};

export type UpdateLearningPreferencesResponse = void;

export type GetCareerGoalResponse = CareerGoalPage;

export type V3GetSkillsData = {
  /**
   * The career goal selected
   */
  careerGoal: string;
};

export type V3GetSkillsResponse = SkillsPage;

export type GetSubskillsData = {
  /**
   * The skills selected
   */
  skills: string;
};

export type GetSubskillsResponse = SubskillsPage;

export type GetTabContentData = {
  navigation?: string;
  tab?: string;
  xPlatform?: string;
};

export type GetTabContentResponse = TabContent;

export type GetCollectionRowsResponse = CollectionRows;

export type GetCollectionData = {
  collectionUuid: string;
};

export type GetCollectionResponse = Collection;

export type UpdateCardProgressData = {
  cardUuid: string;
};

export type UpdateCardProgressResponse = void;

export type GetCollectionInteractionsData = {
  collectionUuid: string;
};

export type GetCollectionInteractionsResponse = CollectionInteractions;

export type CreateOnboardingResponse = Onboarding;

export type UpdateOnboardingData = {
  /**
   * Onboarding Id
   */
  id: number;
};

export type UpdateOnboardingResponse = void;

export type UpdateSessionPreferencesData = {
  requestBody: UpdateSessionPreferences;
  /**
   * Session uuid
   */
  uuid: string;
};

export type UpdateSessionPreferencesResponse = void;

export type GetIterableTokenResponse = IterableToken;

export type GetEligibleInfoData = {
  /**
   * The unique identifier of a resource to redeem.
   */
  uuid: string;
};

export type GetEligibleInfoResponse = RevolutEligibleGift;

export type ActivateRevolutGiftData = {
  /**
   * The unique identifier of a resource to redeem.
   */
  uuid: string;
};

export type ActivateRevolutGiftResponse = unknown;

export type GetCertificateProgramCatalogResponse = CertificateProgramCatalog;

export type GetCertificateHubTilesResponse = CertificateHubTiles;

export type GetCertificateProgramInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramInteractionsResponse =
  CertificateProgramInteractions;

export type GetCertificateProgramData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramResponse = CertificateProgram;

export type GetCurriculumData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCurriculumResponse = Curriculum;

export type PostCurriculumInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCurriculumInteractionsResponse = CurriculumInteractions;

export type GetCurriculumLessonData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type GetCurriculumLessonResponse = CurriculumLesson;

export type GetCurriculumLessonInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type GetCurriculumLessonInteractionsResponse =
  CurriculumLessonInteractions;

export type PostCurriculumLessonInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type PostCurriculumLessonInteractionsResponse =
  CurriculumLessonInteractions;

export type GetCurriculumLessonDownloadResourcesData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type GetCurriculumLessonDownloadResourcesResponse = Blob | File;

export type DownloadCurriculumCapstoneSummaryData = {
  /**
   * The unique identifier of the capstone summary activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type DownloadCurriculumCapstoneSummaryResponse = Blob | File;

export type SubmitCurriculumQuizActivityData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: CurriculumQuizActivityInteractions;
};

export type SubmitCurriculumQuizActivityResponse =
  CurriculumQuizActivityInteractions;

export type SubmitCurriculumDiscussionActivityData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: CurriculumDiscussionActivityInteractions;
};

export type SubmitCurriculumDiscussionActivityResponse =
  CurriculumDiscussionActivityInteractions;

export type PostCurriculumActivityReadData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of the activity.
   */
  uuid: string;
};

export type PostCurriculumActivityReadResponse = unknown;

export type GetCertificateProgramProductData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * Optional discount code to apply to the price
   */
  discountSlug?: string;
};

export type GetCertificateProgramProductResponse = CertificateProgramProduct;

export type ListCertificateProgramProductsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  discountSlugs?: {
    [key: string]: string;
  };
};

export type ListCertificateProgramProductsResponse = CertificateProgramProducts;

export type GetCertificateProgramProductByUuidData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * Optional discount code to apply to the price
   */
  discountSlug?: string;
  /**
   * The unique identifier of a product
   */
  productUuid: string;
};

export type GetCertificateProgramProductByUuidResponse =
  CertificateProgramProduct;

export type GetCertificateProgramRewardData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramRewardResponse = UserCertificateProgramReward;

export type PostCertificateProgramRewardData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCertificateProgramRewardResponse = UserCertificateProgramReward;

export type PostCertificateProgramAddOnData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCertificateProgramAddOnResponse = unknown;

export type GetCertificateProgramCouponData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The code of the coupon
   */
  couponCode: string;
  /**
   * The unique identifier of the product
   */
  productUuid: string;
};

export type GetCertificateProgramCouponResponse = CertificateProgramCoupon;

export type GetCertificateProgramEnrollmentsData = {
  /**
   * Filter by active enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   */
  active?: boolean;
  /**
   * Filter by inactive enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   */
  inactive?: boolean;
  /**
   * Filter by pending enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   */
  pending?: boolean;
};

export type GetCertificateProgramEnrollmentsResponse =
  CertificateProgramEnrollments;

export type GetCertificateProgramEnrollmentData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramEnrollmentResponse =
  CertificateProgramEnrollment;

export type EnrollInCertificateProgramData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: {
    /**
     * Only available for non production environments. If true, the user will be enrolled in all the courses of the certificate program.
     * This is only available for non-production environments.
     *
     */
    autoCheckout?: boolean;
  };
};

export type EnrollInCertificateProgramResponse = {
  /**
   * The date and time when the certificate program was provisioned.
   */
  enrolledAt?: string;
};

export type WithdrawFromCertificateProgramData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type WithdrawFromCertificateProgramResponse = void;

export type V3GetUserData = {
  requestBody?: AcceleratorUser;
};

export type V3GetUserResponse = AcceleratorUser;

export type GetGrowthCategoriesResponse = Array<GrowthCategory>;

export type GetGrowthContentResponse = Array<GrowthContent>;

export type GetQuizRecommendedLessonsResponse =
  Array<GrowthSubcategoryWithLessons>;

export type GetQuizCategoryMediaResponse = Array<GrowthCategoryWithMedia>;

export type GetOutcomesResponse = Array<Outcome>;

export type GetContentOutcomesResponse = Array<ContentOutcome>;

export type CreateEmailCaptureData = {
  requestBody: EmailCaptureRequest;
};

export type CreateEmailCaptureResponse = EmailCaptureResponse;

export type GetUserTokenResponse = DecagonUserToken;

export type GetCommerceProductData = {
  /**
   * The name of the product to retrieve
   */
  productName: string;
};

export type GetCommerceProductResponse = CommerceProduct;

export type GetCommercePurchasePlansData = {
  /**
   * The name of the purchase-plan to retrieve
   */
  slug: string;
};

export type GetCommercePurchasePlansResponse = CommercePurchasePlan;

export type RedeemGiftcardData = {
  /**
   * Giftcode for redemption
   */
  requestBody: {
    /**
     * Giftcard code number
     */
    giftcode: string;
  };
};

export type RedeemGiftcardResponse = SubscriptionDetails;

export type GetCapabilitiesResponse = Capabilities;

export type $OpenApiTs = {
  "/jsonapi/v1/bookmarks": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filter by given bookmarked entity id
         */
        filterBookmarkeeIds?: number;
        /**
         * Filter by given bookmarked entity type
         */
        filterBookmarkeeType?: string;
      };
      res: {
        /**
         * List of bookmarks
         */
        200: Bookmarks;
      };
    };
    post: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Bookmark attributes
         */
        requestBody: CreateBookmarkAttributes;
      };
      res: {
        /**
         * Created bookmark
         */
        200: Bookmark;
      };
    };
  };
  "/jsonapi/v1/bookmarks/{id}": {
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Bookmark is deleted
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/camps": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * slug to be remove from response
         */
        excludedSlug?: string;
        /**
         * include hub dependencies
         */
        hub?: string;
      };
      res: {
        /**
         * Sessions response
         */
        200: SessionsResult;
      };
    };
  };
  "/jsonapi/v1/camps/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep: boolean;
        /**
         * slug id
         */
        slug: string;
      };
      res: {
        /**
         * Session response
         */
        200: SingleSessionResult;
      };
    };
  };
  "/api/v3/sessions/{session_uuid}/interactions": {
    get: {
      req: {
        sessionUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: SessionsInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/categories": {
    get: {
      res: {
        /**
         * List of categories
         */
        200: CategoriesResult;
      };
    };
  };
  "/jsonapi/v1/chapters": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * Chapter response
         */
        200: ChapterResult;
      };
    };
  };
  "/jsonapi/v1/courses": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          tag?: string;
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * Courses response
         */
        200: CoursesResult;
      };
    };
  };
  "/jsonapi/v1/courses/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters courses by tag
         */
        filter?: {
          tag?: string;
        };
        /**
         * Course slug
         */
        slug: string;
      };
      res: {
        /**
         * Courses response
         */
        200: Course | CourseDeep;
      };
    };
  };
  "/jsonapi/v1/courses/{id}/content-gems": {
    get: {
      req: {
        /**
         * Course id
         */
        id: number;
      };
      res: {
        /**
         * Mobile content gems response
         */
        200: MobileContentGems;
      };
    };
  };
  "/jsonapi/v2/content-rows": {
    get: {
      req: {
        pageSlug?: string;
        platform?: "web";
      };
      res: {
        /**
         * List of content rows
         */
        200: ContentRows;
      };
    };
  };
  "/jsonapi/v2/content-rows/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Content row ID
         */
        id: number;
      };
      res: {
        /**
         * Content row response
         */
        200: ContentRow;
      };
    };
  };
  "/jsonapi/v1/conversations": {
    get: {
      req: {
        /**
         * filters by course
         */
        filterCourseId?: number;
        /**
         * filters by client session
         */
        filterVisitSessionId?: string;
        /**
         * Sort by attribute
         */
        sort?: string;
      };
      res: {
        /**
         * Conversation response
         */
        200: Conversations;
      };
    };
    post: {
      req: {
        /**
         * Conversation attributes
         */
        requestBody: ConversationAttributes;
      };
      res: {
        /**
         * Created note
         */
        200: Conversation;
      };
    };
  };
  "/jsonapi/v1/conversations/introduction": {
    get: {
      req: {
        /**
         * Current chapter
         */
        chapterId?: number;
        /**
         * Current course
         */
        courseId?: number;
      };
      res: {
        /**
         * Conversation response
         */
        200: ConversationIntroduction;
      };
    };
  };
  "/jsonapi/v1/conversations/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
      };
      res: {
        /**
         * Conversation response
         */
        200: Conversation;
      };
    };
  };
  "/jsonapi/v1/conversations/{id}/messages": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
        /**
         * Page size
         */
        pageLimit?: number;
        /**
         * Page offset (multiple of page[limit])
         */
        pageOffset?: number;
        /**
         * Sort by id or -id
         */
        sort?: string;
      };
      res: {
        /**
         * Conversation messagesresponse
         */
        200: ConversationMessages;
      };
    };
    post: {
      req: {
        id: number;
        /**
         * Message attributes
         */
        requestBody: ConversationMessageAttributes;
      };
      res: {
        /**
         * Created message
         */
        200: ConversationMessage;
      };
    };
    put: {
      req: {
        id: number;
        /**
         * Message attributes
         */
        requestBody: ConversationMessageAttributes;
      };
      res: {
        /**
         * Created or updated message
         */
        200: ConversationMessage;
      };
    };
  };
  "/jsonapi/v1/conversations/{conversation_id}/messages/{id}": {
    get: {
      req: {
        conversationId: number;
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
      };
      res: {
        /**
         * Conversation response
         */
        200: ConversationMessage;
      };
    };
    patch: {
      req: {
        conversationId: number;
        id: number;
        /**
         * Message update attributes
         */
        requestBody: ConversationMessageUpdateAttributes;
      };
      res: {
        /**
         * Conversation message response
         */
        200: ConversationMessage;
      };
    };
  };
  "/jsonapi/v1/email-confirmations": {
    post: {
      req: {
        /**
         * Context for the Email Confirmation
         */
        requestBody: EmailConfirmationAttributes;
      };
      res: {
        /**
         * Email Confirmation sent to the email on file.
         */
        200: EmailConfirmation;
      };
    };
  };
  "/jsonapi/v1/email-confirmations/{token}": {
    get: {
      req: {
        /**
         * Token that references a specific Email Confirmation
         */
        token: string;
      };
      res: {
        /**
         * Email Confirmation
         */
        200: EmailConfirmation;
      };
    };
  };
  "/email_confirmations": {
    get: {
      res: {
        /**
         * Email confirmation response
         */
        200: {
          confirmationStatus?: EmailConfirmationStatus;
          email?: string;
        };
      };
    };
    post: {
      req: {
        /**
         * Email confirmation attributes
         */
        requestBody: {
          emailConfirmation: EmailConfirmationLegacyAttributes;
        };
      };
      res: {
        /**
         * Email confirmation already exists
         */
        200: {
          confirmationStatus?: string;
        };
        /**
         * Bad request
         */
        400: {
          error?: string;
        };
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_subscriptions/template": {
    get: {
      res: {
        /**
         * CSV downloaded
         */
        200: unknown;
        /**
         * Not authorized to download csv
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_subscriptions": {
    get: {
      res: {
        /**
         * Enterprise Subscriptions list
         */
        200: EnterpriseSubscriptions;
        /**
         * Not authorized to get enterprise subscriptions
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_notifications": {
    get: {
      res: {
        /**
         * Notification list
         */
        200: EnterpriseNotifications;
        /**
         * Not authorized to get notifications
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_notifications/clear": {
    patch: {
      req: {
        /**
         * Ids to clear
         */
        requestBody: {
          ids: Array<string>;
        };
      };
      res: {
        /**
         * Notifications deleted
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/enterprise/bulk_send_invites/{id}": {
    get: {
      req: {
        /**
         * Bulk import id
         */
        id: number;
      };
      res: {
        /**
         * Scheduled invitation retrieved
         */
        200: TeamScheduledInvitation;
        /**
         * Not authorized to get scheduled invitation
         */
        401: unknown;
      };
    };
    patch: {
      req: {
        id: number;
        /**
         * Scheduled invite attributes
         */
        requestBody: {
          sendInviteAt: string;
        };
      };
      res: {
        /**
         * Scheduled invite has been successfully updated
         */
        200: unknown;
      };
    };
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Scheduled invite has been successfully cancelled.
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/enterprise/bulk_send_invites/{id}/user_bulk_send_invites": {
    get: {
      req: {
        /**
         * Bulk invite ID
         */
        id: number;
        /**
         * team ID
         */
        teamId?: number;
      };
      res: {
        /**
         * Team's Scheduled invitations CSV retrieved
         */
        200: string;
        /**
         * Not authorized to get Team's Scheduled invitations CSV
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams": {
    post: {
      req: {
        /**
         * Attributes for the new Profile
         */
        requestBody: TeamCreateAttributes;
      };
      res: {
        /**
         * Team created successfully
         */
        201: Team;
        /**
         * Not authorized to create team
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{id}": {
    get: {
      req: {
        filter?: string;
        /**
         * Team ID
         */
        id: number;
        include?: string;
        pageOffset?: number;
      };
      res: {
        /**
         * Team data
         */
        200: Team;
      };
    };
    delete: {
      req: {
        /**
         * Team ID
         */
        id: number;
      };
      res: {
        /**
         * Team deleted
         */
        200: unknown;
        /**
         * Not authorized to delete team
         */
        401: unknown;
        /**
         * Team not found
         */
        404: unknown;
      };
    };
    patch: {
      req: {
        /**
         * Team ID
         */
        id: number;
        /**
         * Team's new name
         */
        requestBody: {
          name?: string;
        };
      };
      res: {
        /**
         * Team name updated
         */
        200: unknown;
        /**
         * Not authorized to update user
         */
        401: unknown;
        /**
         * Team not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/email": {
    post: {
      req: {
        /**
         * Email and role
         */
        requestBody: {
          /**
           * New admin's email
           */
          email?: string;
          /**
           * New admin's role
           */
          role?: string;
        };
        /**
         * Team ID
         */
        teamId: number;
      };
      res: {
        /**
         * New admin added
         */
        200: unknown;
        /**
         * Unauthorized admin or requires a logged in user
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/remind/{user_id}": {
    post: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * Reminder sent
         */
        200: unknown;
        /**
         * Not authorized to remind user
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}": {
    patch: {
      req: {
        /**
         * User's new name
         */
        requestBody: {
          user?: {
            firstName?: string;
            lastName?: string;
          };
        };
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User updated
         */
        200: unknown;
        /**
         * Not authorized to update user
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User added to team
         */
        200: unknown;
        /**
         * Not authorized to add user to team
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * Admin Role
         */
        role?: string;
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User removed from team
         */
        200: unknown;
        /**
         * Not authorized to remove user from team
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}/role/{role}": {
    post: {
      req: {
        /**
         * admin role
         */
        role: string;
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User added to team
         */
        200: unknown;
        /**
         * Not authorized to add user to team
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}/admin_role/{admin_role}": {
    post: {
      req: {
        /**
         * admin role
         */
        adminRole: string;
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User updated
         */
        200: unknown;
        /**
         * Not authorized to update user
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/scheduled_invitations": {
    get: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
      };
      res: {
        /**
         * Scheduled invitations retrieved
         */
        200: TeamScheduledInvitations;
        /**
         * Not authorized to get scheduled invitations
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/organizations/{id}": {
    get: {
      req: {
        deep?: boolean;
        /**
         * Organization ID
         */
        id: number;
      };
      res: {
        /**
         * Organization data
         */
        200: Organization;
      };
    };
  };
  "/jsonapi/v1/enterprise/organizations/{id}/logo": {
    delete: {
      req: {
        /**
         * Organization ID
         */
        id: number;
      };
      res: {
        /**
         * Logo has been removed
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/enterprise/team_notifications": {
    post: {
      req: {
        /**
         * Attributes for the custom message
         */
        requestBody: TeamNotification;
      };
      res: {
        /**
         * Custom message saved successfully
         */
        201: TeamNotification;
        /**
         * Not authorized to add custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/team_notifications/{id}": {
    get: {
      req: {
        /**
         * Team notification ID
         */
        id: number;
      };
      res: {
        /**
         * Custom message retrieved
         */
        200: TeamNotification;
        /**
         * Not authorized to get organization custom message
         */
        401: unknown;
      };
    };
    delete: {
      req: {
        /**
         * Team notification ID
         */
        id: number;
      };
      res: {
        /**
         * Organization Custom Message has been deleted
         */
        204: void;
        /**
         * Not authorized to delete organization custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/team_notifications/{id}/dismiss": {
    post: {
      req: {
        /**
         * Team notification ID
         */
        id: number;
      };
      res: {
        /**
         * Organization Custom Message has been dismissed for the current user
         */
        200: unknown;
        /**
         * Not authorized to dismiss the organization custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/my_notifications/unread": {
    get: {
      res: {
        /**
         * Custom message retrieved
         */
        200: Array<MemberNotification>;
        /**
         * Not authorized to get organization member custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/episodes": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for Episodes
         */
        filter?: {
          pilot?: boolean;
        };
      };
      res: {
        /**
         * List of all Episodes filtered by options
         */
        200: Episodes;
      };
    };
  };
  "/jsonapi/v1/episodes/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Episode slug
         */
        slug: string;
      };
      res: {
        /**
         * Episode response
         */
        200: Episode;
      };
    };
  };
  "/jsonapi/v1/experiments/sessionless": {
    get: {
      res: {
        /**
         * Array of experiments
         */
        200: Experiments;
      };
    };
  };
  "/jsonapi/v1/feature-interactions": {
    get: {
      req: {
        /**
         * Filters for current user's Feature Interactions
         */
        filter?: {
          id?: number;
        };
      };
      res: {
        /**
         * List of feature interactions
         */
        200: FeatureInteractionsResult;
      };
    };
    post: {
      req: {
        /**
         * Updated feature interaction info
         */
        requestBody: FeatureInteractionAttributes;
      };
      res: {
        /**
         * Successful create/update of Feature Interaction
         */
        200: FeatureInteraction;
      };
    };
  };
  "/jsonapi/v1/guest-passes/{referralToken}": {
    get: {
      req: {
        /**
         * Referral token
         */
        referralToken: string;
      };
      res: {
        /**
         * free trial data
         */
        200: FreeTrial;
      };
    };
  };
  "/jsonapi/v1/guest-pass-email-share": {
    post: {
      req: {
        /**
         * Emails where the guest pass will be shared
         */
        requestBody: GuestPassShareAttributes;
      };
      res: {
        /**
         * Fire events for emails
         */
        200: unknown;
      };
    };
  };
  "/jsonapi/v1/immersive-heros": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * specify a one of slug, courseSlug, or chapterSlug to filter
         */
        filter?: {
          /**
           * specify a gem slug to filter
           */
          slug?: string;
          /**
           * specify a course slug to filter
           */
          courseSlug?: string;
          /**
           * specify a chapter slug to filter
           */
          chapterSlug?: string;
        };
      };
      res: {
        /**
         * Immersive Heroes response
         */
        200: ImmersiveHeros;
      };
    };
  };
  "/jsonapi/v1/instructors": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          /**
           * specify a playlist
           */
          playlist?: string;
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * List of instructors
         */
        200: Array<Instructor>;
        /**
         * User is not signed in
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/notes": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for Notes
         */
        filter?: {
          courseSlug?: string;
        };
      };
      res: {
        /**
         * List of notes
         */
        200: Notes;
      };
    };
    post: {
      req: {
        /**
         * Note attributes
         */
        requestBody: CreateNoteAttributes;
      };
      res: {
        /**
         * Created note
         */
        200: Note;
      };
    };
  };
  "/jsonapi/v1/notes/{id}": {
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Note is deleted
         */
        204: void;
      };
    };
    patch: {
      req: {
        id: number;
        /**
         * Note attributes
         */
        requestBody: {
          content: string;
        };
      };
      res: {
        /**
         * Updated note
         */
        200: Note;
      };
    };
  };
  "/jsonapi/v1/playlists/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        slug: string;
        track?: string;
      };
      res: {
        /**
         * Playlist response
         */
        200: Playlist;
      };
    };
  };
  "/jsonapi/v1/playlists": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * Playlists response
         */
        200: Playlists;
      };
    };
  };
  "/jsonapi/v1/products": {
    get: {
      req: {
        /**
         * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
         */
        discountSlug?: string;
        /**
         * include additional dependencies
         */
        filterPurchasePlanSlugs?: string;
        /**
         * gift query param, determines whether we are sending a gift or not
         */
        gift?: boolean;
      };
      res: {
        /**
         * Products response
         */
        200: Products;
      };
    };
  };
  "/jsonapi/v1/profiles": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * List of all Profiles associated to the current User
         */
        200: Profiles;
      };
    };
    post: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Attributes for the new Profile
         */
        requestBody: ProfileCreateAttributes;
      };
      res: {
        /**
         * Newly created Profile
         */
        200: Profile;
      };
    };
  };
  "/jsonapi/v1/profiles/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Profile ID
         */
        id: number;
      };
      res: {
        /**
         * The profile uniquely identified by the given id
         */
        200: Profile;
      };
    };
    patch: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
        /**
         * Profile attributes to be changed
         */
        requestBody: ProfileUpdateAttributes;
      };
      res: {
        /**
         * The updated Profile
         */
        200: Profile;
      };
    };
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Profile is deleted
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/onboarding-content-recommendation": {
    get: {
      res: {
        /**
         * Onboarding content recommendation response
         */
        200: OnboardingContentRecommendation;
      };
    };
  };
  "/jsonapi/v1/purchase_plans/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Either id number or specific plan slug
         */
        id: string | number;
      };
      res: {
        /**
         * Purchase plan data
         */
        200: PurchasePlan;
      };
    };
  };
  "/jsonapi/v1/referral-audio-programs": {
    get: {
      res: {
        /**
         * List of showcase items
         */
        200: ReferralAudioProgramsResult;
      };
    };
  };
  "/jsonapi/v1/referral-tokens": {
    post: {
      req: {
        /**
         * Attributes to create an invitation link. These attributes will be used to create utm params and handle link redirection
         */
        requestBody: ReferralTokenAttributes;
      };
      res: {
        /**
         * Created invitation links
         */
        200: ShareLinks;
      };
    };
  };
  "/jsonapi/v1/showcases": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * List of showcase items
         */
        200: ShowcasesResult;
      };
    };
  };
  "/jsonapi/v1/skills": {
    get: {
      res: {
        /**
         * List of skills
         */
        200: SkillsResult;
      };
    };
  };
  "/jsonapi/v1/subscriptions/last": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * The subscription item
         */
        200: Subscription;
      };
    };
  };
  "/jsonapi/v1/themes": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for ids
         */
        filter?: {
          /**
           * CSV of ids to filter
           */
          id?: string;
        };
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * Themes response
         */
        200: ThemesResults;
      };
    };
  };
  "/jsonapi/v1/tier_collections/current": {
    get: {
      req: {
        /**
         * temporal param to support the prcng-107V1 experiment and return the correct tier collection
         */
        collapsedBucket?: string;
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
         */
        discountSlug?: string;
        /**
         * gift query param, determines whether we are sending a gift or not
         */
        gift?: boolean;
      };
      res: {
        /**
         * Tiers response
         */
        200: TierCollection;
      };
    };
  };
  "/jsonapi/v1/tier_collections/persona-bundle": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
         */
        discountSlug?: string;
        /**
         * gift query param, determines whether we are sending a gift or not
         */
        gift?: boolean;
      };
      res: {
        /**
         * Tiers response
         */
        200: TierCollection;
      };
    };
  };
  "/jsonapi/v1/user/cart-data": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * User cart data
         */
        200: CartData;
      };
    };
  };
  "/jsonapi/v1/user/guest-passes": {
    get: {
      res: {
        /**
         * User guest passes data
         */
        200: GuestPass;
      };
    };
  };
  "/jsonapi/v1/user/products/last": {
    get: {
      res: {
        /**
         * Product response
         */
        200: Product;
        /**
         * User is not signed in
         */
        401: unknown;
        /**
         * User has no subscription with a product
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/user/streams": {
    post: {
      req: {
        /**
         * Information about a new streaming session
         */
        requestBody: StreamAttributes;
      };
      res: {
        /**
         * Streaming session information is received
         */
        200: StreamsResult;
      };
    };
    delete: {
      req: {
        /**
         * Streaming session id
         */
        requestBody: StreamAttributes;
      };
      res: {
        /**
         * Streaming session is destroyed
         */
        200: StreamsResult;
      };
    };
  };
  "/jsonapi/v1/user-camps": {
    get: {
      res: {
        /**
         * User sessions response
         */
        200: UserSessionsResult;
      };
    };
  };
  "/jsonapi/v1/user-courses": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * User courses response
         */
        200: UserCoursesResult;
      };
    };
    post: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Course to associate to User
         */
        requestBody: CreateUserCourseAttributes;
      };
      res: {
        /**
         * Created User Course
         */
        200: UserCourse;
      };
    };
  };
  "/jsonapi/v1/user-courses/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters courses by tag
         */
        filter?: {
          tag?: string;
        };
        /**
         * Course slug
         */
        slug: string;
      };
      res: {
        /**
         * User course response
         */
        200: UserCourse;
      };
    };
  };
  "/jsonapi/v1/user-progress": {
    get: {
      req: {
        /**
         * Filters for current user's watch list items
         */
        filter?: {
          contentType?: string;
        };
      };
      res: {
        /**
         * User progress response
         */
        200: UserProgressResults;
      };
    };
  };
  "/jsonapi/v1/user-playlists": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for completed playlists
         */
        filter?: {
          completed?: boolean;
        };
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * User playlists response
         */
        200: UserPlaylistResults;
      };
    };
  };
  "/jsonapi/v1/users/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * User id
         */
        id: string | number;
      };
      res: {
        /**
         * User data
         */
        200: User;
      };
    };
    patch: {
      req: {
        /**
         * User id
         */
        id: string | number;
        /**
         * Updated user info
         */
        requestBody: UserAttributesForUpdate;
      };
      res: {
        /**
         * Successful update of user
         */
        200: User;
      };
    };
  };
  "/jsonapi/v1/video-progress-entries": {
    get: {
      req: {
        /**
         * Filters for current user's Video Progress Entries
         */
        filter?: {
          byVideoType?: string;
        };
      };
      res: {
        /**
         * Video Progress Entries for current user
         */
        200: VideoProgressEntriesResult;
      };
    };
    post: {
      req: {
        /**
         * New video progress entry info
         */
        requestBody: VideoProgressEntryAttributesForCreate;
      };
      res: {
        /**
         * Successful create of Video Progress Entry
         */
        200: VideoProgressEntry;
      };
    };
  };
  "/jsonapi/v1/video-progress-entries/{id}": {
    patch: {
      req: {
        /**
         * Video Progress Entry id
         */
        id: number;
        /**
         * Updated video progress entry info
         */
        requestBody: VideoProgressEntryAttributesForUpdate;
      };
      res: {
        /**
         * Successful update of Video Progress Entry
         */
        200: VideoProgressEntry;
      };
    };
  };
  "/jsonapi/v1/watch-list-items": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * Watch list items response
         */
        200: WatchListResults;
      };
    };
    post: {
      req: {
        /**
         * Information about the watch list item
         */
        requestBody: WatchListItemAttributes;
      };
      res: {
        /**
         * Successful create of Watch List Item
         */
        200: WatchListItem;
      };
    };
  };
  "/jsonapi/v1/watch-list-items/{id}": {
    delete: {
      req: {
        /**
         * Id of the current item
         */
        id: number;
      };
      res: {
        /**
         * The item is removed
         */
        200: unknown;
      };
    };
  };
  "/jsonapi/v1/products/landing-prices": {
    get: {
      req: {
        /**
         * user geo to calculate price
         */
        mcGeo: string;
      };
      res: {
        /**
         * Prices response
         */
        200: LandingPrices;
      };
    };
  };
  "/jsonapi/v1/products/persona-bundle": {
    get: {
      res: {
        /**
         * Persona bundle pricing information response
         */
        200: PersonaBundle;
      };
    };
  };
  "/jsonapi/v2/search-config": {
    get: {
      req: {
        mode?: "library" | "search" | "customplaylists";
        platform?: "web";
        userExperience?: "consumer" | "enterprise";
      };
      res: {
        /**
         * Algolia search configuration
         */
        200: SearchConfig;
      };
    };
  };
  "/api/v1/accounts/check_email": {
    get: {
      req: {
        /**
         * email to verify
         */
        email: string;
      };
      res: {
        /**
         * Email is registered (User already exists)
         */
        200: EmailAccount;
        /**
         * Email is not registered (User does not exists)
         */
        404: unknown;
      };
    };
  };
  "/api/v1/accounts/complete_registration": {
    put: {
      req: {
        /**
         * User attributes
         */
        requestBody: UserRegistration;
      };
      res: {
        /**
         * User name and password are set correctly
         */
        200: unknown;
      };
    };
  };
  "/api/v1/credit_cards": {
    post: {
      req: {
        /**
         * Credit card params
         */
        requestBody: CreateCreditCardAttributes;
      };
      res: {
        /**
         * Credit card created
         */
        200: CreditCard;
      };
    };
    get: {
      res: {
        /**
         * Credit cards index
         */
        200: CreditCards;
      };
    };
  };
  "/api/v1/credit_cards/{id}": {
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Credit card is deleted
         */
        204: void;
      };
    };
  };
  "/api/v1/credit_cards/credit_cards_with_currency": {
    get: {
      req: {
        /**
         * Filter credit card by payment method cards or token cards
         */
        tokenOnly?: boolean;
      };
      res: {
        /**
         * Credit cards with user ip currency index
         */
        200: CreditCards;
      };
    };
  };
  "/api/v1/credit_cards/default_credit_card": {
    get: {
      res: {
        /**
         * Default credit card
         */
        200: CreditCard;
      };
    };
  };
  "/api/v1/credit_cards/confirm": {
    get: {
      req: {
        setupIntentId: string;
      };
      res: {
        /**
         * Returns either a status object or credit card details. A status object is returned while the setup intent is pending confirmation. Once confirmed, the complete credit card details are returned.
         */
        200: SetupIntentStatus | CreditCard;
      };
    };
  };
  "/api/v1/coupons/verify": {
    get: {
      req: {
        /**
         * Slug of the coupon to be verified
         */
        code: string;
        /**
         * ID of the product the coupon is being applied to
         */
        productId: number;
      };
      res: {
        /**
         * Coupon details
         */
        200: DiscountCoupon;
      };
    };
  };
  "/api/v2/orders": {
    post: {
      req: {
        /**
         * Order params
         */
        requestBody: CreateOrderAttributes;
        /**
         * COM-839
         */
        xTsBucket: string;
      };
      res: {
        /**
         * Purchase completed
         */
        200: Order;
      };
    };
  };
  "/api/v2/orders/{id}/confirm": {
    get: {
      req: {
        id: number;
      };
      res: {
        /**
         * Order status retrieved
         */
        200: OrderConfirmation;
      };
    };
  };
  "/api/v2/cart": {
    put: {
      req: {
        /**
         * Send the productId and discount we would like to add
         */
        requestBody: UpdateProductAttributes;
      };
      res: {
        /**
         * Cart product updated successfully
         */
        200: unknown;
      };
    };
  };
  "/api/v2/cart/add_product": {
    post: {
      req: {
        /**
         * Cart attributes
         */
        requestBody: AddProductAttributes;
      };
      res: {
        /**
         * Product added successfully
         */
        200: {
          product: CartProduct;
        };
      };
    };
  };
  "/api/v2/cart/clear_cart": {
    post: {
      res: {
        /**
         * Cart cleared successfully
         */
        200: {
          /**
           * Status of the cart clear operation
           */
          status: boolean;
          /**
           * Message indicating the success of the operation
           */
          message: string;
        };
      };
    };
  };
  "/api/v2/cart/remove_product": {
    post: {
      req: {
        /**
         * Product attributes
         */
        requestBody: RemoveProductAttributes;
      };
      res: {
        /**
         * Product removed successfully
         */
        200: {
          product: CartProduct;
        };
      };
    };
  };
  "/api/v2/cart/show_products": {
    get: {
      req: {
        /**
         * if user is gifting, we send gift = true
         */
        gift?: boolean;
      };
      res: {
        /**
         * List of all products added
         */
        200: CartProducts;
      };
    };
  };
  "/bogo_gifts/{bogo_gift_token}/redeem": {
    post: {
      req: {
        /**
         * gift token
         */
        bogoGiftToken: string;
        /**
         * Gift attributes
         */
        requestBody: {
          gift: RedeemBogoGift;
        };
      };
      res: {
        /**
         * Gift sent correctly
         */
        200: {
          gifteeName?: string;
        };
      };
    };
  };
  "/api/v2/users/gift_add_on": {
    get: {
      res: {
        /**
         * Discount details for purchase a gift add on subscription
         */
        200: GiftAddOn;
        /**
         * No user logged in to the system
         */
        401: unknown;
      };
    };
  };
  "/api/v2/add_ons": {
    get: {
      res: {
        /**
         * Details required for the add ons storefront page
         */
        200: {
          persona?: PersonaAddOn;
          learningToolkit?: LearningToolkitAddOn;
          gift?: GiftAddOn;
          certificatePrograms?: Array<CertificateProgramAddOn>;
        };
      };
    };
  };
  "/api/v2/add_ons/learning_toolkit": {
    get: {
      res: {
        /**
         * Details needed for purchase of a learning toolkit subscription
         */
        200: LearningToolkitAddOn;
      };
    };
  };
  "/api/v2/add_ons/persona": {
    get: {
      res: {
        /**
         * Details needed for purchase of a persona add-on subscription
         */
        200: PersonaAddOn;
      };
    };
  };
  "/api/v2/add_ons/{id}/preview_proration": {
    get: {
      req: {
        /**
         * ID of the product to preview proration for
         */
        id: number;
      };
      res: {
        /**
         * Proration preview information for the specified product
         */
        200: ProrationPreview;
        /**
         * Product not found
         */
        404: {
          error?: string;
        };
      };
    };
  };
  "/api/v2/add_on_subscriptions/{id}/cancel": {
    put: {
      req: {
        id: number;
      };
      res: {
        /**
         * Add on Subscription will not be renewed
         */
        200: unknown;
      };
    };
  };
  "/api/v2/subscriptions/{id}/reactivate": {
    put: {
      req: {
        id: number;
      };
      res: {
        /**
         * Subscription reactivated
         */
        200: unknown;
      };
    };
  };
  "/api/v2/subscriptions/{id}/preview": {
    get: {
      req: {
        /**
         * The product id of the plan to preview
         */
        changeProductId: number;
        id: number;
      };
      res: {
        /**
         * Preview response
         */
        200: {
          /**
           * The prorated amount for the plan change
           */
          proratedAmount?: string;
          /**
           * The currency code
           */
          currency?: string;
          /**
           * The type of change (upgrade or downgrade)
           */
          changeType?: "upgrade" | "downgrade";
        };
      };
    };
  };
  "/api/v2/subscriptions/{id}": {
    put: {
      req: {
        /**
         * Subscription ID
         */
        id: number;
        /**
         * Subscription attributes
         */
        requestBody: {
          /**
           * The type of change
           */
          changeType: string;
          /**
           * The product id of the plan to update
           */
          changeProductId: number;
        };
      };
      res: {
        /**
         * Subscription updated
         */
        200: {
          /**
           * A message indicating the subscription was updated
           */
          message?: string;
        };
      };
    };
  };
  "/api/v2/subscriptions/pricing-upgrade": {
    put: {
      res: {
        /**
         * Subscription upgraded
         */
        200: unknown;
      };
    };
  };
  "/api/v3/watch-bundles/{watch_bundle_uuid}": {
    get: {
      req: {
        watchBundleUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundle;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundles/{watch_bundle_uuid}/extras": {
    get: {
      req: {
        watchBundleUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleExtras;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundles/{watch_bundle_uuid}/interactions": {
    get: {
      req: {
        watchBundleUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/bookmarks/{uuid}": {
    patch: {
      req: {
        /**
         * The unique identifier of a resource to bookmark.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: V3Bookmark;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a resource to bookmark.
         */
        uuid: string;
      };
      res: {
        /**
         * No Content. The bookmark was removed from the resource.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/notes/{content_uuid}": {
    patch: {
      req: {
        contentUuid: string;
        requestBody: {
          entry: string;
        };
      };
      res: {
        /**
         * OK
         */
        200: V3Note;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * No Content. The note was destroyed.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundles-contents/{content_uuid}/interactions": {
    get: {
      req: {
        /**
         * Content uuid
         */
        contentUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleContentInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/playback/{content_uuid}": {
    patch: {
      req: {
        contentUuid: string;
        requestBody: {
          cursor: number;
        };
      };
      res: {
        /**
         * OK
         */
        200: Playhead;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/playback/token": {
    get: {
      res: {
        /**
         * OK
         */
        200: PlaybackTokenResponse;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/surveys/{content_uuid}": {
    patch: {
      req: {
        contentUuid: string;
        requestBody: UpdateSurvey;
      };
      res: {
        /**
         * Survey feedback was accepted. The watch bundle interactions will be updated to indicate
         * the survey should not be taken again.
         *
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/sharing/{uuid}": {
    get: {
      req: {
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Sharing;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/session-activities/{uuid}/interactions": {
    get: {
      req: {
        /**
         * Activity uuid
         */
        uuid: string;
      };
      res: {
        /**
         * Session activity response
         */
        200: SessionActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignees": {
    get: {
      res: {
        /**
         * OK
         */
        200: Assignees;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/progress/{uuid}": {
    get: {
      req: {
        filters?: {
          [key: string]: unknown;
        };
        /**
         * Filters progress based on who shared
         */
        sharedBy?: "all" | "me";
        /**
         * The team identifier in which the progress content was assigned.
         */
        teamId: string;
        /**
         * The unique identifier of an assignable content.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: ContentProgress;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignments": {
    get: {
      res: {
        /**
         * OK
         */
        200: AssignedContents;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
    post: {
      req: {
        requestBody: CreateAssignments;
        xRequestId?: string;
      };
      res: {
        /**
         * OK
         */
        201: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignments/{content_uuid}": {
    delete: {
      req: {
        contentUuid: string;
        requestBody: UserIdentifier;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignable-content": {
    get: {
      res: {
        /**
         * OK
         */
        200: AssignableContentResult;
      };
    };
  };
  "/api/v3/enterprise/admin/navigation": {
    get: {
      res: {
        /**
         * OK
         */
        200: NavigationContents;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/admin/organizations/{id}": {
    get: {
      req: {
        id: string;
      };
      res: {
        /**
         * OK
         */
        200: V3Organization;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/admin/template-bulk-import": {
    get: {
      res: {
        /**
         * OK
         */
        200: string;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/skills": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<EnterprisePlaylistSkill>;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists": {
    get: {
      req: {
        /**
         * The unique identifier of an organization.
         */
        organizationId: number;
      };
      res: {
        /**
         * OK
         */
        200: V3Playlists;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        requestBody: CreatePlaylist;
      };
      res: {
        /**
         * Created
         */
        201: CreatedPlaylist;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * This playlist title already exists. Try a different one.
         *
         */
        409: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: V3Playlist;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    patch: {
      req: {
        formData: UpdatePlaylist;
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}/publish": {
    patch: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}/unpublish": {
    patch: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}/duplicate": {
    post: {
      req: {
        requestBody: CreatePlaylist;
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * Created
         */
        201: CreatedPlaylist;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{playlist_uuid}/lessons": {
    get: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Array<EnterprisePlaylistLesson>;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        playlistUuid: string;
        requestBody: EnterprisePlaylistAddLessons;
      };
      res: {
        /**
         * Created
         */
        201: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/reorder": {
    patch: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
        requestBody: ReorderLessons;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/{lesson_uuid}": {
    patch: {
      req: {
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
        requestBody: UpdateLesson;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}": {
    get: {
      req: {
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
      };
      res: {
        /**
         * OK
         */
        200: Program;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}/enroll": {
    put: {
      req: {
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
      };
      res: {
        /**
         * Enrolled
         */
        201: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}/download-resources": {
    get: {
      req: {
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
        /**
         * Files to be compressed that belong to the same section.
         */
        stage?: "before" | "along" | "after";
      };
      res: {
        /**
         * A ZIP file
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}/modules/{module_slug}/download-resources": {
    get: {
      req: {
        /**
         * The unique identifier of a module.
         */
        moduleSlug: string;
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
      };
      res: {
        /**
         * A ZIP file
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/quote": {
    post: {
      req: {
        requestBody: EnterpriseQuoteRequest;
      };
      res: {
        /**
         * Generated
         */
        201: EnterpriseQuote;
        /**
         * The input to the quote service is invalid
         *
         */
        400: unknown;
      };
    };
  };
  "/api/v3/enterprise/addon-quote": {
    post: {
      req: {
        requestBody: EnterpriseAddonQuoteRequest;
      };
      res: {
        /**
         * Generated
         */
        201: EnterpriseQuote;
        /**
         * The input to the quote service is invalid
         *
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/process-addon-order": {
    post: {
      req: {
        requestBody: EnterpriseProcessAddonOrderRequest;
      };
      res: {
        /**
         * Processed
         */
        201: EnterpriseAddonOrder;
        /**
         * The input to the order service is invalid
         *
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/process-order": {
    post: {
      req: {
        requestBody: EnterpriseProcessOrderRequest;
      };
      res: {
        /**
         * Order Processed
         */
        201: EnterpriseOrder;
        /**
         * The input to the order service is invalid
         *
         */
        400: unknown;
      };
    };
  };
  "/api/v3/enterprise/invoice/{invoice_id}": {
    get: {
      req: {
        /**
         * The unique identifier of the invoice.
         */
        invoiceId: string;
      };
      res: {
        /**
         * Invoice ready
         */
        200: EnterpriseInvoice;
        /**
         * The invoice does not exist
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/licenses": {
    get: {
      res: {
        /**
         * OK
         */
        200: EnterpriseLicenses;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/licenses/revoke-consent": {
    post: {
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/analytics/metrics/{slug}": {
    get: {
      req: {
        filters?: {
          [key: string]: unknown;
        };
        slug: string;
        teamId: string;
      };
      res: {
        /**
         * OK
         */
        200: EnterpriseAnalyticsMetric;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/analytics/generate-csv-report-jobs": {
    post: {
      req: {
        /**
         * generate-csv-report-job request body
         */
        requestBody: EnterpriseAnalyticsGenerateCsvReportJobRequest;
      };
      res: {
        /**
         * OK
         */
        202: EnterpriseAnalyticsGenerateCsvReportJobResponse;
        /**
         * The request format is not valid.
         *
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The request is not authorized
         *
         */
        403: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/analytics/generate-csv-report-jobs/{uuid}": {
    get: {
      req: {
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: EnterpriseAnalyticsGenerateCsvReportJobResponse;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The request is not authorized
         *
         */
        403: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v3/content-rows": {
    get: {
      req: {
        /**
         * Used to filter out tiles with a different entityType
         */
        entityType?: Array<V3ContentRowEntityType>;
        filter: {
          bundle: string;
          /**
           * comma-separated list of ids to filter
           */
          id?: string;
          platform:
            | "iphone"
            | "ipad"
            | "android_phone"
            | "android_tv"
            | "fire_tv"
            | "apple tv"
            | "roku"
            | "web";
          /**
           * Used to override row reference
           */
          referenceUuid?: string;
        };
        includeItems?: boolean;
        resourceUuid?: string;
      };
      res: {
        /**
         * List of content rows
         */
        200: V3ContentRows;
      };
    };
  };
  "/api/v3/unique-identifiers/{resource_type_plural}/{slug}": {
    get: {
      req: {
        /**
         * Type of the resource in plural.
         */
        resourceTypePlural:
          | "stories"
          | "collections"
          | "collection-parts"
          | "collection-part-cards"
          | "courses"
          | "chapters"
          | "certificate_programs"
          | "curriculum_lessons";
        /**
         * Slug of the resource.
         */
        slug: string;
      };
      res: {
        /**
         * OK
         */
        200: UniqueIdentifiersResponse;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/my-list": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<MyListItem>;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/my-list/{content_uuid}": {
    post: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * OK
         */
        201: unknown;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * No Content. The content was removed from My List.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/homepage-layout": {
    get: {
      res: {
        /**
         * Get list of navigation tabs
         */
        200: HomepageLayout;
      };
    };
  };
  "/api/v3/semantic-search": {
    get: {
      req: {
        /**
         * The question asked by the user
         */
        q: string;
      };
      res: {
        /**
         * OK
         */
        200: SemanticSearchResponse;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/app-data": {
    get: {
      res: {
        /**
         * OK
         */
        200: AppData;
      };
    };
  };
  "/api/v3/learning-preferences": {
    patch: {
      req: {
        requestBody: LearningPreferences;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/learning-preferences/career-goal": {
    get: {
      res: {
        /**
         * OK
         */
        200: CareerGoalPage;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/learning-preferences/skills": {
    get: {
      req: {
        /**
         * The career goal selected
         */
        careerGoal: string;
      };
      res: {
        /**
         * OK
         */
        200: SkillsPage;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/learning-preferences/subskills": {
    get: {
      req: {
        /**
         * The skills selected
         */
        skills: string;
      };
      res: {
        /**
         * OK
         */
        200: SubskillsPage;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/tab-content": {
    get: {
      req: {
        navigation?: string;
        tab?: string;
        xPlatform?: string;
      };
      res: {
        /**
         * Get content that will be presented on UI tab
         */
        200: TabContent;
      };
    };
  };
  "/api/v3/collection-rows": {
    get: {
      res: {
        /**
         * OK
         */
        200: CollectionRows;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/collections/{collection_uuid}": {
    get: {
      req: {
        collectionUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Collection;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/card-progress/{card_uuid}": {
    patch: {
      req: {
        cardUuid: string;
      };
      res: {
        /**
         * Card was marked as viewed successfully
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/collections/{collection_uuid}/interactions": {
    get: {
      req: {
        collectionUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CollectionInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/onboarding": {
    post: {
      res: {
        /**
         * New onboarding
         */
        200: Onboarding;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/onboarding/{id}/complete": {
    post: {
      req: {
        /**
         * Onboarding Id
         */
        id: number;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/session-preferences/{uuid}": {
    patch: {
      req: {
        requestBody: UpdateSessionPreferences;
        /**
         * Session uuid
         */
        uuid: string;
      };
      res: {
        /**
         * No Content
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/iterable-token": {
    get: {
      res: {
        /**
         * Get a valid JWT
         */
        200: IterableToken;
      };
    };
  };
  "/api/v3/partnerships/revolut/eligible/{uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a resource to redeem.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: RevolutEligibleGift;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/partnerships/revolut/activate/{uuid}": {
    put: {
      req: {
        /**
         * The unique identifier of a resource to redeem.
         */
        uuid: string;
      };
      res: {
        /**
         * Activation successfully
         *
         */
        200: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The activation fails due to un-eligible status.
         *
         */
        409: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/catalog": {
    get: {
      res: {
        /**
         * OK
         */
        200: CertificateProgramCatalog;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/hub/tiles": {
    get: {
      res: {
        /**
         * OK
         */
        200: CertificateHubTiles;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/interactions": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgram;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Curriculum;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum/interactions": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumLesson;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/interactions": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumLessonInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumLessonInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/download": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/capstone-summary/download": {
    get: {
      req: {
        /**
         * The unique identifier of the capstone summary activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/quiz/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: CurriculumQuizActivityInteractions;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumQuizActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/discussion/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: CurriculumDiscussionActivityInteractions;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumDiscussionActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * There was a conflict. This can occur if an evaluation of the submission is in progress.
         *
         */
        409: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{uuid}/read": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of the activity.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/product": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * Optional discount code to apply to the price
         */
        discountSlug?: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProduct;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/products": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        discountSlugs?: {
          [key: string]: string;
        };
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProducts;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/products/{product_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * Optional discount code to apply to the price
         */
        discountSlug?: string;
        /**
         * The unique identifier of a product
         */
        productUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProduct;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/reward": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: UserCertificateProgramReward;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * Accepted
         */
        202: UserCertificateProgramReward;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/add-ons": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/coupons/{coupon_code}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The code of the coupon
         */
        couponCode: string;
        /**
         * The unique identifier of the product
         */
        productUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramCoupon;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/enrollments": {
    get: {
      req: {
        /**
         * Filter by active enrollments. If multiple status parameters are provided,
         * the results will be concatenated together.
         *
         */
        active?: boolean;
        /**
         * Filter by inactive enrollments. If multiple status parameters are provided,
         * the results will be concatenated together.
         *
         */
        inactive?: boolean;
        /**
         * Filter by pending enrollments. If multiple status parameters are provided,
         * the results will be concatenated together.
         *
         */
        pending?: boolean;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramEnrollments;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramEnrollment;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: {
          /**
           * Only available for non production environments. If true, the user will be enrolled in all the courses of the certificate program.
           * This is only available for non-production environments.
           *
           */
          autoCheckout?: boolean;
        };
      };
      res: {
        /**
         * OK
         */
        200: {
          /**
           * The date and time when the certificate program was provisioned.
           */
          enrolledAt?: string;
        };
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * No Content
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/accelerator/user": {
    post: {
      req: {
        requestBody?: AcceleratorUser;
      };
      res: {
        /**
         * OK
         */
        200: AcceleratorUser;
        /**
         * The request body was invalid.
         */
        400: unknown;
      };
    };
  };
  "/api/v3/growth/categories": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthCategory>;
      };
    };
  };
  "/api/v3/growth/content": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthContent>;
      };
    };
  };
  "/api/v3/growth/quiz-results/recommended-lessons": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthSubcategoryWithLessons>;
      };
    };
  };
  "/api/v3/growth/quiz/category-media": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthCategoryWithMedia>;
      };
    };
  };
  "/api/v3/growth/outcomes": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<Outcome>;
      };
    };
  };
  "/api/v3/growth/content-outcomes": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<ContentOutcome>;
      };
    };
  };
  "/api/v3/growth/email-capture": {
    post: {
      req: {
        requestBody: EmailCaptureRequest;
      };
      res: {
        /**
         * Email captured successfully
         */
        200: EmailCaptureResponse;
        /**
         * Bad request - email is required
         */
        400: ErrorResponse;
      };
    };
  };
  "/api/v3/decagon/user-token": {
    get: {
      res: {
        /**
         * Get a valid JWT
         */
        200: DecagonUserToken;
      };
    };
  };
  "/api/v3/commerce/products/{product_name}": {
    get: {
      req: {
        /**
         * The name of the product to retrieve
         */
        productName: string;
      };
      res: {
        /**
         * OK
         */
        200: CommerceProduct;
      };
    };
  };
  "/api/v3/commerce/purchase-plans/{slug}": {
    get: {
      req: {
        /**
         * The name of the purchase-plan to retrieve
         */
        slug: string;
      };
      res: {
        /**
         * OK
         */
        200: CommercePurchasePlan;
      };
    };
  };
  "/api/v3/commerce/bhn/redeem-giftcode": {
    post: {
      req: {
        /**
         * Giftcode for redemption
         */
        requestBody: {
          /**
           * Giftcard code number
           */
          giftcode: string;
        };
      };
      res: {
        /**
         * OK
         */
        200: SubscriptionDetails;
        /**
         * Giftcode Invalid
         */
        400: unknown;
        /**
         * Subscription invalid
         */
        409: unknown;
        /**
         * Service Unavailable
         */
        503: unknown;
      };
    };
  };
  "/api/v3/capabilities": {
    get: {
      res: {
        /**
         * OK
         */
        200: Capabilities;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
};
